import React, { useEffect, useRef, useState } from "react";
import {
    ArrowRightIcon,
    ComboFightIcon, FlightTopIcon,FlightSimpleIcon,
    PriceCheapestIcon,
    PriceFastestIcon,
    SearchIcon,
    SingleFightIcon,
    ChevronRightIcon,
    ChevronLeftIcon,
    SliderLeftIcon,
    SliderRightIcon,
    MarkUpIcon,
    EmailPopupIcon,
    InfoIcon
} from '../../helper/HwIcon';
import {useLocation} from "react-router-dom";
import {
    agentDefaultImage,
    airlineImageFn,
    captureBookedFlightPriceFn,
    convertMinutesFn, convertMinutesHeaderFn, decryptData, defaultAirlineCompanyListArr, encryptData, formatDateTime,
    formatDateMonthWise,
    formatDayWiseDateFn, formatePriceFn,
    formatPrice, generateRandomString, getCookie, getDateDifference, getMinutesDifference,
    getQueryParams,
    getUserToken,
    setCookie, setSessionStorage
} from "../../helper/commonFunction";
import { ApiCall } from "../../helper/axios";
import { debounce } from 'lodash';
import { FlightSearchLoader } from "./components/FlightSearchLoader";
import SearchFlight from "./SearchFlight";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setFlightMarkupAmount } from "../../redux/slice/userSlice";
import FlightsShowComponent from "./ListingFlightsComponent/FlightsShowComponent";
import FlightDetailsComponent from "./ListingFlightsComponent/FlightDetailsComponent";
import FareViewsComponent from "./ListingFlightsComponent/FareViewsComponent";
import FlightListingSidebar from "./ListingFlightsComponent/FlightListingSidebar";
import { ListFlightItemComponent } from "./ListingFlightsComponent/ListFlightItemComponent";
import FlightListItemSkeleton from "./components/FlightListItemSkeleton";
import FlightListLoadingSkeleton from "./components/FlightListLoadingSkeleton";
import { formatDate } from "../../helper/commonFunction";
import { toUrlSource } from "../../helper/vendorMask";
import CommonPopup from "../common-popup/CommonPopup";
import { Tooltip } from "react-tooltip";

const PER_PAGE = 10;
const ListFlightPage = () => {
    const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
    const dispatch = useDispatch();
    const {
        agentActiveCurrency,
        airlineCompanyList,
        showVendorLogo,
        seatShow,
        displayPrice,
        flightMarkupAmount,
        isShowMarkupOption,
        isShowFlightAlternateOption,
        userAgentData
    } = useSelector((state) => state.userData);
    const location = useLocation();
    let navigate = useNavigate();
    const changePageState = location.state;
    const queryParams = getQueryParams(location.search);
    const [searchQueryAirport, setSearchQueryAirport] = useState({});
    const [fastestFlight, setFastestFlight] = useState(false);
    const [originalFlightData, setOriginalFlightData] = useState([]);
    const [flightData, setFlightData] = useState([]);
    const [mainLoading, setMainLoading] = useState(true);
    const [firstonLoad, setFirstonLoad] = useState(true);
    const [loading, setLoading] = useState(true);
    const [cheapestDuration, setCheapestDuration] = useState('');
    const [fastestDuration, setFastestDuration] = useState('');
    const [airlineFilterData, setAirlineFilterData] = useState([]);
    const [currentTabAirport, setCurrentTabAirport] = useState('');
    const [headerAirportData, setHeaderAirportData] = useState([]);
    const [headerAirlineData, setHeaderAirlineData] = useState([]);
    const [page, setPage] = useState(1);
    const [headerAirportMenuShow, setHeaderAirportMenuShow] = useState(false);
    const [isHeaderAirportsLoading, setIsHeaderAirportsLoading] = useState(false);
    const [showLoadingAfterLoad, setShowLoadingAfterLoad] = useState(true);
    const [isExpiredSearch, setIsExpiredSearch] = useState(false);
    const [roundTripDomestic, setRoundTripDomestic] = useState({
        status: false,
        active: 0
    });
    const [selectedMultiflights, setSelectedMultiflights] = useState([]);
    const [multiFlightOptionsData, setMultiFlightOptionsData] = useState([]);
    const timeRemainingRef = useRef(1800);
    const hasRun = useRef(false);
    const rawFlightsRef = useRef([]);
    const nearbyToggleSkipFirst = useRef(true);
    const debounceTimer = useRef({ price: null, duration: null });
    const [hasRangeChanges, setRangeChange] = useState({
        priceChange: false,
        timeChange: false
    })
    const [airportFilterData, setAirportFilterData] = useState({});
    const userToken = getUserToken();
    const [filterHideShow, setFilterHideShow] = useState({
        departure: true,
        returnDeparture: true,
        multiCityDeparture: true,
        multiCityStops: true,
        stops: true,
        returnstops: true,
        price: false,
        airlines: false,
        durations: false,
        airport: false,
    })
    const [activeStops, setActiveStops] = useState([
        { title: `${queryParams?.fromAirport}-${queryParams?.toAirport}`, active: true, index: 1 },
        { title: `${queryParams?.toAirport}-${queryParams?.fromAirport}`, active: false, index: 2 }
    ]);
    const [totalAirportStops, setTotalAirportStops] = useState([
        { stop: 'Non Stop', checked: false, value: 0 },
        { stop: '1 Stop', checked: false, value: 1 },
        { stop: '2 Stop', checked: false, value: 2 },
        { stop: '3+ Stop', checked: false, value: 3 },
    ]);
    const [departureTimeFilter, setDepartureTimeFilter] = useState([
        { time: '00-06', checked: false, title: 'Before 6AM' },
        { time: '06-12', checked: false, title: '6AM - 12PM' },
        { time: '12-18', checked: false, title: '12PM - 6PM' },
        { time: '18-24', checked: false, title: 'After 6PM' },
    ]);
    const [returnDepartureTimeFilter, setreturnDepartureTimeFilter] = useState([
        { time: '00-06', checked: false, title: 'Before 6AM' },
        { time: '06-12', checked: false, title: '6AM - 12PM' },
        { time: '12-18', checked: false, title: '12PM - 6PM' },
        { time: '18-24', checked: false, title: 'After 6PM' },
    ]);
    const [multiCityDepartureTimeFilter, setMultiCityDepartureTimeFilter] = useState({})
    const [multiCityDurationValues, setMultiCityDurationValues] = useState({});
    const [airlineText, setAirlineText] = useState('');
    const [priceRange, setPriceRange] = useState({
        minMaxSetPrice: [0, 1],
        minMaxPrice: [0, 1],
    });
    const [durationValues, setDurationValues] = useState({
        minMaxSetValue: [0, 100],
        duration: [50]
    });
    const [returnDurationValues, setReturnDurationValues] = useState({
        minMaxSetValue: [0, 100],
        duration: [50]
    });
    const [selectedAirArabiaBundle, setSelectedAirArabiaBundle] = useState([]);
    const [datefilterData, setDateFilterData] = useState([])
    const [selectedDate, setSelectedDate] = useState(0)
    const [showMarkupPopup, setShowMarkupPopup] = useState(false);
    const [markupInputAmount, setMarkupInputAmount] = useState('');
    const [markupError, setMarkupError] = useState('');
    const totalMarkupAmount = Number(flightMarkupAmount) || 0;
    const [isActionMenuCentered, setIsActionMenuCentered] = useState(false);
    const [isFooterVisible, setIsFooterVisible] = useState(false);
    const [isMobileView, setIsMobileView] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 767 : false));
    const [isPrintSelectionMode, setIsPrintSelectionMode] = useState(false);
    const [selectedPrintIndexes, setSelectedPrintIndexes] = useState([]);
    const [isEmailSelectionMode, setIsEmailSelectionMode] = useState(false);
    const [selectedEmailIndexes, setSelectedEmailIndexes] = useState([]);
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [emailError, setEmailError] = useState('');
    const [emailMessageType, setEmailMessageType] = useState('error');
    const [emailSending, setEmailSending] = useState(false);
    const [isFlightBookModalOpen, setIsFlightBookModalOpen] = useState(false);
    const [activeActionTooltip, setActiveActionTooltip] = useState(null);
    const sliderRef = useRef();
    const actionMenuRef = useRef(null);

    const hideActionTooltips = () => {
        setActiveActionTooltip(null);
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };

    const showActionTooltip = (tooltipId, { fromFocus = false } = {}) => {
        if (fromFocus) {
            setActiveActionTooltip(tooltipId);
            return;
        }
        if (typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            setActiveActionTooltip(tooltipId);
        }
    };
    const [isLoadingDate, setIsLoadingDate] = useState(false);
    const handlePrev = () => {
        sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    };

    const handleNext = () => {
        sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    };

    const applyMarkupToPricingFn = (pricing = [], markupDelta = 0) => {
        const markToAdd = Math.round(markupDelta)
        if (!Array.isArray(pricing) || !Number.isFinite(markToAdd) || markToAdd === 0) {
            return pricing;
        }

        return pricing.map((priceObj) => {
            const currentTotalPrice = Number(priceObj?.totalPrice);
            if (!Number.isFinite(currentTotalPrice)) {
                return priceObj;
            }
            return {
                ...priceObj,
                totalPrice: currentTotalPrice + markToAdd
            };
        });
    };

    const applyMarkupToFlightFn = (flight = {}, markupDelta = 0) => ({
        ...flight,
        pricing: applyMarkupToPricingFn(flight?.pricing, markupDelta),
        uniqueGroup: Array.isArray(flight?.uniqueGroup)
            ? flight.uniqueGroup.map((groupFlight) => ({
                ...groupFlight,
                pricing: applyMarkupToPricingFn(groupFlight?.pricing, markupDelta)
            }))
            : flight?.uniqueGroup
    });

    const applyMarkupToFlightsFn = (flights = [], markupAmount = 0) => {
        const markupValue = Number(markupAmount);
        if (!Array.isArray(flights) || !Number.isFinite(markupValue) || markupValue <= 0) {
            return Array.isArray(flights) ? flights : [];
        }

        return flights.map((flight) => applyMarkupToFlightFn(flight, markupValue));
    };

    const addMarkupAmountFn = () => {
        const enteredAmount = Number(markupInputAmount);
        if (!Number.isInteger(enteredAmount)) {
            setMarkupError('Decimal values are not allowed. Please enter a whole number.');
            return;
        }
        if (!Number.isFinite(enteredAmount) || enteredAmount <= 0) {
            setMarkupError('Please enter a valid markup amount greater than 0.');
            return;
        }
        const markupDelta = enteredAmount - totalMarkupAmount;
        if (!Number.isFinite(markupDelta) || markupDelta === 0) {
            setMarkupError('Entered amount is already applied. Please enter a different amount.');
            return;
        }
        setMarkupError('');
        setOriginalFlightData((prevFlights = []) =>
            prevFlights.map((flight) => applyMarkupToFlightFn(flight, markupDelta))
        );
        dispatch(setFlightMarkupAmount(enteredAmount));
        setShowMarkupPopup(false);
    };

    const clearMarkupAmountFn = () => {
        if (!totalMarkupAmount) {
            setMarkupInputAmount('0');
            setMarkupError('');
            return;
        }

        setOriginalFlightData((prevFlights = []) =>
            prevFlights.map((flight) => applyMarkupToFlightFn(flight, -totalMarkupAmount))
        );
        dispatch(setFlightMarkupAmount(0));
        setMarkupInputAmount('0');
        setMarkupError('');
        setShowMarkupPopup(false);
    };

    const toggleEmailSelectionItemFn = (index) => {
        setSelectedEmailIndexes((prevIndexes) =>
            prevIndexes.includes(index)
                ? prevIndexes.filter((item) => item !== index)
                : [...prevIndexes, index]
        );
    };

    const startEmailSelectionModeFn = () => {
        hideActionTooltips();
        setIsPrintSelectionMode(false);
        setSelectedPrintIndexes([]);
        setIsEmailSelectionMode(true);
        setShowEmailPopup(false);
        setEmailError('');
        setEmailMessageType('error');
    };

    const cancelEmailSelectionModeFn = () => {
        hideActionTooltips();
        setIsEmailSelectionMode(false);
        setSelectedEmailIndexes([]);
        setShowEmailPopup(false);
        setEmailAddress('');
        setEmailError('');
        setEmailMessageType('error');
    };

    const openEmailPopupFn = () => {
        if (!selectedEmailIndexes.length) {
            return;
        }
        setEmailError('');
        setEmailMessageType('error');
        setShowEmailPopup(true);
    };

    const isValidEmailFn = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

    const buildSelectedFlightsEmailHtmlFn = () => {
        if (!Array.isArray(selectedEmailIndexes) || !selectedEmailIndexes.length) {
            return '';
        }

        const escapeHtmlForEmailFn = (value) => String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

        const formatTimeForEmailFn = (iso) => {
            const t = formatDateTime(iso);
            return t?.time || '';
        };

        const formatPriceForEmailFn = (priceObj) => {
            const total = priceObj?.totalPrice;
            if (!Number.isFinite(Number(total))) return '';
            return `${agentActiveCurrency || 'AED'} ${formatPrice(total, false, true)}`;
        };

        const buildSeatBadgeForEmailFn = (flight) => {
            const seatRemainingNum = Number(flight?.pricing?.[0]?.seatRemaining);
            if (!seatShow || !Number.isFinite(seatRemainingNum) || seatRemainingNum <= 0) {
                return '';
            }
            let label;
            let color;
            let bg;
            if (seatRemainingNum === 1) {
                label = 'only 1 seat left';
                color = '#e3342f';
                bg = '#fff1f2';
            } else if (seatRemainingNum >= 9) {
                label = '9+ seats left';
                color = '#1f8f4a';
                bg = '#effaf3';
            } else {
                label = `${seatRemainingNum} seats left`;
                color = '#f08c00';
                bg = '#fff7eb';
            }
            return `
                <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto 8px auto;">
                    <tr>
                        <td style="padding:6px 14px;border-radius:999px;background:${bg};color:${color};font-size:14px;font-weight:500;font-family:Arial,sans-serif;line-height:1;white-space:nowrap;text-align:center;">${escapeHtmlForEmailFn(label)}</td>
                    </tr>
                </table>
            `;
        };

        const buildAirlineHeaderHtmlFn = (segments) => {
            const uniqueCodes = [];
            (segments || []).forEach((seg) => {
                if (seg?.flightCode && !uniqueCodes.includes(seg.flightCode)) {
                    uniqueCodes.push(seg.flightCode);
                }
            });
            const airlineCellsHtml = uniqueCodes.map((code) => {
                const seg = segments.find((s) => s?.flightCode === code) || {};
                const imgUrl = airlineImageFn(code);
                const flightName = escapeHtmlForEmailFn(seg?.flightName || '');
                const flightCode = escapeHtmlForEmailFn(`${seg?.flightCode || ''}${seg?.flightNumber || ''}`);
                return `
                    <td valign="middle" style="padding-right:16px;">
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" width="40">
                                    <img src="${escapeHtmlForEmailFn(imgUrl)}" width="40" height="40" alt="${flightName}" style="display:block;width:40px;height:40px;border:0;outline:none;text-decoration:none;" />
                                </td>
                                <td width="10" style="font-size:0;line-height:0;">&nbsp;</td>
                                <td valign="middle">
                                    <div style="font-size:14px;font-weight:700;color:#163a66;font-family:Arial,sans-serif;line-height:1.4;">${flightName}</div>
                                    <div style="font-size:12px;color:#6b7280;font-family:Arial,sans-serif;line-height:1.4;">${flightCode}</div>
                                </td>
                            </tr>
                        </table>
                    </td>
                `;
            }).join('');
            return `
                <table cellpadding="0" cellspacing="0" border="0" style="margin-bottom:8px;">
                    <tr>${airlineCellsHtml}</tr>
                </table>
            `;
        };

        const buildRouteLineHtmlFn = (stopCount) => {
            const dot = `
                <td width="8" height="8" align="center" valign="middle" bgcolor="#9ca3af" style="width:8px;min-width:8px;height:8px;background-color:#9ca3af;border-radius:50%;font-size:0;line-height:8px;mso-line-height-rule:exactly;padding:0;">&#160;</td>
            `;
            const segmentLine = `
                <td height="8" valign="middle" style="height:8px;padding:0;font-size:0;line-height:0;">
                    <div style="height:2px;background-color:#9ca3af;font-size:0;line-height:2px;mso-line-height-rule:exactly;">&#160;</div>
                </td>
            `;
            const normalizedStopCount = Math.max(0, Number(stopCount) || 0);
            const routeParts = [dot];
            for (let index = 0; index < normalizedStopCount; index += 1) {
                routeParts.push(segmentLine, dot);
            }
            routeParts.push(segmentLine, dot);
            return `
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin:8px 0;border-collapse:collapse;">
                    <tr>${routeParts.join('')}</tr>
                </table>
            `;
        };

        const buildRouteRowHtmlFn = ({ segments, totalDuration }) => {
            if (!Array.isArray(segments) || !segments.length) return '';
            const first = segments[0];
            const last = segments[segments.length - 1];
            const stopCount = Math.max(0, segments.length - 1);
            const stopText = stopCount === 0 ? 'Non-Stop' : `${stopCount} stop`;
            const durationText = convertMinutesFn(totalDuration || 0);

            return `
                <table cellpadding="0" cellspacing="0" border="0" width="100%">
                    <tr>
                        <td class="e-route-from" valign="middle" align="left" style="padding-right:8px;width:30%;min-width:88px;">
                            <div class="e-time" style="font-size:18px;font-weight:700;color:#163a66;font-family:Arial,sans-serif;line-height:1.3;">${escapeHtmlForEmailFn(formatTimeForEmailFn(first?.departure?.departureTime))}</div>
                            <div class="e-city" style="font-size:14px;color:#1f2937;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;">${escapeHtmlForEmailFn(first?.departure?.city || '')}</div>
                            <div class="e-date" style="font-size:14px;color:#6b7280;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;">${escapeHtmlForEmailFn(formatDateMonthWise(first?.departure?.departureTime) || '')}</div>
                        </td>
                        <td class="e-route-mid" valign="middle" align="center" style="padding:0 8px;width:40%;">
                            <div class="e-duration" style="font-size:14px;color:#1f2937;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;text-align:center;">${escapeHtmlForEmailFn(durationText)}</div>
                            ${buildRouteLineHtmlFn(stopCount)}
                            <div class="e-stops" style="font-size:14px;color:#1f2937;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;text-align:center;">${escapeHtmlForEmailFn(stopText)}</div>
                        </td>
                        <td class="e-route-to" valign="middle" align="left" style="padding-left:8px;width:30%;min-width:88px;">
                            <div class="e-time" style="font-size:18px;font-weight:700;color:#163a66;font-family:Arial,sans-serif;line-height:1.3;">${escapeHtmlForEmailFn(formatTimeForEmailFn(last?.arrival?.arrivalTime))}</div>
                            <div class="e-city" style="font-size:14px;color:#1f2937;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;">${escapeHtmlForEmailFn(last?.arrival?.city || '')}</div>
                            <div class="e-date" style="font-size:14px;color:#6b7280;font-weight:500;font-family:Arial,sans-serif;line-height:1.5;">${escapeHtmlForEmailFn(formatDateMonthWise(last?.arrival?.arrivalTime) || '')}</div>
                        </td>
                    </tr>
                </table>
            `;
        };

        const buildSegmentGroupsForEmailFn = (flight) => {
            if (flight?.tripType !== 'COMBO') {
                return [{
                    segments: flight?.segments || [],
                    totalDuration: flight?.totalDuration || 0
                }];
            }
            if (Array.isArray(queryParams?.segments) && queryParams.segments.length) {
                const groups = [];
                queryParams.segments.forEach((qSeg) => {
                    const matched = [];
                    let collecting = false;
                    let totalDuration = 0;
                    (flight?.segments || []).forEach((seg) => {
                        const depDate = seg?.departure?.departureTime?.split('T')?.[0];
                        if ((seg?.departure?.airportCode === qSeg?.fromAirport || seg?.neareastFromAirport === qSeg?.fromAirport) && depDate === qSeg?.departDate) {
                            collecting = true;
                        }
                        if (collecting) {
                            matched.push(seg);
                            totalDuration += (seg?.duration || 0) + (seg?.connectingTime || 0);
                            if (seg?.arrival?.airportCode === qSeg?.toAirport || seg?.neareastToAirport === qSeg?.toAirport) {
                                collecting = false;
                            }
                        }
                    });
                    if (matched.length) {
                        if (flight?.source === 'amadeus') {
                            totalDuration = matched[0]?.amadeusDurations || 0;
                        }
                        groups.push({ segments: matched, totalDuration });
                    }
                });
                if (groups.length) return groups;
            }
            const departure = [];
            const ret = [];
            let isDeparture = true;
            (flight?.segments || []).forEach((seg) => {
                if (isDeparture) {
                    departure.push(seg);
                    if (seg?.arrival?.airportCode === queryParams?.toAirport || seg?.neareastToAirport === queryParams?.toAirport) {
                        isDeparture = false;
                    }
                } else {
                    ret.push(seg);
                }
            });
            let depDuration = 0;
            let retDuration = 0;
            departure.forEach((s) => { depDuration += (s?.duration || 0) + (s?.connectingTime || 0); });
            ret.forEach((s) => { retDuration += (s?.duration || 0) + (s?.connectingTime || 0); });
            if (flight?.source === 'amadeus') {
                depDuration = departure?.[0]?.amadeusDurations || depDuration;
                retDuration = ret?.[0]?.amadeusDurations || retDuration;
            }
            const groups = [];
            if (departure.length) groups.push({ segments: departure, totalDuration: depDuration });
            if (ret.length) groups.push({ segments: ret, totalDuration: retDuration });
            return groups;
        };

        const buildActionColumnHtmlFn = (flight) => {
            const seatBadgeHtml = buildSeatBadgeForEmailFn(flight);
            const priceText = formatPriceForEmailFn(flight?.pricing?.[0]);
            return `
                <table cellpadding="0" cellspacing="0" border="0" width="100%" align="center">
                    ${seatBadgeHtml ? `<tr><td align="center" style="text-align:center;">${seatBadgeHtml}</td></tr>` : ''}
                    <tr>
                        <td class="e-price" align="center" style="text-align:center;font-size:20px;font-weight:700;color:#163a66;font-family:Arial,sans-serif;line-height:1.4;padding-bottom:8px;">${escapeHtmlForEmailFn(priceText)}</td>
                    </tr>
                    <tr>
                        <td align="center" style="text-align:center;padding-bottom:8px;">
                            <table cellpadding="0" cellspacing="0" border="0" align="center">
                                <tr>
                                    <td class="e-btn" align="center" style="padding:8px 24px;border-radius:6px;border:1px solid #3264ff;background:#ebf0ff;color:#3264ff;font-weight:700;font-size:16px;font-family:Arial,sans-serif;line-height:1.5;text-align:center;white-space:nowrap;">View Prices</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td class="e-link" align="center" style="text-align:center;font-size:14px;color:#3264ff;font-family:Arial,sans-serif;line-height:1.4;">View Flight Details</td>
                    </tr>
                </table>
            `;
        };

        const buildFlightCardHtmlFn = (flight) => {
            if (!flight) return '';
            const groups = buildSegmentGroupsForEmailFn(flight);
            if (!groups.length) return '';

            const headerSegments = groups[0]?.segments || [];
            const headerHtml = buildAirlineHeaderHtmlFn(headerSegments);

            const ndcHtml = flight?.source === 'verteil'
                ? `<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:0 0 8px 0;border-collapse:collapse;"><tr><td style="padding:4px 10px;background:#ebf0ff;color:#3264ff;font-size:14px;font-weight:700;font-family:Arial,sans-serif;border-radius:6px;line-height:1.5;white-space:nowrap;">NDC Fare</td></tr></table>`
                : '';

            const routeRowsHtml = groups.map((g, idx) => {
                const sep = idx > 0
                    ? '<tr><td style="height:8px;line-height:0;font-size:0;">&nbsp;</td></tr>'
                    : '';
                return `${sep}<tr><td>${buildRouteRowHtmlFn(g)}</td></tr>`;
            }).join('');

            const lastGroup = groups[groups.length - 1];
            const lastSegs = lastGroup?.segments || [];
            const dateDiff = lastSegs.length
                ? getDateDifference(lastSegs[0]?.departure?.departureTime, lastSegs[lastSegs.length - 1]?.arrival?.arrivalTime)
                : 0;
            const dateDiffHtml = dateDiff
                ? `<div style="margin-top:8px;font-size:14px;color:#1f2937;font-weight:500;font-family:Arial,sans-serif;">Flight Arrives after ${dateDiff} Day</div>`
                : '';

            return `
                <table cellpadding="0" cellspacing="0" border="0" width="100%" style="margin:0 0 12px 0;background:#ffffff;border:1px solid #e5e7eb;border-radius:8px;font-family:Arial,sans-serif;">
                    <tr>
                        <td style="padding:16px;">
                            ${ndcHtml}
                            ${headerHtml}
                            <table cellpadding="0" cellspacing="0" border="0" width="100%">
                                <tr>
                                    <td class="e-stack e-route-cell" valign="middle">
                                        <table cellpadding="0" cellspacing="0" border="0" width="100%">
                                            ${routeRowsHtml}
                                        </table>
                                    </td>
                                    <td class="e-stack e-action-cell" valign="middle" align="center" width="180" style="padding-left:16px;text-align:center;width:180px;">
                                        ${buildActionColumnHtmlFn(flight)}
                                    </td>
                                </tr>
                            </table>
                            ${dateDiffHtml}
                        </td>
                    </tr>
                </table>
            `;
        };

        const cardsHtml = selectedEmailIndexes
            .map((idx) => flightData?.[idx])
            .filter(Boolean)
            .map((flight) => buildFlightCardHtmlFn(flight))
            .filter(Boolean)
            .join('');

        if (!cardsHtml) {
            return '';
        }

        return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Flight Details</title>
    <style>
        body { margin:0; padding:0; background:#f2f2f2; font-family:Arial,sans-serif; }
        img { -ms-interpolation-mode:bicubic; }
        @media only screen and (max-width:600px) {
            .e-shell-cell { padding:12px 8px !important; }
            .e-card-cell { padding:12px !important; }
            .e-stack { display:block !important; width:100% !important; box-sizing:border-box !important; }
            .e-action-cell { padding-left:0 !important; padding-top:14px !important; border-top:1px solid #e5e7eb !important; margin-top:12px !important; }
            .e-route-cell { padding-bottom:4px !important; }
            .e-route-from, .e-route-to { width:36% !important; min-width:0 !important; }
            .e-route-mid { width:28% !important; }
            .e-time { font-size:16px !important; }
            .e-city { font-size:13px !important; }
            .e-date { font-size:12px !important; }
            .e-duration, .e-stops { font-size:12px !important; }
            .e-price { font-size:18px !important; }
            .e-btn { padding:8px 18px !important; font-size:14px !important; }
            .e-link { font-size:13px !important; }
        }
    </style>
</head>
<body style="margin:0;padding:0;background:#f2f2f2;font-family:Arial,sans-serif;">
    <table cellpadding="0" cellspacing="0" border="0" width="100%" style="background:#f2f2f2;">
        <tr>
            <td class="e-shell-cell" align="center" style="padding:24px 20px;">
                <table cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width:1100px;background:#ffffff;border:1px solid #e5e7eb;border-radius:10px;">
                    <tr>
                        <td class="e-card-cell" style="padding:16px;">
                            ${cardsHtml}
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
    };

    const sendSelectedFlightsEmailFn = async () => {
        const recipient = emailAddress.trim();
        if (!isValidEmailFn(recipient)) {
            setEmailMessageType('error');
            setEmailError('Please enter a valid email address.');
            return;
        }

        const selectedFlights = selectedEmailIndexes
            .map((index) => flightDataToConsider?.[index])
            .filter(Boolean);

        if (!selectedFlights.length) {
            setEmailMessageType('error');
            setEmailError('Please select at least one section to email.');
            return;
        }

        const emailSubject = `Flights from ${queryParams?.fromAirport || ''} to ${queryParams?.toAirport || ''}`;
        const bodyHtml = buildSelectedFlightsEmailHtmlFn();
        if (!bodyHtml?.trim()) {
            setEmailMessageType('error');
            setEmailError('Unable to prepare selected section HTML. Please try again.');
            return;
        }

        setEmailSending(true);
        setEmailError('');
        setEmailMessageType('error');
        const response = await ApiCall(
            'POST',
            'wp-json/dahr/v1/ticket-details-email',
            {
                email_subject: emailSubject,
                email_body: bodyHtml,
                receiver_email: recipient
            },
            {},
            'wordpress'
        );
        setEmailSending(false);

        if (response?.status === 200 && response?.data?.mail_sent) {
            setEmailMessageType('success');
            setEmailError('Mail sent successfully.');
            setEmailAddress('');
            return;
        }

        setEmailMessageType('error');
        setEmailError(response?.data?.message || 'Unable to send email right now. Please try again.');
    };

    const togglePrintSelectionItemFn = (index) => {
        setSelectedPrintIndexes((prevIndexes) =>
            prevIndexes.includes(index)
                ? prevIndexes.filter((item) => item !== index)
                : [...prevIndexes, index]
        );
    };

    const startPrintSelectionModeFn = () => {
        hideActionTooltips();
        setIsEmailSelectionMode(false);
        setSelectedEmailIndexes([]);
        setShowEmailPopup(false);
        setEmailAddress('');
        setEmailError('');
        setEmailMessageType('error');
        setIsPrintSelectionMode(true);
    };

    const cancelPrintSelectionModeFn = () => {
        hideActionTooltips();
        setIsPrintSelectionMode(false);
        setSelectedPrintIndexes([]);
    };

    const confirmPrintSelectionFn = () => {
        if (!selectedPrintIndexes.length) {
            return;
        }
        window.print();
    };

    useEffect(() => {
        const onScroll = () => {
            setIsActionMenuCentered(window.scrollY > 120);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        if (typeof document === 'undefined') return undefined;
        let lastHeight = 0;
        let ro;
        let raf;
        const apply = (el) => {
            const h = Math.round(el.getBoundingClientRect().height);
            if (h && h !== lastHeight) {
                lastHeight = h;
                document.documentElement.style.setProperty('--flight-header-h', `${h}px`);
            }
        };
        const attach = () => {
            const el = document.querySelector('.hw-widget--flight__open');
            if (!el) { raf = requestAnimationFrame(attach); return; }
            apply(el);
            if (typeof ResizeObserver !== 'undefined') {
                ro = new ResizeObserver(() => apply(el));
                ro.observe(el);
            }
        };
        const onResize = () => {
            const el = document.querySelector('.hw-widget--flight__open');
            if (el) apply(el);
        };
        attach();
        window.addEventListener('resize', onResize);
        return () => {
            if (ro) ro.disconnect();
            if (raf) cancelAnimationFrame(raf);
            window.removeEventListener('resize', onResize);
        };
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return undefined;
        }

        const checkFooterVisibilityFn = () => {
            const footerElement = document.querySelector('footer') || document.querySelector('.hw-footer');
            const actionMenuElement = actionMenuRef.current;
            if (!footerElement || !actionMenuElement) {
                setIsFooterVisible(false);
                return;
            }

            const footerRect = footerElement.getBoundingClientRect();
            const actionMenuRect = actionMenuElement.getBoundingClientRect();
            const isOverlappingFooter = !(actionMenuRect.bottom < footerRect.top || actionMenuRect.top > footerRect.bottom);
            setIsFooterVisible(isOverlappingFooter);
        };

        checkFooterVisibilityFn();
        window.addEventListener('scroll', checkFooterVisibilityFn, { passive: true });
        window.addEventListener('resize', checkFooterVisibilityFn);

        return () => {
            window.removeEventListener('scroll', checkFooterVisibilityFn);
            window.removeEventListener('resize', checkFooterVisibilityFn);
        };
    }, [isMobileView, mainLoading]);

    useEffect(() => {
        if (typeof document === 'undefined') return undefined;

        const checkFlightBookModalOpenFn = () => {
            setIsFlightBookModalOpen(!!document.querySelector('.hw-modal--flightBook.show'));
        };

        checkFlightBookModalOpenFn();

        const observer = new MutationObserver(() => {
            checkFlightBookModalOpenFn();
        });

        observer.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class']
        });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const onResize = () => {
            setIsMobileView(window.innerWidth <= 767);
        };

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const lockBodyScroll = () => {
        if (typeof document === 'undefined') return;
        const body = document.body;
        const currentCount = Number(body.dataset.hwScrollLockCount || '0');
        if (currentCount === 0) {
            body.dataset.hwScrollLockOverflow = body.style.overflow || '';
            body.style.overflow = 'hidden';
        }
        body.dataset.hwScrollLockCount = String(currentCount + 1);
    };

    const unlockBodyScroll = () => {
        if (typeof document === 'undefined') return;
        const body = document.body;
        const currentCount = Number(body.dataset.hwScrollLockCount || '0');
        const nextCount = Math.max(0, currentCount - 1);
        body.dataset.hwScrollLockCount = String(nextCount);
        if (nextCount === 0) {
            body.style.overflow = body.dataset.hwScrollLockOverflow || '';
            delete body.dataset.hwScrollLockOverflow;
        }
    };

    useEffect(() => {
        const isAnyPopupOpen = showMarkupPopup || showEmailPopup;
        if (!isAnyPopupOpen) return undefined;

        lockBodyScroll();
        return () => {
            unlockBodyScroll();
        };
    }, [showMarkupPopup, showEmailPopup]);

    useEffect(() => {
        if (!showMarkupPopup) {
            return;
        }
        setMarkupInputAmount(String(totalMarkupAmount || 0));
        setMarkupError('');
    }, [showMarkupPopup, totalMarkupAmount]);

    useEffect(() => {
        const afterPrintFn = () => {
            setIsPrintSelectionMode(false);
            setSelectedPrintIndexes([]);
        };

        window.addEventListener('afterprint', afterPrintFn);
        return () => window.removeEventListener('afterprint', afterPrintFn);
    }, []);

    const addBundleSelection = (bundleData, tripType = '') => {
        setSelectedAirArabiaBundle(prevBundles => {
            const filteredBundles = prevBundles.filter(bundle => bundle.tripType !== tripType);
            return [...filteredBundles, { ...bundleData, tripType }];
        });
    };

    const getBundleForTripType = (tripType) => {
        return selectedAirArabiaBundle.find(bundle => bundle.tripType === tripType);
    };

    const clearBundleSelection = (tripType = null) => {
        if (tripType) {
            setSelectedAirArabiaBundle(prevBundles =>
                prevBundles.filter(bundle => bundle.tripType !== tripType)
            );
        } else {
            setSelectedAirArabiaBundle([]);
        }
    };

    const onSelectAirArabiaBundle = (service, tripType = '') => {
        addBundleSelection(service, tripType);
    };


    const flightPayloadFn = (queryParams) => {
        let tripData = [];
        if (queryParams?.type === "combo") {
            tripData = queryParams?.segments?.map(data => ({
                "from": data?.fromAirport,
                "to": data?.toAirport,
                "date": data?.departDate
            }))
        } else {
            let oneWayData = {
                "from": queryParams?.fromAirport,
                "to": queryParams?.toAirport,
                "date": queryParams?.departDate
            };
            tripData?.push(oneWayData)
            if (queryParams?.returnDate) {
                tripData?.push({
                    "from": queryParams?.toAirport,
                    "to": queryParams?.fromAirport,
                    "date": queryParams?.returnDate
                })
            }
        }
        return {
            "cabinClass": queryParams?.passageClass?.toUpperCase().replace(/ /g, "_"),
            ...(parseInt(queryParams?.adult) ? { adult: parseInt(queryParams?.adult) } : {}),
            ...(parseInt(queryParams?.child) ? { child: parseInt(queryParams?.child) } : {}),
            ...(parseInt(queryParams?.infant) ? { infant: parseInt(queryParams?.infant) } : {}),
            ...((queryParams?.airlineCode) ? { airlines: queryParams?.airlineCode?.split(',') } : {}),
            "trip": tripData,
            // always fetch connecting flights too — "Direct Flights" is applied
            // client-side (like the sidebar's Non Stop filter), so the listing
            // needs them in memory to be able to show them again when unticked
            "directFlights": false,
            "nearByAirport": queryParams?.nearByAirport === 'true'
        }
    }

    const flightDatesPayloadFn = (queryParams) => {
        let payload = {
            currency: 'AED'
        }
        let totalPassenger = parseInt(queryParams?.adult) + parseInt(queryParams?.child) + parseInt(queryParams?.infant);
        if (totalPassenger > 0) {
            payload['passenger'] = totalPassenger;
        }
        payload['from'] = queryParams?.fromAirport
        payload['to'] = queryParams?.toAirport
        payload['fromDate'] = queryParams?.departDate
        payload["cabinClass"] = queryParams?.passageClass?.toUpperCase().replace(/ /g, "_");
        payload["directFlights"] = queryParams?.directFlight === 'true';
        payload["nearByAirport"] = queryParams?.nearByAirport === 'true';
        payload["airlines"] = queryParams?.airlineCode?.split(',');
        payload['adult'] = parseInt(queryParams?.adult) > 0 ? parseInt(queryParams?.adult) : 0;
        payload['child'] = parseInt(queryParams?.child) > 0 ? parseInt(queryParams?.child) : 0;
        payload['infant'] = parseInt(queryParams?.infant) > 0 ? parseInt(queryParams?.infant) : 0;
        if (queryParams?.returnDate) {
            payload['endDate'] = queryParams?.returnDate
        }
        return payload
    }

    useEffect(() => {
        if (changePageState) {
            resetState()
        }
        createDatesSlider()
        fetchFlightData();
        fetchHeaderData();
        setActiveStops([
            { title: `${queryParams?.fromAirport}-${queryParams?.toAirport}`, active: true, index: 1 },
            { title: `${queryParams?.toAirport}-${queryParams?.fromAirport}`, active: false, index: 2 }
        ])
    }, [changePageState])

    const createDatesSlider = () => {
        const fromDate = new Date(queryParams?.departDate)
        const toDate = new Date(queryParams?.returnDate)
        const diffMs = toDate - fromDate;
        const tripRange = diffMs / (1000 * 60 * 60 * 24);
        const today = new Date();
        const numDays = 365;
        const slider = [];

        for (let i = 0; i < numDays; i++) {
            const start = new Date(today);
            start.setDate(today.getDate() + i);

            let end = null;
            let endStr = null;
            if (tripRange > 0) {
                end = new Date(start);
                end.setDate(start.getDate() + tripRange);
                endStr = end.toISOString().split("T")[0];
            }
            const startStr = start.toISOString().split("T")[0];
            slider.push({
                depDate: startStr,
                arrDate: tripRange > 0 ? endStr : null,
                price: null,
                showLoading: true,
                displayString: tripRange > 0
                    ? `${formatDate(start, false)} - ${formatDate(end, false)}`
                    : `${formatDate(start, true)}`
            });
        }
        setDateFilterData(slider);
        const selectedIndex = slider.findIndex(item =>
            tripRange > 0
                ? item.depDate === queryParams?.departDate && item.arrDate === queryParams?.returnDate
                : item.depDate === queryParams?.departDate
        );
        setSelectedDate(selectedIndex ? selectedIndex : 0);
    };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    useEffect(() => {
        if (!queryParams?.departDate) return;
        createDatesSlider();
        // fetchDatesFlights();
    }, [queryParams?.departDate, queryParams?.returnDate, changePageState]);

    useEffect(() => {
        if (!sliderRef.current || selectedDate < 0) return;
        const scrollToSelected = () => {
            const child = sliderRef.current.children[selectedDate];
            if (child) {
                child.scrollIntoView({ behavior: "instant", inline: "center", block: "nearest" });
                setTimeout(() => setIsLoadingDate(false), 500)
            }
        };
        const id = requestAnimationFrame(scrollToSelected);
        setIsLoadingDate(false)
        return () => cancelAnimationFrame(id);
    }, [datefilterData, selectedDate, originalFlightData, mainLoading]);


    const resetState = () => {
        setAirlineText('')
        setIsPrintSelectionMode(false);
        setSelectedPrintIndexes([]);
        setIsEmailSelectionMode(false);
        setSelectedEmailIndexes([]);
        setShowEmailPopup(false);
        setEmailAddress('');
        setEmailError('');
        setEmailMessageType('error');
        setIsHeaderAirportsLoading(true);
        setSearchQueryAirport({});
        setFastestFlight(false);
        setOriginalFlightData([]);
        setFlightData([]);
        setLoading(true);
        setMainLoading(true);
        setFirstonLoad(true);
        setCheapestDuration('');
        setFastestDuration('');
        setAirlineFilterData([]);
        setAirportFilterData({});
        setCurrentTabAirport('');
        setHeaderAirportData([]);
        setHeaderAirlineData([]);
        setHeaderAirportMenuShow(false);
        setDateFilterData([])
        setFilterHideShow({
            departure: true,
            returnDeparture: true,
            stops: true,
            returnstops: true,
            price: false,
            airlines: false,
            durations: false,
            airport: false,
        });
        setTotalAirportStops([
            { stop: 'Non Stop', checked: false, value: 0 },
            { stop: '1 Stop', checked: false, value: 1 },
            { stop: '2 Stop', checked: false, value: 2 },
            { stop: '3+ Stop', checked: false, value: 3 },
        ]);
        setDepartureTimeFilter([
            { time: '00-06', checked: false, title: 'Before 6AM' },
            { time: '06-12', checked: false, title: '6AM - 12PM' },
            { time: '12-18', checked: false, title: '12PM - 6PM' },
            { time: '18-24', checked: false, title: 'After 6PM' },
        ]);
        setPriceRange({
            minMaxSetPrice: [0, 1],
            minMaxPrice: [0, 1],
        });
        setDurationValues({
            minMaxSetValue: [0, 100],
            duration: [50],
        });
        setSelectedMultiflights([])
        setMultiFlightOptionsData([])
        setRoundTripDomestic({
            status: false,
            active: 0
        })
        setPage(1);
    };

    useEffect(() => {
        if (originalFlightData?.length) {
            setCurrentTabAirport(`${originalFlightData?.[0]?.segments[0]?.departure?.airportCode}-${originalFlightData?.[0]?.segments[originalFlightData?.[0]?.segments.length - 1]?.arrival?.airportCode}`)
            const cheapestFlight = originalFlightData
                .flatMap(f => (f?.pricing || []).map(p => ({ flight: f, price: Number(p?.totalPrice) })))
                .reduce(
                    (min, curr) => (curr?.price < min?.price ? curr : min),
                    { flight: null, price: Infinity }
                );
            setCheapestDuration(
                    <>
                        {/* <span className="hw-currency ml-6">{agentActiveCurrency} </span> */}
                        {/* formatePriceFn(agentActiveCurrency, formatPrice(option?.amount, true, true), displayPrice) */}
                        {formatePriceFn(agentActiveCurrency,formatPrice(
                            cheapestFlight?.pricing?.[0]?.totalPrice,
                            true,
                            true
                        ),displayPrice)}
                        {" | "}
                        {convertMinutesHeaderFn(cheapestFlight?.totalDuration)}
                    </>
                );
            const minDuration = originalFlightData.reduce((minObj, currentObj) => {
                if (currentObj.totalDuration < minObj.totalDuration) return currentObj;
                if (currentObj.totalDuration > minObj.totalDuration) return minObj;
                const curP = currentObj?.pricing?.[0]?.totalPrice ?? Infinity;
                const minP = minObj?.pricing?.[0]?.totalPrice ?? Infinity;
                return curP < minP ? currentObj : minObj;
            });
            setFastestDuration(
                <>
                    {formatePriceFn(
                        agentActiveCurrency,
                        formatPrice(
                            minDuration?.pricing?.[0]?.totalPrice,
                            true,
                            true
                        ),
                        displayPrice
                    )}
                    {" | "}
                    {convertMinutesHeaderFn(minDuration?.totalDuration)}
                </>
            );
            let original_flight_data = originalFlightData?.map((items) => ({
                ...items,
                openFlightDetails: false,
                openFareViews: false,
                openFlighDetailsCurrentTabs: 1,
                openFlighDetailsFareRulesTabs: 1
            }));

            const prices = originalFlightData.map(flights => flights?.pricing?.[0]?.totalPrice);

            if (Math.min(...prices) === Math.max(...prices)) {
                setPriceRange({
                    minMaxPrice: [0, Math.max(...prices)],
                    minMaxSetPrice: [0, Math.max(...prices)],
                })
            } else {
                setPriceRange({
                    minMaxPrice: [Math.min(...prices), Math.max(...prices)],
                    minMaxSetPrice: [Math.min(...prices), Math.max(...prices)],
                })
            }

            let findOnWardFlight = originalFlightData.find(item => item.tripType === 'ONWARD');
            let findReturnFlight = originalFlightData.find(item => item.tripType === 'RETURN');
            let multiFlightData = [];
            let pricing = {}
            // if(findOnWardFlight?.source === 'fly-dubai'){
            //     pricing = {...findOnWardFlight?.pricing?.[0], id : findOnWardFlight?.pricing?.[0]?.solnId}
            // }
            if (findOnWardFlight) {
                let onWardFlight = {
                    type: 'ONWARD',
                    fromAirport: findOnWardFlight?.segments?.[0]?.departure,
                    segment: findOnWardFlight?.segments,
                    routingId: findOnWardFlight?.routingId,
                    totalDurations: findOnWardFlight?.totalDuration,
                    source: findOnWardFlight?.source,
                    journeyKey: findOnWardFlight?.journeyKey,
                    baseCurrency: findOnWardFlight?.baseCurrency,
                    flightDHTRId: findOnWardFlight?.flightDHTRId,
                    arrivalAirport: findOnWardFlight?.segments?.[findOnWardFlight?.segments?.length - 1]?.arrival,
                    airlineData: {
                        flightCode: findOnWardFlight?.segments?.[0]?.flightCode,
                        flightEquipmentType: findOnWardFlight?.segments?.[0]?.flightEquipmentType,
                        flightNumber: findOnWardFlight?.segments?.[0]?.flightNumber,
                        flightName: findOnWardFlight?.segments?.[0]?.flightName,
                    },
                    priceId: findOnWardFlight?.source !== 'air-arabia' ? findOnWardFlight?.pricing?.[0] : findOnWardFlight?.source === 'fly-dubai' ? pricing : undefined,
                    active: true,
                    selected: false
                };
                let publishedFlight = findOnWardFlight?.pricing?.[0];

                if (onWardFlight?.source === 'air-arabia') {
                    multiFlightData.push(onWardFlight)
                } else {
                    if (publishedFlight) {
                        onWardFlight.priceId = publishedFlight
                        multiFlightData.push(onWardFlight)
                    }
                }


            }
            if (findReturnFlight) {
                let returnFlight = {
                    type: 'RETURN',
                    fromAirport: findReturnFlight?.segments?.[0]?.departure,
                    arrivalAirport: findReturnFlight?.segments?.[findReturnFlight?.segments?.length - 1]?.arrival,
                    source: findReturnFlight?.source,
                    segment: findReturnFlight?.segments,
                    routingId: findReturnFlight?.routingId,
                    flightDHTRId: findReturnFlight?.flightDHTRId,
                    totalDurations: findReturnFlight?.totalDuration,
                    journeyKey: findReturnFlight?.journeyKey,
                    baseCurrency: findReturnFlight?.baseCurrency,
                    airlineData: {
                        flightCode: findReturnFlight?.segments?.[0]?.flightCode,
                        flightEquipmentType: findReturnFlight?.segments?.[0]?.flightEquipmentType,
                        flightNumber: findReturnFlight?.segments?.[0]?.flightNumber,
                        flightName: findReturnFlight?.segments?.[0]?.flightName,
                    },
                    priceId: (findReturnFlight?.source !== 'air-arabia') ? findReturnFlight?.pricing?.[0] : undefined,
                    active: false,
                    selected: false
                }
                if (multiFlightData?.length) {
                    let publishedFlight = findReturnFlight?.pricing?.[0];
                    if (returnFlight?.source === 'air-arabia') {
                        multiFlightData.push(returnFlight)
                    } else {
                        if (publishedFlight) {
                            returnFlight.priceId = publishedFlight
                            multiFlightData.push(returnFlight)
                        }
                    }
                }
            }
            setMultiFlightOptionsData(multiFlightData)

            // For Fly Dubai, only select onward flight by default
            // if(findOnWardFlight?.source === 'fly-dubai'){
            //     let onwardFlight = multiFlightData.find(flight => flight?.type === 'ONWARD')
            //     if(onwardFlight){
            //         setSelectedMultiflights([onwardFlight])
            //     }else{
            //         setSelectedMultiflights([])
            //     }
            // }else{
            // }
            setSelectedMultiflights(multiFlightData)

            const durations = originalFlightData.map(item => item.totalDuration);
            let durationData;

            // Handle empty durations array
            if (durations.length === 0) {
                durationData = {
                    minMaxSetValue: [0, 100],
                    duration: [50]
                }
            } else if (Math.min(...durations) === Math.max(...durations)) {
                const sameValue = Math.max(...durations);
                durationData = {
                    minMaxSetValue: [Math.max(0, sameValue - 1), sameValue],
                    duration: [sameValue]
                }
            } else {
                durationData = {
                    minMaxSetValue: [Math.min(...durations), Math.max(...durations)],
                    duration: [Math.max(...durations)]
                }
            }


            let airportFilterData = {
                departure: {
                    airportCode: originalFlightData?.[0]?.segments[0]?.departure?.airportCode,
                    airportName: originalFlightData?.[0]?.segments[0]?.departure?.airportName,
                    active: false
                },
                arrival: {
                    airportCode: originalFlightData?.[0]?.segments[originalFlightData?.[0]?.segments.length - 1]?.arrival?.airportCode,
                    airportName: originalFlightData?.[0]?.segments[originalFlightData?.[0]?.segments.length - 1]?.arrival?.airportName,
                    active: false
                }
            }

            if (["RETURN", "ONWARD"].every(type => originalFlightData.some(item => item.tripType === type))) {
                setRoundTripDomestic(prevState => ({
                    ...prevState,
                    status: true,
                    active: 1
                }));
                original_flight_data = original_flight_data.filter(flight => flight?.tripType !== 'COMBO')
                const getUniqueAirports = (flights, type, tripType) => {
                    const seen = new Set();
                    return flights.map(flight => {
                        if (flight?.tripType === tripType) {
                            const airport = type === 'departure'
                                ? flight?.segments[0]?.departure
                                : flight?.segments[flight?.segments.length - 1]?.arrival;

                            if (!airport) return null;

                            const key = `${airport.airportCode}-airport`;
                            if (seen.has(key)) return null;

                            seen.add(key);
                            return {
                                airportCode: airport.airportCode,
                                airportName: airport.airportName,
                                active: false,
                            };
                        }
                    }).filter(Boolean);
                };
                const uniqueDepartureAirports = getUniqueAirports(original_flight_data, 'departure', 'ONWARD');
                const uniqueArrivalAirports = getUniqueAirports(original_flight_data, 'arrival', 'ONWARD');
                const returnuniqueDepartureAirports = getUniqueAirports(original_flight_data, 'departure', 'RETURN');
                const returnuniqueArrivalAirports = getUniqueAirports(original_flight_data, 'arrival', 'RETURN');
                airportFilterData = {
                    departure: uniqueDepartureAirports,
                    arrival: uniqueArrivalAirports,
                    returnDeparture: returnuniqueDepartureAirports,
                    returnArrival: returnuniqueArrivalAirports
                }
                let checkComboFlight = ["COMBO"].every(type => originalFlightData.some(item => item.tripType === type));
                if (checkComboFlight) {
                    const departureTimings = [];
                    const returnTimings = [];
                    const comboFlightsOnly = originalFlightData?.filter(f => f?.tripType === 'COMBO') || [];
                    comboFlightsOnly.forEach((flights) => {
                        let isDeparture = true;
                        let departureDuration = 0;
                        let returnDuration = 0;
                        const departureFlights = [];
                        const returnFlights = [];
                        flights?.segments.forEach((flight, index) => {
                            const { connectingTime = 0, duration = 0, arrival } = flight;
                            const totalDuration = connectingTime + duration;

                            if (isDeparture) {
                                departureFlights.push(flight);
                                departureDuration += totalDuration;
                                if (arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                                    isDeparture = false;
                                }
                            } else {
                                returnFlights.push(flight);
                                returnDuration += totalDuration;
                            }
                        });
                        if (flights?.source === 'amadeus') {
                            if (departureFlights.length > 0) {
                                departureDuration = departureFlights[0]?.amadeusDurations || 0;
                            }
                            if (returnFlights.length > 0) {
                                returnDuration = returnFlights[0]?.amadeusDurations || 0;
                            }
                        }
                        if (departureDuration > 0) departureTimings.push(departureDuration);
                        if (returnDuration > 0) returnTimings.push(returnDuration);
                    });
                    const departureMin = departureTimings.length > 0 ? Math.min(...departureTimings) : 0;
                    const departureMax = departureTimings.length > 0 ? Math.max(...departureTimings) : 100;
                    const departureMinValue = departureMin === departureMax ? Math.max(0, departureMin - 1) : departureMin;
                    /*durationData = {
                        minMaxSetValue: [departureMinValue, departureMax],
                        duration: [departureMax]
                    };*/
                    const returnMin = returnTimings.length > 0 ? Math.min(...returnTimings) : 0;
                    const returnMax = returnTimings.length > 0 ? Math.max(...returnTimings) : 100;
                    const returnMinValue = returnMin === returnMax ? Math.max(0, returnMin - 1) : returnMin;
                    setReturnDurationValues({
                        minMaxSetValue: [returnMinValue, returnMax],
                        duration: [returnMax]
                    })
                }
            } else if (originalFlightData.some(item => item.tripType === 'COMBO') && originalFlightData.some(item => !['RETURN', 'ONWARD', 'COMBO'].includes(item.tripType))) {
                // Handle combined scenario: COMBO + other trip types (0, 1, 2, etc.)
                setRoundTripDomestic(prevState => ({
                    ...prevState,
                    status: true,
                    active: 2
                }));

                // Create multiFlightOptionsData for both COMBO and other trip types
                const allFlightData = [...originalFlightData];
                const comboFlights = allFlightData.filter(flight => flight?.tripType === 'COMBO');
                const otherTripTypeFlights = allFlightData.filter(flight => !['RETURN', 'ONWARD', 'COMBO'].includes(flight?.tripType));

                // Create flight options for other trip types (0, 1, 2, etc.)
                const otherTripTypeOptions = [];
                const uniqueOtherTripTypes = [...new Set(otherTripTypeFlights.map(f => f?.tripType))].sort();

                for (let i = 0; i < uniqueOtherTripTypes.length; i++) {
                    const type = uniqueOtherTripTypes[i];
                    const flight = otherTripTypeFlights.find(f => f?.tripType === type);
                    if (!flight) continue;
                    const segments = flight.segments || [];
                    const firstSegment = segments[0] || {};
                    const lastSegment = segments[segments.length - 1] || {};
                    otherTripTypeOptions.push({
                        type,
                        fromAirport: firstSegment.departure,
                        arrivalAirport: lastSegment.arrival,
                        airlineData: {
                            flightCode: firstSegment.flightCode,
                            flightEquipmentType: firstSegment.flightEquipmentType,
                            flightNumber: firstSegment.flightNumber,
                            flightName: firstSegment.flightName,
                        },
                        routingId: flight?.routingId,
                        priceId: flight?.pricing?.[0],
                        active: i === 0,
                        selected: false
                    });
                }

                // Set multiFlightOptionsData with both COMBO and other trip types
                setMultiFlightOptionsData(otherTripTypeOptions);

                // Initialize selectedMultiflights with one pre-filled entry per leg so the
                // footer shows the default (cheapest) fare immediately after switching to
                // Single-tab — and so selectMultiFlightFn can locate the active slot via
                // findIndex instead of always pushing a brand-new entry (Issue 1 + 2).
                const initialSelectedMultiflights = [];
                for (let j = 0; j < uniqueOtherTripTypes.length; j++) {
                    const tripTypeVal = uniqueOtherTripTypes[j];
                    const legFlight = otherTripTypeFlights.find(f => f?.tripType === tripTypeVal);
                    if (!legFlight) continue;
                    const legSegments = legFlight.segments || [];
                    const legFirstSeg = legSegments[0] || {};
                    const legLastSeg = legSegments[legSegments.length - 1] || {};
                    initialSelectedMultiflights.push({
                        type: tripTypeVal,
                        segment: legSegments,
                        routingId: legFlight?.routingId,
                        totalDurations: legFlight?.totalDuration,
                        journeyKey: legFlight?.journeyKey,
                        flightDHTRId: legFlight?.flightDHTRId,
                        priceId: legFlight?.pricing?.[0],
                        source: legFlight?.source,
                        fromAirport: legFirstSeg.departure,
                        arrivalAirport: legLastSeg.arrival,
                        airlineData: {
                            flightCode: legFirstSeg.flightCode,
                            flightEquipmentType: legFirstSeg.flightEquipmentType,
                            flightNumber: legFirstSeg.flightNumber,
                            flightName: legFirstSeg.flightName,
                        },
                        active: j === 0,
                        selected: false
                    });
                }
                setSelectedMultiflights(initialSelectedMultiflights);

                // Filter to show only COMBO flights by default
                original_flight_data = original_flight_data.filter(flight => flight?.tripType === 'COMBO');

                // Process COMBO flights for multi-city (same logic as pure COMBO scenario)
                if (Array.isArray(queryParams?.segments)) {
                    const multiCityData = {};
                    const durationArr = {};
                    airportFilterData = {};
                    const timeFilterData = {};
                    let durationAirportData = {};

                    queryParams?.segments?.forEach((segment, segmentIndex) => {
                        const { fromAirport, toAirport, departDate } = segment;
                        const segmentWiseDepartureAirport = [];
                        const segmentWiseArrivalAirport = [];

                        original_flight_data?.forEach((flights) => {
                            let matchedFlights = [];
                            let collecting = false;
                            let totalDuration = 0;

                            for (const flight of flights?.segments || []) {
                                const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];

                                if (!collecting && (flight.departure.airportCode === fromAirport || flight?.neareastFromAirport === fromAirport) && flightDepartureDate === departDate) {
                                    collecting = true;
                                }

                                if (collecting) {
                                    matchedFlights.push(flight);
                                    totalDuration += (flight.duration || 0) + (flight.connectingTime || 0);

                                    if (flight.arrival.airportCode === toAirport || flight?.neareastToAirport === toAirport) {
                                        segmentWiseDepartureAirport.push({
                                            airportCode: matchedFlights[0]?.departure.airportCode,
                                            airportName: matchedFlights[0]?.departure.airportName,
                                            active: false,
                                            returnActive: false
                                        });
                                        segmentWiseArrivalAirport.push({
                                            airportCode: matchedFlights[matchedFlights.length - 1]?.arrival.airportCode,
                                            airportName: matchedFlights[matchedFlights.length - 1]?.arrival.airportName,
                                            active: false,
                                            returnActive: false
                                        })
                                        break;
                                    }
                                }
                            }

                            if (matchedFlights.length > 0) {
                                if (flights.source === 'amadeus') {
                                    totalDuration = matchedFlights[0]?.amadeusDurations || 0;
                                }
                                if (!multiCityData[segmentIndex]) {
                                    multiCityData[segmentIndex] = {
                                        flights: matchedFlights,
                                        source: flights.source,
                                        totalDuration
                                    };

                                    timeFilterData[segmentIndex] = {
                                        time: [
                                            { time: '00-06', checked: false, title: 'Before 6AM' },
                                            { time: '06-12', checked: false, title: '6AM - 12PM' },
                                            { time: '12-18', checked: false, title: '12PM - 6PM' },
                                            { time: '18-24', checked: false, title: 'After 6PM' },
                                        ],
                                        title: matchedFlights[0]?.departure.airportCode,
                                        airportName: matchedFlights[0]?.departure.airportName,
                                        city: matchedFlights[0]?.departure.city,
                                        active: true,
                                        departure: true
                                    };
                                }
                                const routeKey = `${fromAirport}-${toAirport}`;
                                if (!durationArr[routeKey]) {
                                    durationArr[routeKey] = { totalDuration: [] };
                                }
                                durationArr[routeKey].departDate = departDate;
                                durationArr[routeKey].totalDuration.push(totalDuration);
                            }
                        });

                        const uniqueDepartureData = segmentWiseDepartureAirport.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.airportCode === value.airportCode
                            ))
                        );

                        const uniqueArrivalData = segmentWiseArrivalAirport.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.airportCode === value.airportCode
                            ))
                        );

                        airportFilterData[segmentIndex] = {
                            departure: uniqueDepartureData,
                            arrival: uniqueArrivalData
                        };
                    });

                    if (Object.keys(durationArr)?.length) {
                        let activeStopData = [];
                        Object.keys(durationArr)?.map((airports, index) => {
                            let totalDuration = durationArr?.[airports]?.totalDuration;
                            // Handle empty arrays and same values to prevent RangeError
                            if (totalDuration.length === 0) {
                                durationAirportData[airports] = {
                                    minMaxSetValue: [0, 100],
                                    duration: [50]
                                }
                            } else if (Math.min(...totalDuration) === Math.max(...totalDuration)) {
                                const sameValue = Math.max(...totalDuration);
                                durationAirportData[airports] = {
                                    minMaxSetValue: [Math.max(0, sameValue - 1), sameValue],
                                    duration: [sameValue]
                                }
                            } else {
                                durationAirportData[airports] = {
                                    minMaxSetValue: [Math.min(...totalDuration), Math.max(...totalDuration)],
                                    duration: [Math.max(...totalDuration)]
                                }
                            }
                            durationAirportData[airports].departDate = durationArr?.[airports]?.departDate;
                            activeStopData.push({
                                departDate: durationArr?.[airports]?.departDate,
                                title: airports,
                                active: index === 0,
                                index: index + 1
                            })
                        })
                        setActiveStops(activeStopData)
                    }
                    setMultiCityDurationValues(durationAirportData);
                    setMultiCityDepartureTimeFilter(timeFilterData);
                }
            } else if (["COMBO"].every(type => originalFlightData.some(item => item.tripType === type))) {
                setRoundTripDomestic(prevState => ({
                    ...prevState,
                    status: true,
                    active: 2
                }));
                if (Array.isArray(queryParams?.segments)) {
                    const multiCityData = {};
                    const durationArr = {};
                    airportFilterData = {};
                    // const airportFilterData = {};
                    const timeFilterData = {};
                    let durationAirportData = {};
                    queryParams?.segments?.forEach((segment, segmentIndex) => {
                        const { fromAirport, toAirport, departDate } = segment;
                        const segmentWiseDepartureAirport = [];
                        const segmentWiseArrivalAirport = [];
                        original_flight_data?.forEach((flights) => {
                            let matchedFlights = [];
                            let collecting = false;
                            let totalDuration = 0;

                            for (const flight of flights?.segments || []) {
                                const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];

                                if (!collecting && (flight.departure.airportCode === fromAirport || flight?.neareastFromAirport === fromAirport) && flightDepartureDate === departDate) {
                                    collecting = true;
                                }

                                if (collecting) {
                                    matchedFlights.push(flight);
                                    totalDuration += (flight.duration || 0) + (flight.connectingTime || 0);

                                    if (flight.arrival.airportCode === toAirport || flight?.neareastToAirport === toAirport) {
                                        segmentWiseDepartureAirport.push({
                                            airportCode: matchedFlights[0]?.departure.airportCode,
                                            airportName: matchedFlights[0]?.departure.airportName,
                                            active: false,
                                            returnActive: false
                                        });
                                        segmentWiseArrivalAirport.push({
                                            airportCode: matchedFlights[matchedFlights.length - 1]?.arrival.airportCode,
                                            airportName: matchedFlights[matchedFlights.length - 1]?.arrival.airportName,
                                            active: false,
                                            returnActive: false
                                        })
                                        break;
                                    }
                                }
                            }

                            if (matchedFlights.length > 0) {
                                if (flights.source === 'amadeus') {
                                    totalDuration = matchedFlights[0]?.amadeusDurations || 0;
                                }
                                if (!multiCityData[segmentIndex]) {
                                    multiCityData[segmentIndex] = {
                                        flights: matchedFlights,
                                        source: flights.source,
                                        totalDuration
                                    };


                                    timeFilterData[segmentIndex] = {
                                        time: [
                                            { time: '00-06', checked: false, title: 'Before 6AM' },
                                            { time: '06-12', checked: false, title: '6AM - 12PM' },
                                            { time: '12-18', checked: false, title: '12PM - 6PM' },
                                            { time: '18-24', checked: false, title: 'After 6PM' },
                                        ],
                                        title: matchedFlights[0]?.departure.airportCode,
                                        airportName: matchedFlights[0]?.departure.airportName,
                                        city: matchedFlights[0]?.departure.city,
                                        active: true,
                                        departure: true
                                    };
                                }
                                const routeKey = `${fromAirport}-${toAirport}`;
                                if (!durationArr[routeKey]) {
                                    durationArr[routeKey] = { totalDuration: [] };
                                }
                                durationArr[routeKey].departDate = departDate;
                                durationArr[routeKey].totalDuration.push(totalDuration);
                            }
                        });


                        const uniqueDepartureData = segmentWiseDepartureAirport.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.airportCode === value.airportCode
                            ))
                        );

                        const uniqueArrivalData = segmentWiseArrivalAirport.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.airportCode === value.airportCode
                            ))
                        );

                        airportFilterData[segmentIndex] = {
                            departure: uniqueDepartureData,
                            arrival: uniqueArrivalData
                        };
                    });


                    if (Object.keys(durationArr)?.length) {
                        let activeStopData = [];
                        Object.keys(durationArr)?.map((airports, index) => {
                            let totalDuration = durationArr?.[airports]?.totalDuration;
                            // Handle empty arrays and same values to prevent RangeError
                            if (totalDuration.length === 0) {
                                durationAirportData[airports] = {
                                    minMaxSetValue: [0, 100],
                                    duration: [50]
                                }
                            } else if (Math.min(...totalDuration) === Math.max(...totalDuration)) {
                                const sameValue = Math.max(...totalDuration);
                                durationAirportData[airports] = {
                                    minMaxSetValue: [Math.max(0, sameValue - 1), sameValue],
                                    duration: [sameValue]
                                }
                            } else {
                                durationAirportData[airports] = {
                                    minMaxSetValue: [Math.min(...totalDuration), Math.max(...totalDuration)],
                                    duration: [Math.max(...totalDuration)]
                                }
                            }
                            durationAirportData[airports].departDate = durationArr?.[airports]?.departDate;
                            activeStopData.push({
                                departDate: durationArr?.[airports]?.departDate,
                                title: airports,
                                active: index === 0,
                                index: index + 1
                            })

                        })
                        setActiveStops(activeStopData)
                    }
                    setMultiCityDurationValues(durationAirportData);
                    setMultiCityDepartureTimeFilter(timeFilterData);

                } else {
                    const departureTimings = [];
                    const returnTimings = [];
                    let departFlightData = [];
                    let departureAllAriport = [];
                    let arrivalAllAriport = [];
                    let returnDepartureAirport = [];
                    let returnArrivalAirport = [];

                    original_flight_data?.forEach((flights) => {
                        let isDeparture = true;
                        let departureDuration = 0;
                        let returnDuration = 0;

                        const departureFlights = [];
                        const returnFlights = [];
                        flights?.segments.forEach((flight, index) => {
                            const { connectingTime = 0, duration = 0, arrival } = flight;
                            const totalDuration = connectingTime + duration;

                            if (isDeparture) {
                                departureFlights.push(flight);
                                departureDuration += totalDuration;
                                if (arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                                    isDeparture = false;
                                }
                            } else {
                                returnFlights.push(flight);
                                returnDuration += totalDuration;
                            }
                        });
                        if (flights?.source === 'amadeus') {
                            if (departureFlights.length > 0) {
                                departureDuration = departureFlights[0]?.amadeusDurations || 0;
                            }
                            if (returnFlights.length > 0) {
                                returnDuration = returnFlights[0]?.amadeusDurations || 0;
                            }
                        }
                        departFlightData = departureFlights;
                        if (departureDuration > 0) {
                            departureTimings.push(departureDuration);
                        }
                        if (returnDuration > 0) {
                            returnTimings.push(returnDuration);
                        }

                        if (departureFlights?.length) {
                            departureAllAriport.push({
                                airportCode: departureFlights?.[0]?.departure?.airportCode,
                                airportName: departureFlights?.[0]?.departure.airportName,
                                active: false,
                            })

                            arrivalAllAriport.push({
                                airportCode: departureFlights?.[departureFlights?.length - 1]?.arrival.airportCode,
                                airportName: departureFlights?.[departureFlights?.length - 1]?.arrival.airportName,
                                active: false,
                            })
                        }
                        if (returnFlights?.length) {
                            returnDepartureAirport.push({
                                airportCode: returnFlights?.[0]?.departure?.airportCode,
                                airportName: returnFlights?.[0]?.departure.airportName,
                                active: false,
                            })

                            returnArrivalAirport.push({
                                airportCode: returnFlights?.[returnFlights?.length - 1]?.arrival.airportCode,
                                airportName: returnFlights?.[returnFlights?.length - 1]?.arrival.airportName,
                                active: false,
                            })
                        }
                    });


                    const getUniqueAirports = (flights, type) => {
                        const seen = new Set();
                        return flights.map(flight => {
                            if (!flight) return null;

                            const key = `${flight.airportCode}-airport`;
                            if (seen.has(key)) return null;

                            seen.add(key);
                            return {
                                airportCode: flight.airportCode,
                                airportName: flight.airportName,
                                active: false,
                            };
                        }).filter(Boolean);
                    };
                    const uniqueDepartureAirports = getUniqueAirports(departureAllAriport);
                    const uniqueArrivalAirports = getUniqueAirports(arrivalAllAriport);
                    const returnUniqueDepartureirports = getUniqueAirports(returnDepartureAirport);
                    const returnUniqueArrivalAirports = getUniqueAirports(returnArrivalAirport);

                    airportFilterData = {
                        departure: uniqueDepartureAirports,
                        arrival: uniqueArrivalAirports,
                        returnDeparture: returnUniqueDepartureirports,
                        returnArrival: returnUniqueArrivalAirports
                    }
                    // Handle empty arrays and same values to prevent RangeError
                    const returnMin = returnTimings.length > 0 ? Math.min(...returnTimings) : 0;
                    const returnMax = returnTimings.length > 0 ? Math.max(...returnTimings) : 100;
                    const departureMin = departureTimings.length > 0 ? Math.min(...departureTimings) : 0;
                    const departureMax = departureTimings.length > 0 ? Math.max(...departureTimings) : 100;

                    // Ensure min is not equal to max to prevent Range component error
                    const returnMinValue = returnMin === returnMax ? Math.max(0, returnMin - 1) : returnMin;
                    const departureMinValue = departureMin === departureMax ? Math.max(0, departureMin - 1) : departureMin;

                    setReturnDurationValues({
                        minMaxSetValue: [returnMinValue, returnMax],
                        duration: [returnMax]
                    })
                    durationData = {
                        minMaxSetValue: [departureMinValue, departureMax],
                        duration: [departureMax]
                    }
                }

            } else if (!["RETURN", "ONWARD", "COMBO"].some(type => originalFlightData.some(item => item.tripType === type))) {
                const uniqueTripTypes = [...new Set(originalFlightData.map(f => f?.tripType))].sort();
                const flightOptions = [];
                for (let i = 0; i < uniqueTripTypes.length; i++) {
                    const type = uniqueTripTypes[i];
                    const flight = originalFlightData.find(f => f?.tripType === type);
                    if (!flight) continue;
                    const segments = flight.segments || [];
                    const firstSegment = segments[0] || {};
                    const lastSegment = segments[segments.length - 1] || {};
                    flightOptions.push({
                        type,
                        fromAirport: firstSegment.departure,
                        arrivalAirport: lastSegment.arrival,
                        flightDHTRId: firstSegment?.flightDHTRId,
                        airlineData: {
                            flightCode: firstSegment.flightCode,
                            flightEquipmentType: firstSegment.flightEquipmentType,
                            flightNumber: firstSegment.flightNumber,
                            flightName: firstSegment.flightName,
                        },
                        routingId: flight?.routingId,
                        priceId: flight?.pricing?.[0],
                        active: (i === 0),
                        selected: false
                    });
                }
                setMultiFlightOptionsData(flightOptions);
                setSelectedMultiflights(flightOptions)
                setRoundTripDomestic(prevState => ({
                    ...prevState,
                    status: true,
                    active: 1
                }));
                original_flight_data = original_flight_data.filter(
                    flight => flight?.tripType === uniqueTripTypes[0]
                );
            } else {
                const getUniqueAirports = (flights, type) => {
                    const seen = new Set();
                    return flights.map(flight => {

                        const airport = type === 'departure'
                            ? flight?.segments[0]?.departure
                            : flight?.segments[flight?.segments.length - 1]?.arrival;

                        if (!airport) return null;

                        const key = `${airport.airportCode}-airport`;
                        if (seen.has(key)) return null;

                        seen.add(key);
                        return {
                            airportCode: airport.airportCode,
                            airportName: airport.airportName,
                            active: false,
                        };
                    }).filter(Boolean);
                };
                const uniqueDepartureAirports = getUniqueAirports(original_flight_data, 'departure');
                const uniqueArrivalAirports = getUniqueAirports(original_flight_data, 'arrival');
                airportFilterData = {
                    departure: uniqueDepartureAirports,
                    arrival: uniqueArrivalAirports
                }
            }
            setAirportFilterData(airportFilterData)
            setDurationValues(durationData)
            setFlightData([...original_flight_data])
        }
    }, [originalFlightData])

    useEffect(() => {
        if (!originalFlightData?.length) {
            setAirlineFilterData([]);
            return;
        }
        const list = filterAirlineFn(originalFlightData);
        setAirlineFilterData(prev => {
            const checkedMap = new Map((prev || []).map(a => [a.flightCode, a.checked]));
            return list.map(a => ({ ...a, checked: checkedMap.get(a.flightCode) || false }));
        });
    }, [originalFlightData])

    useEffect(() => {
        if (!roundTripDomestic?.status || !originalFlightData?.length) return;
        const hasSingle = originalFlightData.some(f => f?.tripType !== 'COMBO');
        const hasCombo = originalFlightData.some(f => f?.tripType === 'COMBO');
        if (roundTripDomestic?.active === 1 && !hasSingle && hasCombo) {
            setRoundTripDomestic(prev => ({ ...prev, active: 2 }));
        } else if (roundTripDomestic?.active === 2 && !hasCombo && hasSingle) {
            setRoundTripDomestic(prev => ({ ...prev, active: 1 }));
        }
    }, [originalFlightData, roundTripDomestic?.status, roundTripDomestic?.active])

    useEffect(() => {
        if (!roundTripDomestic?.status || !originalFlightData?.length) return;
        const checkedCodes = airlineFilterData.filter(a => a.checked).map(a => a.flightCode);
        if (!checkedCodes.length) return;
        const viewHasAirline = (view) => {
            const flights = view === 1
                ? originalFlightData.filter(f => f?.tripType !== 'COMBO')
                : originalFlightData.filter(f => f?.tripType === 'COMBO');
            return flights.some(f => f?.segments?.some(s => checkedCodes.includes(s?.flightCode)));
        };
        const currentActive = roundTripDomestic?.active;
        if (!viewHasAirline(currentActive)) {
            const otherView = currentActive === 1 ? 2 : 1;
            if (viewHasAirline(otherView)) {
                setRoundTripDomestic(prev => ({ ...prev, active: otherView }));
            }
        }
    }, [airlineFilterData, originalFlightData, roundTripDomestic?.status, roundTripDomestic?.active])

    useEffect(() => {
        if (nearbyToggleSkipFirst.current) {
            nearbyToggleSkipFirst.current = false;
            return;
        }
        if (!rawFlightsRef.current?.length) {
            return;
        }
        // filter the flights already in memory — no search loader, this is not a re-search
        const raw = rawFlightsRef.current || [];
        const shown = queryParams?.nearByAirport === 'false' ? checkNearByAirportFn(raw) : raw;
        setOriginalFlightData(applyMarkupToFlightsFn(shown, totalMarkupAmount));
    }, [queryParams?.nearByAirport])

    // "Direct Flights" in the header is the same filter as the sidebar's "Non Stop"
    // stop option, so drive that option from the URL param. The main filter effect
    // watches totalAirportStops, so the list re-filters without a new search.
    useEffect(() => {
        const directOnly = queryParams?.directFlight === 'true';
        setTotalAirportStops((prevData) =>
            prevData.map((stop) => (
                stop.value === 0
                    ? { ...stop, checked: directOnly }
                    : { ...stop, checked: directOnly ? false : stop.checked }
            ))
        );
    }, [queryParams?.directFlight])

    const filterAirlineFn = (flightsData) => {
        const flightMap = new Map();
        flightsData.forEach(flight => {
            const totalPrice = flight?.pricing?.[0]?.totalPrice;
            const seenInFlight = new Set();
            flight.segments.forEach((segment) => {
                const flightName = segment.flightName;
                const flightCode = segment.flightCode;
                if (!flightCode) return;
                if (flightMap.has(flightCode)) {
                    let flightData = flightMap.get(flightCode);
                    if (totalPrice != null && totalPrice < flightData.totalPrice) {
                        flightData.totalPrice = totalPrice;
                    }
                    if (!seenInFlight.has(flightCode)) {
                        flightData.count += 1;
                    }
                } else {
                    flightMap.set(flightCode, {
                        flightName: flightName,
                        totalPrice: totalPrice != null ? totalPrice : Infinity,
                        count: 1
                    });
                }
                seenInFlight.add(flightCode);
            });
        });
        return Array.from(flightMap, ([flightCode, { flightName, totalPrice, count }]) => {
            if (count === 0) {
                return null;
            }
            return {
                flightName,
                flightCode,
                totalPrice,
                count,
                show: true,
                checked: false
            };
        }).filter(Boolean)
            .sort((a, b) => a.flightName.localeCompare(b.flightName))
            .map((item, index) => ({
                ...item,
                index
            }));
    }

    const onclickFastestCheapestFn = (value) => {
        setFastestFlight(value);
    }

    const filterByTimeFn = (data, timeRanges) => {
        return data.filter(item => {
            const departureTime = new Date(item.segments[0].departure.departureTime);
            const hours = departureTime.getHours();
            return timeRanges.some(range => {
                const [start, end] = range.split('-').map(Number);
                return hours >= start && hours < end;
            });
        });
    };

    const filterByTimeReturnFn = (data, timRanges) => {
        return data.filter(item => {
            const returnSegmentIndex = item?.segments?.findIndex(segment => segment?.departure?.airportCode === queryParams?.toAirport || segment?.neareastFromAirport === queryParams?.toAirport);
            if (returnSegmentIndex === -1) return false;
            const departureTime = new Date(item.segments[returnSegmentIndex].departure.departureTime);
            const hours = departureTime.getHours();
            return timRanges.some(range => {
                const [start, end] = range.split('-').map(Number);
                return hours >= start && hours < end;
            });
        });
    }
    const fetchFlightDataBackup = async () => {
        if (queryParams) {
            setLoading(true);
            let response;
            try {
                const payloadFlight = flightPayloadFn(queryParams);
                payloadFlight.activeCurrency = agentActiveCurrency;
                response = await ApiCall('POST', '/flights/search-flights', payloadFlight, { authorization: userToken });
                if (response?.status === 200 && response?.data?.statusCode === 200) {
                    setOriginalFlightData(applyMarkupToFlightsFn(response?.data?.data, totalMarkupAmount));
                }
            } catch (err) {
                console.log('Error fetching flight data', err);
            } finally {
                if (!response?.data?.data?.length) {
                    setLoading(false);
                }
            }
        }
    };

    const fetchDatesFlights = async () => {
        if (queryParams && queryParams?.type !== 'combo') {
            // setIsLoadingDate(true)
            const payload = flightDatesPayloadFn(queryParams)
            const flightResponse = await ApiCall('POST', `/flights/get-flights-dates`, payload, { authorization: userToken });
            if (flightResponse?.data?.data?.results?.length) {
                const data = flightResponse.data.data;
                const tripRange = data?.range || 0;
                const results = data?.results;
                const today = new Date();
                const numDays = 365;
                const slider = [];
                for (let i = 0; i < numDays; i++) {
                    const start = new Date(today);
                    start.setDate(today.getDate() + i);
                    let end = null;
                    let endStr = null;
                    if (tripRange > 0) {
                        end = new Date(start);
                        end.setDate(start.getDate() + tripRange);
                        endStr = end.toISOString().split("T")[0];
                    }
                    const startStr = start.toISOString().split("T")[0];
                    let match = null;
                    if (tripRange > 0) {
                        match = results.find(item => item.depDate === startStr && item.arrDate === endStr);
                    } else {
                        match = results.find(item => item.depDate === startStr);
                    }
                    slider?.push({
                        depDate: startStr,
                        showLoading: false,
                        arrDate: tripRange > 0 ? endStr : null,
                        price: match ? match.price : null,
                        displayString: tripRange > 0
                            ? `${formatDate(start, false)} - ${formatDate(end, false)}`
                            : `${formatDate(start, true)}`
                    });
                }
                setDateFilterData(slider);
                const selectedIndex = slider?.findIndex(item =>
                    tripRange > 0
                        ? item.depDate === queryParams?.departDate && item.arrDate === queryParams?.returnDate
                        : item.depDate === queryParams?.departDate
                );
                setSelectedDate(selectedIndex >= 0 ? selectedIndex : 0);
            } else {
                setDateFilterData((prev) => prev?.map(item => {
                    return { ...item, showLoading: false }
                }))
            }
        }
    }

    const fetchFlightData = async () => {
        if (queryParams) {
            const sources = airlineCompanyList || [];
            // const sources = ['aljazeera'] || [];
            const payloadFlight = flightPayloadFn(queryParams);
            payloadFlight.activeCurrency = "AED";
            setShowLoadingAfterLoad(true);
            setLoading(true);
            setMainLoading(true);
            const processedFlightIds = new Set();
            const promises = sources.map((source) => {
                const updatedPayload = { ...payloadFlight, source };
                return ApiCall('POST', '/flights/search-flights', updatedPayload, { authorization: userToken })
                    .then((response) => {
                        if (response?.status === 200 && response?.data?.statusCode === 200 && response?.data?.data?.length) {
                            return response?.data?.data || [];
                        } else {
                            console.error(`Source ${source} returned invalid response`);
                            return Promise.reject(`Source ${source} returned no valid data`);
                        }
                    })
                    .catch((err) => {
                        console.error(`Error fetching from source ${source}:`, err);
                        return Promise.reject(err);
                    });
            });
            try {
                const firstResponse = await Promise.any(promises);
                let uniqueFirstFlights = Array.isArray(firstResponse) ? firstResponse : [];
                const firstBatchRaw = Array.isArray(uniqueFirstFlights) ? [...uniqueFirstFlights] : [];

                if (queryParams?.nearByAirport === 'false') {
                    uniqueFirstFlights = checkNearByAirportFn(uniqueFirstFlights);
                }

                // Set initial data for faster UI update
                setOriginalFlightData(applyMarkupToFlightsFn(uniqueFirstFlights, totalMarkupAmount));
                if (uniqueFirstFlights?.length) {
                    setMainLoading(false);
                    setShowLoadingAfterLoad(true);
                }

                const remainingResponses = await Promise.allSettled(promises);
                const additionalData = remainingResponses
                    .filter(result => result.status === 'fulfilled' && Array.isArray(result.value) && result.value.length > 0)
                    .flatMap(result => result.value);
                const allResponses = [...uniqueFirstFlights, ...additionalData];

                // Find fly Dubai data from flight objects
                let flyDubaiData = allResponses.find(flight => flight?.source === 'fly-dubai');
                if (flyDubaiData) {
                    setCookie("dahr--fly_dubaiToken", flyDubaiData?.token);
                    // sessionStorage.setItem("fly-dubai-Combination", JSON.stringify(flyDubaiData?.flightCombinability));
                }

                let filteredFlights = await getUniqueFlights(allResponses);
                rawFlightsRef.current = await getUniqueFlights([...firstBatchRaw, ...additionalData]);
                let lowestPrice;
                if (payloadFlight?.trip?.length > 1) {
                    const comboPrices = filteredFlights
                        .filter(f => f.tripType === "COMBO")
                        .map(f => f.pricing?.[0]?.totalPrice || Infinity);
                    const onwardPrices = filteredFlights
                        .filter(f => f.tripType === "ONWARD")
                        .map(f => f.pricing?.[0]?.totalPrice)
                        .filter(Boolean);
                    const returnPrices = filteredFlights
                        .filter(f => f.tripType === "RETURN")
                        .map(f => f.pricing?.[0]?.totalPrice)
                        .filter(Boolean);
                    const combinedPrice =
                        onwardPrices.length && returnPrices.length
                            ? [Math.min(...onwardPrices) + Math.min(...returnPrices)]
                            : [];
                    lowestPrice = Math.min(...comboPrices, ...combinedPrice);
                } else {
                    lowestPrice = Math.min(
                        ...filteredFlights
                            .filter(f => f.tripType === "ONWARD")
                            .map(f => f.pricing?.[0]?.totalPrice || Infinity)
                    );
                }
                if (queryParams?.type !== 'combo') {
                    const saveLowerPrice = await ApiCall('POST', `/flights/set-flights-dates`,
                        {
                            trip: payloadFlight?.trip,
                            lowestPrice,
                            currency: 'AED',
                            passenger: parseInt(queryParams?.adult) + parseInt(queryParams?.child) + parseInt(queryParams?.infant)
                        }, { authorization: userToken });
                }
                if (queryParams?.nearByAirport === 'false') {
                    filteredFlights = checkNearByAirportFn(filteredFlights);
                }
                setOriginalFlightData(applyMarkupToFlightsFn(filteredFlights, totalMarkupAmount));
                setFilterHideShow({
                    departure: true,
                    returnDeparture: true,
                    multiCityDeparture: true,
                    multiCityStops: true,
                    stops: true,
                    returnstops: true,
                    price: true,
                    airlines: true,
                    durations: true,
                    airport: true,
                });
                hasRun.current = true
                // Reset loading states after processing
                setMainLoading(false);
                setFirstonLoad(false);
                setLoading(false);
                setShowLoadingAfterLoad(false);
                await fetchDatesFlights()
            } catch (err) {
                console.error('Error in fetchFlightData:', err);
                setOriginalFlightData([]);
                setMainLoading(false);
                setFirstonLoad(false);
                setShowLoadingAfterLoad(false);
                setLoading(false);
            }
        }
    };

    const checkNearByAirportFn = (filteredFlight = []) => {
        // Check if we have mixed trip types (RETURN, ONWARD, COMBO)
        let filteredFlights = filteredFlight;

        const hasReturn = filteredFlights.some(item => item.tripType === 'RETURN');
        const hasOnward = filteredFlights.some(item => item.tripType === 'ONWARD');
        const hasCombo = filteredFlights.some(item => item.tripType === 'COMBO');

        if (hasReturn && hasOnward && hasCombo) {
            // Handle mixed trip types scenario
            filteredFlights = filteredFlights?.filter((filterData) => {
                const segments = filterData?.segments;
                if (!segments || segments.length === 0) return false;
                const firstFlightAirport = segments[0]?.departure?.airportCode;
                const lastFlightAirport = segments[segments.length - 1]?.arrival?.airportCode;

                if (filterData?.tripType === 'ONWARD') {
                    return firstFlightAirport === queryParams?.fromAirport && lastFlightAirport === queryParams?.toAirport;
                } else if (filterData?.tripType === 'RETURN') {
                    return firstFlightAirport === queryParams?.toAirport && lastFlightAirport === queryParams?.fromAirport;
                } else if (filterData?.tripType === 'COMBO') {
                    // Handle COMBO type in mixed scenario
                    if (Array.isArray(queryParams?.segments)) {
                        const segments = queryParams?.segments || [];
                        return segments.every((segment, index) => {
                            const { fromAirport, toAirport, departDate } = segment;
                            const matched = [];
                            let collecting = false;
                            for (const flight of filterData?.segments || []) {
                                const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                                if (!collecting && flight?.departure?.airportCode === fromAirport && flightDepartureDate === departDate) {
                                    collecting = true;
                                }
                                if (collecting) {
                                    matched.push(flight);
                                    if (flight?.arrival?.airportCode === toAirport) break;
                                }
                            }
                            const firstFlight = matched[0];
                            const lastFlight = matched[matched.length - 1];
                            return (
                                firstFlight?.departure?.airportCode === fromAirport &&
                                lastFlight?.arrival?.airportCode === toAirport
                            );
                        });
                    } else {
                        const departureFlights = [];
                        const returnFlights = [];
                        let isDeparture = true;

                        filterData?.segments.forEach((flight) => {
                            const { arrival, departure } = flight;
                            if (isDeparture) {
                                departureFlights.push(flight);
                                if (arrival.airportCode === queryParams?.toAirport) {
                                    isDeparture = false;
                                }
                            } else {
                                returnFlights.push(flight);
                            }
                        });

                        const firstDepartureAirport = departureFlights[0]?.departure?.airportCode;
                        const lastDepartureAirport = departureFlights[departureFlights.length - 1]?.arrival?.airportCode;
                        const firstReturnAirport = returnFlights[0]?.departure?.airportCode;
                        const lastReturnAirport = returnFlights[returnFlights.length - 1]?.arrival?.airportCode;
                        const isDepartureValid = firstDepartureAirport === queryParams?.fromAirport && lastDepartureAirport === queryParams?.toAirport;
                        const isReturnValid = firstReturnAirport === queryParams?.toAirport && lastReturnAirport === queryParams?.fromAirport;
                        return isDepartureValid && isReturnValid;
                    }
                }
                return false;
            });
        } else if (["RETURN", "ONWARD"].every(type => filteredFlights.some(item => item.tripType === type))) {
            filteredFlights = filteredFlights?.filter((filterData) => {
                const segments = filterData?.segments;
                if (!segments || segments.length === 0) return false;
                const firstFlightAirport = segments[0]?.departure?.airportCode;
                const lastFlightAirport = segments[segments.length - 1]?.arrival?.airportCode;
                if (filterData?.tripType === 'ONWARD') {
                    return firstFlightAirport === queryParams?.fromAirport && lastFlightAirport === queryParams?.toAirport;
                } else if (filterData?.tripType === 'RETURN') {
                    return firstFlightAirport === queryParams?.toAirport && lastFlightAirport === queryParams?.fromAirport;
                }
            });
        } else if (filteredFlights.some(item => item.tripType === 'COMBO') && filteredFlights.some(item => !['RETURN', 'ONWARD', 'COMBO'].includes(item.tripType))) {
            if (Array.isArray(queryParams?.segments)) {
                filteredFlights = filteredFlights?.filter((flights) => {
                    if (flights?.tripType === 'COMBO') {
                        const segments = queryParams?.segments || [];
                        return segments.every((segment, index) => {
                            const { fromAirport, toAirport, departDate } = segment;
                            const matched = [];
                            let collecting = false;
                            for (const flight of flights?.segments || []) {
                                const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                                if (!collecting && flight?.departure?.airportCode === fromAirport && flightDepartureDate === departDate) {
                                    collecting = true;
                                }
                                if (collecting) {
                                    matched.push(flight);
                                    if (flight?.arrival?.airportCode === toAirport) break;
                                }
                            }
                            const firstFlight = matched[0];
                            const lastFlight = matched[matched.length - 1];
                            return (
                                firstFlight?.departure?.airportCode === fromAirport &&
                                lastFlight?.arrival?.airportCode === toAirport
                            );
                        });
                    } else {
                        return flights
                    }
                });
            } else {
                filteredFlights = filteredFlights?.map((filterData) => {
                    const departureFlights = [];
                    const returnFlights = [];
                    let isDeparture = true;

                    if (filterData?.tripType === 'COMBO') {
                        filterData?.segments.forEach((flight) => {
                            const { arrival, departure } = flight;
                            if (isDeparture) {
                                departureFlights.push(flight);
                                if (arrival.airportCode === queryParams?.toAirport) {
                                    isDeparture = false;
                                }
                            } else {
                                returnFlights.push(flight);
                            }
                        });
                        const firstDepartureAirport = departureFlights[0]?.departure?.airportCode;
                        const lastDepartureAirport = departureFlights[departureFlights.length - 1]?.arrival?.airportCode;
                        const firstReturnAirport = returnFlights[0]?.departure?.airportCode;
                        const lastReturnAirport = returnFlights[returnFlights.length - 1]?.arrival?.airportCode;
                        const isDepartureValid = firstDepartureAirport === queryParams?.fromAirport && lastDepartureAirport === queryParams?.toAirport;
                        const isReturnValid = firstReturnAirport === queryParams?.toAirport && lastReturnAirport === queryParams?.fromAirport;
                        if (isDepartureValid && isReturnValid) {
                            return filterData;
                        }
                        return null;
                    } else {
                        return filterData
                    }

                }).filter(Boolean);
            }
        } else if (["COMBO"].every(type => filteredFlights.some(item => item.tripType === type))) {
            if (Array.isArray(queryParams?.segments)) {
                filteredFlights = filteredFlights?.filter((flights) => {
                    const segments = queryParams?.segments || [];
                    return segments.every((segment, index) => {
                        const { fromAirport, toAirport, departDate } = segment;
                        const matched = [];
                        let collecting = false;
                        for (const flight of flights?.segments || []) {
                            const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                            if (!collecting && flight?.departure?.airportCode === fromAirport && flightDepartureDate === departDate) {
                                collecting = true;
                            }
                            if (collecting) {
                                matched.push(flight);
                                if (flight?.arrival?.airportCode === toAirport) break;
                            }
                        }
                        const firstFlight = matched[0];
                        const lastFlight = matched[matched.length - 1];
                        return (
                            firstFlight?.departure?.airportCode === fromAirport &&
                            lastFlight?.arrival?.airportCode === toAirport
                        );
                    });
                });

            } else {
                filteredFlights = filteredFlights?.map((filterData) => {
                    const departureFlights = [];
                    const returnFlights = [];
                    let isDeparture = true;

                    filterData?.segments.forEach((flight) => {
                        const { arrival, departure } = flight;
                        if (isDeparture) {
                            departureFlights.push(flight);
                            if (arrival.airportCode === queryParams?.toAirport) {
                                isDeparture = false;
                            }
                        } else {
                            returnFlights.push(flight);
                        }
                    });

                    const firstDepartureAirport = departureFlights[0]?.departure?.airportCode;
                    const lastDepartureAirport = departureFlights[departureFlights.length - 1]?.arrival?.airportCode;
                    const firstReturnAirport = returnFlights[0]?.departure?.airportCode;
                    const lastReturnAirport = returnFlights[returnFlights.length - 1]?.arrival?.airportCode;
                    const isDepartureValid = firstDepartureAirport === queryParams?.fromAirport && lastDepartureAirport === queryParams?.toAirport;
                    const isReturnValid = firstReturnAirport === queryParams?.toAirport && lastReturnAirport === queryParams?.fromAirport;
                    if (isDepartureValid && isReturnValid) {
                        return filterData;
                    }
                    return null;
                }).filter(Boolean);
            }
        } else if (!["RETURN", "ONWARD", "COMBO"].some(type => filteredFlights.some(item => item.tripType === type))) {
            let filterNewData = [];
            const uniqueTripTypes = [...new Set(filteredFlights.map(f => f?.tripType))].sort();
            for (let i = 0; i < uniqueTripTypes.length; i++) {
                let queryParamsData = queryParams?.segments?.[i];
                let fromAirport = queryParamsData?.fromAirport;
                let toAirport = queryParamsData?.toAirport;
                const type = uniqueTripTypes[i];
                const flightData = filteredFlights.filter(f => f?.tripType === type);
                if (flightData?.length) {
                    flightData?.map((flight) => {
                        const segments = flight.segments || [];
                        const firstSegment = segments[0] || {};
                        const lastSegment = segments[segments.length - 1] || {};
                        if (firstSegment?.departure?.airportCode === fromAirport && lastSegment?.arrival?.airportCode === toAirport) {
                            filterNewData.push(flight)
                        }
                    })
                }
            }
            filteredFlights = filterNewData
            // console.log("tripJack Only")
        } else {
            filteredFlights = filteredFlights?.filter((filterData) => {
                const segments = filterData?.segments;
                if (!segments || segments.length === 0) return false;
                const firstFlightAirport = segments[0]?.departure?.airportCode;
                const lastFlightAirport = segments[segments.length - 1]?.arrival?.airportCode;
                return firstFlightAirport === queryParams?.fromAirport && lastFlightAirport === queryParams?.toAirport;
            });
        }

        return filteredFlights;
    }

    function normalizeTime(t) {
        return new Date(t)?.toISOString()?.slice(0, 16);
    }

    const getUniqueFlights = async (data) => {
        const grouped = new Map();
        data.forEach(flight => {
            if (!flight.pricing || flight.pricing.length === 0) return;
            const segmentSignature = flight.segments.map(seg =>
                [
                    seg?.departure?.airportCode,
                    seg?.arrival?.airportCode,
                    seg?.flightCode,
                    seg?.flightNumber,
                    normalizeTime(seg?.departure?.departureTime),
                    normalizeTime(seg?.arrival?.arrivalTime)
                ].join('|')
            ).join('||');

            const key = flight?.source?.toLowerCase() === 'fly-dubai' ? `${segmentSignature}|${flight?.lfId}` : `${segmentSignature}`;

            if (!grouped.has(key)) {
                grouped.set(key, []);
            }
            grouped.get(key).push(flight);
        });

        const uniqueFlights = [];
        grouped.forEach(group => {
            const vendor = group[0].source?.toLowerCase();
            const groupedItems = [];
            const groupedItemSeen = new Set();
            group.forEach((item) => {
                const itemSignature = String(item?.flightDHTRId || "");
                if (itemSignature && groupedItemSeen.has(itemSignature)) return;
                if (itemSignature) groupedItemSeen.add(itemSignature);
                groupedItems.push({ ...item });
            });

            const alternativesFor = (representative) => {
                const repId = String(representative?.flightDHTRId || "");
                return groupedItems.filter((item) => String(item?.flightDHTRId || "") !== repId);
            };

            if (vendor === "fly-dubai") {
                const baseFlight = { ...group[0], pricing: [...group[0]?.pricing] };
                for (let i = 1; i < group.length; i++) {
                    baseFlight?.pricing.push(...group[i]?.pricing);
                }
                baseFlight.pricing = baseFlight?.pricing?.filter(
                    (p, index, arr) =>
                        index ===
                        arr.findIndex(
                            (pp) =>
                                pp?.fareIdentifier === p?.fareIdentifier &&
                                pp?.totalPrice === p?.totalPrice
                        )
                );
                const min = Math.min(
                    ...baseFlight.pricing.map((p) => Number(p?.totalPrice) || 0)
                );
                baseFlight.pricing.forEach(
                    (p) => (p.isLowest = Number(p?.totalPrice) === min)
                );
                uniqueFlights.push({
                    ...baseFlight,
                    uniqueGroup: alternativesFor(baseFlight)
                });
            } else {
                const cheapest = groupedItems.reduce((best, cur) => {
                    const bestPrice = parseFloat(best?.pricing?.[0]?.totalPrice) || 0;
                    const curPrice = parseFloat(cur?.pricing?.[0]?.totalPrice) || 0;
                    return curPrice < bestPrice ? cur : best;
                }, groupedItems[0]);
                uniqueFlights.push({
                    ...cheapest,
                    uniqueGroup: alternativesFor(cheapest)
                });
            }
        });

        return uniqueFlights;
    };




    const selectMultiFlightFn = (flights, pricing) => {
            // console.log(flights, 'flights')
            // console.log(pricing, 'pricing')
            // console.log(selectedMultiflights, 'selectedMultiflights')

        if (flights?.source === 'fly-dubai' && flights?.tripType === 'ONWARD') {
            const updatedMultiflights = selectedMultiflights.map(flight => {
                if (flight?.type === 'RETURN') {
                    return { ...flight, priceId: undefined };
                }
                return flight;
            });
            // console.log(updatedMultiflights, 'updatedMultiflights')
            setSelectedMultiflights(updatedMultiflights);
        }
        const multiFlightData = [...selectedMultiflights];
        const findActiveIndex = multiFlightData.findIndex(flights => flights.active);
        const flightSegment = flights?.segments?.[0] || {}; // Handle missing segments
        const lastSegment = flights?.segments?.[flights?.segments?.length - 1] || {};

        // Determine trip type based on current selection
        let tripType = 'UNKNOWN';
        if (roundTripDomestic?.status && roundTripDomestic?.active === 1) {
            // Use the flight's actual tripType instead of array length
            tripType = flights?.tripType || 'UNKNOWN';
        } else {
            tripType = 'SINGLE';
        }

        const newFlightData = {
            segment: flights?.segments,
            routingId: flights?.routingId,
            totalDurations: flights?.totalDuration,
            journeyKey: flights?.journeyKey,
            flightDHTRId: flights?.flightDHTRId,
            priceId: pricing,
            source: flights?.source,
            selected: true,
            fromAirport: flightSegment?.departure,
            arrivalAirport: lastSegment?.arrival,
            airlineData: {
                flightCode: flightSegment?.flightCode,
                flightEquipmentType: flightSegment?.flightEquipmentType,
                flightNumber: flightSegment?.flightNumber,
                flightName: flightSegment?.flightName,
            },
            type: tripType,
            bundleData: flights?.source === 'air-arabia' ? pricing : null
        };

        if (findActiveIndex < 0) {
            multiFlightData.push(newFlightData)
        } else {
            multiFlightData[findActiveIndex] = { ...multiFlightData[findActiveIndex], ...newFlightData };
        }
        setSelectedMultiflights(multiFlightData)

        // Add bundle selection for Air Arabia if bundle is present in pricing
        if (flights?.source === 'air-arabia' && pricing?.bundleData) {
            addBundleSelection(pricing.bundleData, tripType);
        }
    }


    /*    console.log(selectedMultiflights, 'selectedMultiflights')*/

    const fetchHeaderData = async () => {
        if (queryParams) {
            setIsHeaderAirportsLoading(true);
            // console.log(queryParams, 'queryParams')
            let airportQuery = [queryParams?.fromAirport, queryParams?.toAirport];
            let airlineQuery = queryParams?.airlineCode ? queryParams?.airlineCode?.split(',') : []

            if (Array.isArray(queryParams?.segments)) {
                airportQuery = Array.from(
                    new Set(
                        queryParams?.segments?.flatMap(({ fromAirport, toAirport }) => [fromAirport, toAirport])
                    )
                ) || [];
            }

            try {
                const response = await ApiCall('POST', '/flights/header-airports', {
                    airports: airportQuery,
                    airlines: airlineQuery
                }, { authorization: userToken });
                if (response?.status === 200 && response?.data?.statusCode === 200) {
                    setHeaderAirportData(response?.data?.data?.airportData)
                    setHeaderAirlineData(response?.data?.data?.airlineData)
                }
                setIsHeaderAirportsLoading(false);
            } catch (err) {
                console.log('Error fetching flight data', err);
                setIsHeaderAirportsLoading(false);
            }
        } else {
            setIsHeaderAirportsLoading(false);
        }
    };

    const filterChangeFn = debounce(() => {
        if (originalFlightData?.length) {
            let originalFlights = [...originalFlightData];

            if (fastestFlight) {
                originalFlights = originalFlights.sort((a, b) => {
                    const durDiff = (a?.totalDuration ?? 0) - (b?.totalDuration ?? 0);
                    if (durDiff !== 0) return durDiff;
                    return (a?.pricing?.[0]?.totalPrice ?? 0) - (b?.pricing?.[0]?.totalPrice ?? 0);
                });
            } else {
                originalFlights = originalFlights.sort((a, b) => a?.pricing?.[0]?.totalPrice - b?.pricing?.[0]?.totalPrice);
            }

            if (roundTripDomestic?.status) {
                if (roundTripDomestic?.active === 1) {
                    originalFlights = originalFlights.filter(flight => flight?.tripType !== 'COMBO')
                    if (multiFlightOptionsData?.length > 1) {
                        let activeFlightData = multiFlightOptionsData?.find(flight => flight.active);
                        if (activeFlightData) {
                            if (activeFlightData?.type === "ONWARD") {
                                originalFlights = originalFlights.filter(flight => flight?.tripType === 'ONWARD')
                            } else if (activeFlightData?.type === "RETURN") {
                                originalFlights = originalFlights.filter(flight => flight?.tripType === 'RETURN')
                            } else {
                                originalFlights = originalFlights.filter(flight => flight?.tripType === activeFlightData?.type)
                            }
                        }
                    }
                } else if (roundTripDomestic?.active === 2) {
                    originalFlights = originalFlights.filter(flight => flight?.tripType === 'COMBO')
                }
            }

            let filteredData = originalFlights.filter(item => {
                const totalPrice = item.pricing[0].totalPrice;
                return totalPrice >= priceRange?.minMaxPrice?.[0] && totalPrice <= priceRange?.minMaxPrice?.[1];
            });
            if (filteredData?.length) {
                const checkedFlightCodes = airlineFilterData.filter(flight => flight.checked).map(flight => flight.flightCode);
                if (checkedFlightCodes?.length) {
                    filteredData = filteredData.filter(flights => {
                        return flights?.segments?.some(seg => checkedFlightCodes.includes(seg?.flightCode))
                    });
                }
                const checkDepartureTime = departureTimeFilter.filter(timeFilter => timeFilter.checked).map(times => times.time);
                if (checkDepartureTime?.length) {
                    filteredData = filterByTimeFn(filteredData, checkDepartureTime)
                }

                if (queryParams?.returnDate && roundTripDomestic?.active !== 1) {
                    const checkReturnTime = returnDepartureTimeFilter.filter(timeFilter => timeFilter.checked).map(times => times.time);
                    if (checkReturnTime?.length) {
                        filteredData = filterByTimeReturnFn(filteredData, checkReturnTime)
                    }
                }

                if (queryParams?.segments?.length && roundTripDomestic?.active === 2) {
                    // Handle multi-city departure time filter
                    if (Object.keys(multiCityDepartureTimeFilter)?.length) {
                        Object.keys(multiCityDepartureTimeFilter).forEach(segmentIndex => {
                            const timeFilter = multiCityDepartureTimeFilter[segmentIndex];
                            if (timeFilter) {
                                const checkedTimes = timeFilter.time.filter(t => t.checked).map(t => t.time);
                                if (checkedTimes.length > 0) {
                                    filteredData = filteredData.filter(flight => {
                                        const querySegment = queryParams.segments[segmentIndex];
                                        // Chain-collecting approach for multi-city segment
                                        let matchedFlights = [];
                                        let collecting = false;
                                        for (const seg of flight.segments || []) {
                                            const flightDepartureDate = seg?.departure?.departureTime?.split("T")[0];

                                            if ((seg.departure.airportCode === querySegment.fromAirport || seg?.neareastFromAirport === queryParams?.fromAirport) && flightDepartureDate === querySegment.departDate) {
                                                collecting = true;
                                            }
                                            if (collecting) {
                                                matchedFlights.push(seg);
                                                if (seg.arrival.airportCode === querySegment.toAirport || seg?.neareastToAirport === querySegment.toAirport) {
                                                    break;
                                                }
                                            }
                                        }
                                        if (matchedFlights.length > 0) {
                                            // Optionally, you can check time filter on the first segment in the chain
                                            const departureTime = new Date(matchedFlights[0].departure.departureTime);
                                            const hours = departureTime.getHours();
                                            return checkedTimes.some(range => {
                                                const [start, end] = range.split('-').map(Number);
                                                return hours >= start && hours < end;
                                            });
                                        }
                                        return false;
                                    });
                                }
                            }
                        });
                    }

                    if (Object.keys(multiCityDurationValues)?.length) {
                        Object.keys(multiCityDurationValues).forEach(routeKey => {
                            const durationFilter = multiCityDurationValues[routeKey];
                            if (durationFilter && !durationFilter.minMaxSetValue.includes(durationFilter.duration[0] + 1)) {
                                const [fromAirport, toAirport] = routeKey.split('-');
                                filteredData = filteredData.filter(flight => {
                                    let matchedFlights = [];
                                    let collecting = false;
                                    for (const seg of flight.segments || []) {
                                        const flightDepartureDate = seg?.departure?.departureTime?.split("T")[0];

                                        if (!collecting && (seg.departure.airportCode === fromAirport || seg?.neareastFromAirport === fromAirport) && flightDepartureDate === durationFilter?.departDate) {
                                            collecting = true;
                                        }
                                        if (collecting) {
                                            matchedFlights.push(seg);
                                            if (seg.arrival.airportCode === toAirport || seg?.neareastToAirport === toAirport) {
                                                break;
                                            }
                                        }
                                    }
                                    if (matchedFlights.length > 0) {
                                        let totalDuration = matchedFlights.reduce((acc, seg) => acc + (seg.duration || 0) + (seg.connectingTime || 0), 0);
                                        if (flight.source === 'amadeus') {
                                            totalDuration = matchedFlights[0]?.amadeusDurations || 0;
                                        }
                                        const [minDuration, maxDuration] = [durationFilter.minMaxSetValue[0], durationFilter.duration[0]];
                                        return totalDuration >= minDuration && totalDuration <= maxDuration;
                                    }
                                    return false;
                                });
                            }
                        });
                    }

                    // Add active stop logic for multi-city
                    const activeStop = activeStops?.find(stop => stop.active);
                    if (activeStop) {
                        const [activeFromAirport, activeToAirport] = activeStop.title.split('-');
                        let departDate = activeStop?.departDate;
                        filteredData = filteredData.filter(flight => {
                            // Chain-collecting approach for multi-city segment
                            let matchedFlights = [];
                            let collecting = false;
                            for (const seg of flight.segments || []) {
                                const flightDepartureDate = seg?.departure?.departureTime?.split("T")[0];
                                if ((seg.departure.airportCode === activeFromAirport || seg?.neareastFromAirport === activeFromAirport) && flightDepartureDate === departDate) {
                                    collecting = true;
                                }
                                if (collecting) {
                                    matchedFlights.push(seg);
                                    if (seg.arrival.airportCode === activeToAirport || seg?.neareastToAirport === activeToAirport) {
                                        break;
                                    }
                                }
                            }
                            const checktotalAirportStops = totalAirportStops.filter(airports => airports.checked).map(totalAirport => totalAirport.value);
                            if (checktotalAirportStops.length) {
                                // Number of stops = number of segments in chain - 1
                                const stopsCount = matchedFlights.length - 1;
                                return checktotalAirportStops.includes(stopsCount);
                            }
                            // If no stop filter is selected, return all flights with a valid chain
                            return matchedFlights.length > 0;
                        });
                    }

                    if (queryParams?.nearByAirport === 'true') {

                        if (Object.keys(airportFilterData)?.length) {
                            Object.keys(airportFilterData).forEach(segmentIndex => {
                                const segmentData = airportFilterData[segmentIndex];
                                if (segmentData) {
                                    let arrivalData = segmentData?.arrival?.filter(code => code?.active)?.map(code => code?.airportCode);
                                    let departureData = segmentData?.departure?.filter(code => code?.active)?.map(code => code?.airportCode);

                                    const querySegment = queryParams.segments[segmentIndex];
                                    if (arrivalData?.length) {
                                        filteredData = filteredData.filter(flight => {
                                            let matchedFlights = [];
                                            let collecting = false;

                                            for (const seg of flight.segments || []) {
                                                const flightDepartureDate = seg?.departure?.departureTime?.split("T")[0];
                                                if (
                                                    (seg.departure.airportCode === querySegment.fromAirport ||
                                                        seg?.neareastFromAirport === querySegment.fromAirport) &&
                                                    flightDepartureDate === querySegment.departDate
                                                ) {
                                                    collecting = true;
                                                }

                                                if (collecting) {
                                                    matchedFlights.push(seg);
                                                    if (
                                                        seg.arrival.airportCode === querySegment.toAirport ||
                                                        seg?.neareastToAirport === querySegment.toAirport
                                                    ) {
                                                        break;
                                                    }
                                                }
                                            }

                                            if (matchedFlights.length > 0) {
                                                const lastArrivalAirport = matchedFlights[matchedFlights.length - 1]?.arrival?.airportCode;
                                                return arrivalData.includes(lastArrivalAirport);
                                            }

                                            return false;
                                        });
                                    }

                                    if (departureData?.length) {
                                        filteredData = filteredData.filter(flight => {
                                            let matchedFlights = [];
                                            let collecting = false;

                                            for (const seg of flight.segments || []) {
                                                const flightDepartureDate = seg?.departure?.departureTime?.split("T")[0];
                                                if (
                                                    (seg.departure.airportCode === querySegment.fromAirport ||
                                                        seg?.neareastFromAirport === querySegment.fromAirport) &&
                                                    flightDepartureDate === querySegment.departDate
                                                ) {
                                                    collecting = true;
                                                }

                                                if (collecting) {
                                                    matchedFlights.push(seg);
                                                    if (
                                                        seg.arrival.airportCode === querySegment.toAirport ||
                                                        seg?.neareastToAirport === querySegment.toAirport
                                                    ) {
                                                        break;
                                                    }
                                                }
                                            }

                                            if (matchedFlights.length > 0) {
                                                const firstDepartureAirport = matchedFlights[0]?.departure?.airportCode;
                                                return departureData.includes(firstDepartureAirport);
                                            }

                                            return false;
                                        });
                                    }
                                }
                            });
                        }

                    }
                } else {
                    const checktotalAirportStops = totalAirportStops.filter(airports => airports.checked).map(totalAirport => totalAirport.value);
                    if (checktotalAirportStops?.length) {
                        if (queryParams?.returnDate && roundTripDomestic?.active !== 1) {
                            let findActiveStop = activeStops?.find(stops => stops?.active);
                            if (findActiveStop) {
                                if (findActiveStop?.index === 1) {
                                    filteredData = filteredData.filter(item => {
                                        let airportFilterDataIndex = item?.segments?.findIndex(flights => flights?.arrival?.airportCode === queryParams?.toAirport || flights?.neareastToAirport === queryParams?.toAirport);
                                        return airportFilterDataIndex !== -1 &&
                                            (checktotalAirportStops.includes(airportFilterDataIndex) || airportFilterDataIndex >= 4);
                                    });
                                } else if (findActiveStop?.index === 2) {
                                    let [departureAirport, arrivalAirport] = findActiveStop.title.split('-');
                                    function findOneStopChains(segments, from, to) {
                                        const chains = [];
                                        for (let i = 0; i < segments.length; i++) {
                                            const first = segments[i];
                                            if (first.departure.airportCode !== from) {
                                                if (first?.neareastFromAirport !== from) {
                                                    continue;
                                                }
                                            }
                                            for (let j = 0; j < segments.length; j++) {
                                                if (i === j) continue;
                                                const second = segments[j];
                                                if (
                                                    (first.arrival.airportCode === second.departure.airportCode || first?.neareastToAirport === second.departure.airportCode || first?.neareastToAirport === second?.neareastFromAirport || first.arrival.airportCode === second?.neareastFromAirport) &&
                                                    (second.arrival.airportCode === to || second?.neareastToAirport === to) &&
                                                    new Date(first.arrival.arrivalTime) < new Date(second.departure.departureTime) // realistic connection
                                                ) {
                                                    chains.push([first, second]);
                                                }
                                            }
                                        }
                                        return chains;
                                    }
                                    filteredData = filteredData.filter(item => {
                                        const chains = findOneStopChains(item.segments, departureAirport, arrivalAirport);
                                        return (checktotalAirportStops.includes(chains.length) || chains.length >= 4);
                                    });
                                }
                            }
                        } else {
                            filteredData = filteredData.filter(item =>
                                checktotalAirportStops.includes(item.segments.length - 1) || item.segments.length - 1 >= 4
                            );
                        }
                    }

                    if (!durationValues.minMaxSetValue.includes(durationValues?.duration?.[0] + 1)) {
                        let [minDuration, maxDuration] = [durationValues.minMaxSetValue[0], durationValues.duration[0]]
                        if (queryParams?.returnDate && roundTripDomestic?.active !== 1) {
                            filteredData = filteredData.filter((flights) => {
                                let departureDuration = 0;
                                let isDeparture = true;
                                for (const flight of flights?.segments || []) {
                                    if (isDeparture) {
                                        const connectingTime = flight.connectingTime || 0;
                                        const duration = flight.duration || 0;
                                        departureDuration += connectingTime + duration;

                                        if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                                            isDeparture = false;
                                        }
                                    }
                                }
                                if (flights?.source === 'amadeus' && flights?.segments?.length > 0) {
                                    departureDuration = flights.segments[0]?.amadeusDurations || departureDuration;
                                }
                                return departureDuration >= minDuration && departureDuration <= maxDuration;
                            });
                        } else {
                            filteredData = filteredData.filter(item => item?.totalDuration >= minDuration && item?.totalDuration <= maxDuration);
                        }
                    }

                    if (!returnDurationValues.minMaxSetValue.includes(returnDurationValues?.duration?.[0] + 1)) {
                        let [minDuration, maxDuration] = [returnDurationValues.minMaxSetValue[0], returnDurationValues.duration[0]]
                        if (queryParams?.returnDate && roundTripDomestic?.active !== 1) {
                            filteredData = filteredData.filter((flights) => {
                                let returnDuration = 0;

                                // Handle COMBO flights differently
                                if (flights?.tripType === 'COMBO') {
                                    // For COMBO flights, we need to identify departure and return segments properly
                                    const segments = flights?.segments || [];
                                    let departureSegments = [];
                                    let returnSegments = [];
                                    let isDeparture = true;

                                    for (let i = 0; i < segments.length; i++) {
                                        const flight = segments[i];
                                        if (isDeparture) {
                                            departureSegments.push(flight);
                                            // Check if this is the last departure segment
                                            if (i < segments.length - 1) {
                                                if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                                                    isDeparture = false;
                                                }
                                            }
                                        } else {
                                            returnSegments.push(flight);
                                        }
                                    }

                                    // Calculate return duration
                                    returnSegments.forEach((flight) => {
                                        const connectingTime = flight.connectingTime || 0;
                                        const duration = flight.duration || 0;
                                        returnDuration += connectingTime + duration;
                                    });
                                    if (flights?.source === 'amadeus') {
                                        returnDuration = returnSegments?.[0]?.amadeusDurations || 0
                                    }
                                } else {
                                    // Original logic for non-COMBO flights
                                    const returnFlights = [];
                                    let isDeparture = true;
                                    for (const flight of flights?.segments) {
                                        if (isDeparture) {
                                            if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                                                isDeparture = false;
                                            }
                                        } else {
                                            returnFlights.push(flight);
                                        }
                                    }
                                    if (returnFlights?.length) {
                                        returnFlights?.map((flight) => {
                                            let connectingtime = flight?.connectingTime || 0;
                                            let duration = flight?.duration || 0;
                                            returnDuration += (connectingtime + duration);
                                        })
                                        if (flights?.source === 'amadeus') {
                                            returnDuration = returnFlights?.[0]?.amadeusDurations || 0
                                        }
                                    }
                                }

                                return returnDuration >= minDuration && returnDuration <= maxDuration;
                            });
                        }
                    }


                    if (queryParams?.nearByAirport === 'true') {
                        if (roundTripDomestic?.active === 1) {
                            if (multiFlightOptionsData?.length > 1) {
                                let activeFlightData = multiFlightOptionsData?.find(flight => flight.active);
                                if (activeFlightData) {
                                    if (activeFlightData?.type === "ONWARD") {
                                        if (airportFilterData?.departure && airportFilterData?.departure?.length) {
                                            let filterActiveAirport = airportFilterData?.departure?.filter(data => data?.active);
                                            if (filterActiveAirport?.length) {
                                                filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                                filteredData = filteredData?.filter((filterData) => {
                                                    const segments = filterData?.segments;
                                                    if (!segments || segments.length === 0) return false;
                                                    const firstFlightAirport = segments[0]?.departure?.airportCode;
                                                    return filterActiveAirport?.includes(firstFlightAirport);
                                                });
                                            }
                                        }

                                        if (airportFilterData?.arrival && airportFilterData?.arrival?.length) {
                                            let filterActiveAirport = airportFilterData?.arrival?.filter(data => data?.active);
                                            if (filterActiveAirport?.length) {
                                                filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                                filteredData = filteredData?.filter((filterData) => {
                                                    const segments = filterData?.segments;
                                                    if (!segments || segments.length === 0) return false;
                                                    const firstFlightAirport = segments[segments?.length - 1]?.arrival?.airportCode;
                                                    return filterActiveAirport?.includes(firstFlightAirport);
                                                });
                                            }
                                        }
                                    } else if (activeFlightData?.type === "RETURN") {
                                        if (airportFilterData?.returnDeparture && airportFilterData?.returnDeparture?.length) {
                                            let filterActiveAirport = airportFilterData?.returnDeparture?.filter(data => data?.active);
                                            if (filterActiveAirport?.length) {
                                                filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                                filteredData = filteredData?.filter((filterData) => {
                                                    const segments = filterData?.segments;
                                                    if (!segments || segments.length === 0) return false;
                                                    const firstFlightAirport = segments[0]?.departure?.airportCode;
                                                    return filterActiveAirport?.includes(firstFlightAirport);
                                                });
                                            }
                                        }
                                        if (airportFilterData?.returnArrival && airportFilterData?.returnArrival?.length) {
                                            let filterActiveAirport = airportFilterData?.returnArrival?.filter(data => data?.active);
                                            if (filterActiveAirport?.length) {
                                                filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                                filteredData = filteredData?.filter((filterData) => {
                                                    const segments = filterData?.segments;
                                                    if (!segments || segments.length === 0) return false;
                                                    const firstFlightAirport = segments[segments?.length - 1]?.arrival?.airportCode;
                                                    return filterActiveAirport?.includes(firstFlightAirport);
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        } else if (roundTripDomestic?.active === 2) {
                            if (!roundTripDomestic?.status) {
                                if (airportFilterData?.departure && airportFilterData?.departure?.length) {
                                    let filterActiveAirport = airportFilterData?.departure?.filter(data => data?.active);
                                    if (filterActiveAirport?.length) {
                                        filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                        filteredData = filteredData?.filter((filterData) => {
                                            const segments = filterData?.segments;
                                            if (!segments || segments.length === 0) return false;
                                            const firstFlightAirport = segments[0]?.departure?.airportCode;
                                            return filterActiveAirport?.includes(firstFlightAirport);
                                        });
                                    }
                                }
                                if (airportFilterData?.arrival && airportFilterData?.arrival?.length) {
                                    let filterActiveAirport = airportFilterData?.arrival?.filter(data => data?.active);
                                    if (filterActiveAirport?.length) {
                                        filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                        filteredData = filteredData?.map((filterData) => {
                                            const departureFlights = [];
                                            let isDeparture = true;

                                            filterData?.segments.forEach((flight) => {
                                                const { arrival } = flight;
                                                if (isDeparture) {
                                                    departureFlights.push(flight);
                                                    if (arrival.airportCode === queryParams?.toAirport) {
                                                        isDeparture = false;
                                                    }
                                                }
                                            });
                                            const lastDepartureAirport = departureFlights[departureFlights.length - 1]?.arrival?.airportCode;

                                            if (filterActiveAirport?.includes(lastDepartureAirport)) {
                                                return filterData;
                                            }
                                            return null;
                                        }).filter(Boolean);
                                    }
                                }
                                if (airportFilterData?.returnDeparture && airportFilterData?.returnDeparture?.length) {
                                    let filterActiveAirport = airportFilterData?.returnDeparture?.filter(data => data?.active);
                                    if (filterActiveAirport?.length) {
                                        filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                        filteredData = filteredData?.map((filterData) => {
                                            const returnFlights = [];
                                            let isDeparture = true;

                                            filterData?.segments.forEach((flight) => {
                                                const { arrival } = flight;
                                                if (isDeparture) {
                                                    if (arrival.airportCode === queryParams?.toAirport) {
                                                        isDeparture = false;
                                                    }
                                                } else {
                                                    returnFlights.push(flight);
                                                }
                                            });
                                            const firstReturnAirport = returnFlights[0]?.departure?.airportCode;
                                            if (filterActiveAirport?.includes(firstReturnAirport)) {
                                                return filterData;
                                            }
                                            return null;
                                        }).filter(Boolean);
                                    }
                                }
                                if (airportFilterData?.returnArrival && airportFilterData?.returnArrival?.length) {
                                    let filterActiveAirport = airportFilterData?.returnArrival?.filter(data => data?.active);
                                    if (filterActiveAirport?.length) {
                                        filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                        filteredData = filteredData?.filter((filterData) => {
                                            const segments = filterData?.segments;
                                            if (!segments || segments.length === 0) return false;
                                            const firstFlightAirport = segments[segments?.length - 1]?.arrival?.airportCode;
                                            return filterActiveAirport?.includes(firstFlightAirport);
                                        });
                                    }
                                }
                            }
                        } else {
                            if (airportFilterData?.departure && airportFilterData?.departure?.length) {
                                let filterActiveAirport = airportFilterData?.departure?.filter(data => data?.active);
                                if (filterActiveAirport?.length) {
                                    filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                    filteredData = filteredData?.filter((filterData) => {
                                        const segments = filterData?.segments;
                                        if (!segments || segments.length === 0) return false;
                                        const firstFlightAirport = segments[0]?.departure?.airportCode;
                                        return filterActiveAirport?.includes(firstFlightAirport);
                                    });
                                }
                            }

                            if (airportFilterData?.arrival && airportFilterData?.arrival?.length) {
                                let filterActiveAirport = airportFilterData?.arrival?.filter(data => data?.active);
                                if (filterActiveAirport?.length) {
                                    filterActiveAirport = filterActiveAirport?.map(data => data?.airportCode);
                                    filteredData = filteredData?.filter((filterData) => {
                                        const segments = filterData?.segments;
                                        if (!segments || segments.length === 0) return false;
                                        const firstFlightAirport = segments[segments?.length - 1]?.arrival?.airportCode;
                                        return filterActiveAirport?.includes(firstFlightAirport);
                                    });
                                }
                            }
                        }
                    }
                }
            }
            filteredData = filteredData?.map((items) => ({
                ...items,
                openFlightDetails: false,
                openFareViews: false,
                openFlighDetailsCurrentTabs: 1,
                openFlighDetailsFareRulesTabs: 1
            }));
            if (filteredData?.length) {
                const cheapestFlight = filteredData.reduce((minObj, currentObj) => {
                    const currentPrice = currentObj?.pricing?.[0]?.totalPrice ?? Number.POSITIVE_INFINITY;
                    const minPrice = minObj?.pricing?.[0]?.totalPrice ?? Number.POSITIVE_INFINITY;
                    return currentPrice < minPrice ? currentObj : minObj;
                }, filteredData[0]);
                setCheapestDuration(
                    <>
                        {/* <span className="hw-currency ml-6">{agentActiveCurrency} </span> */}
                        {/* formatePriceFn(agentActiveCurrency, formatPrice(option?.amount, true, true), displayPrice) */}
                        {formatePriceFn(agentActiveCurrency,formatPrice(
                            cheapestFlight?.pricing?.[0]?.totalPrice,
                            true,
                            true
                        ),displayPrice)}
                        {" | "}
                        {convertMinutesHeaderFn(cheapestFlight?.totalDuration)}
                    </>
                );

                const minDuration = filteredData.reduce((minObj, currentObj) => {
                    if (currentObj.totalDuration < minObj.totalDuration) return currentObj;
                    if (currentObj.totalDuration > minObj.totalDuration) return minObj;
                    const curP = currentObj?.pricing?.[0]?.totalPrice ?? Infinity;
                    const minP = minObj?.pricing?.[0]?.totalPrice ?? Infinity;
                    return curP < minP ? currentObj : minObj;
                }, filteredData[0]);
                setFastestDuration(
                <>
                    {formatePriceFn(
                        agentActiveCurrency,
                        formatPrice(
                            minDuration?.pricing?.[0]?.totalPrice,
                            true,
                            true
                        ),
                        displayPrice
                    )}
                    {" | "}
                    {convertMinutesHeaderFn(minDuration?.totalDuration)}
                </>
            );
            } else {
                setCheapestDuration('');
                setFastestDuration('');
            }
            setFlightData(filteredData);
            setLoading(false);
            if (firstonLoad) {
                setMainLoading(false);
                setFirstonLoad(false);
            }
        }

    }, 700);

    useEffect(() => {
        if (hasRangeChanges.priceChange) {
            if (debounceTimer.current.price) clearTimeout(debounceTimer.current.price);
            debounceTimer.current.price = setTimeout(() => {
                if (
                    priceRange?.minMaxPrice[0] >= 0 &&
                    priceRange?.minMaxPrice[1] >= 0 &&
                    airlineFilterData?.length
                ) {
                    if (hasRun?.current) {
                        filterChangeFn();
                        hasRun.current = false;
                    } else {
                        setLoading(true);
                        filterChangeFn();
                    }
                }
                setRangeChange(prev => ({ ...prev, priceChange: false }));
            }, 500);
            return () => clearTimeout(debounceTimer.current.price);
        }
        else if (hasRangeChanges.timeChange) {
            if (debounceTimer.current.duration) clearTimeout(debounceTimer.current.duration);
            debounceTimer.current.duration = setTimeout(() => {
                if (
                    priceRange?.minMaxPrice[0] >= 0 &&
                    priceRange?.minMaxPrice[1] >= 0 &&
                    airlineFilterData?.length
                ) {
                    if (hasRun?.current) {
                        filterChangeFn();
                        hasRun.current = false;
                    } else {
                        setLoading(true);
                        filterChangeFn();
                    }
                }
                setRangeChange(prev => ({ ...prev, timeChange: false }));
            }, 500);
            return () => clearTimeout(debounceTimer.current.duration);
        }
        else if (priceRange?.minMaxPrice[0] >= 0 && priceRange?.minMaxPrice[1] >= 0 && airlineFilterData?.length) {
            if (hasRun?.current) {
                filterChangeFn()
                hasRun.current = false;
                return () => {
                    filterChangeFn.cancel();
                };
            } else {
                setLoading(true);
                filterChangeFn()
                return () => {
                    filterChangeFn.cancel();
                };
            }
        }
    }, [priceRange, airlineFilterData, departureTimeFilter, totalAirportStops, durationValues, airportFilterData, roundTripDomestic, multiFlightOptionsData, returnDepartureTimeFilter, returnDurationValues, multiCityDepartureTimeFilter, multiCityDurationValues, fastestFlight])

    const inputRangeOnChange = (newValues) => {
        setRangeChange({ ...hasRangeChanges, priceChange: true })
        setPriceRange((prevState) => ({
            ...prevState,
            minMaxPrice: newValues,
        }));
    }

    const durationRangeChange = (newValues, duration) => {
        setRangeChange({ ...hasRangeChanges, timeChange: true })
        setMultiCityDurationValues(prev => ({
            ...prev,
            [duration]: {
                ...prev[duration],
                duration: newValues
            }
        }));
    }

    const filterHideShowFn = (menuItems,) => {
        let menuObj = { ...filterHideShow };
        menuObj[menuItems] = !menuObj[menuItems]
        setFilterHideShow(menuObj);
    }


    const handleChange = (newValues) => {
        setRangeChange({ ...hasRangeChanges, timeChange: true })
        setDurationValues((prevData) => {
            let updatedData = { ...prevData };
            updatedData.duration = newValues;
            return updatedData;
        });
    };

    const returnHandleChange = (newValues) => {
        setRangeChange({ ...hasRangeChanges, timeChange: true })
        setReturnDurationValues((prevData) => {
            let updatedData = { ...prevData };
            updatedData.duration = newValues;
            return updatedData;
        });
    };

    useEffect(() => {
        if (isFilterCollapsed) {
            document.body.classList.add('filter-collapsed');
        } else {
            document.body.classList.remove('filter-collapsed');
        }
    }, [isFilterCollapsed]);

    const jsToogleFilterClickFn = () => {
        setIsFilterCollapsed(prevState => !prevState);
    }

    useEffect(() => {
        if (isExpiredSearch) return;

        const timer = setInterval(() => {
            if (timeRemainingRef.current <= 1) {
                setIsExpiredSearch(true);
                window.location.reload();
                clearInterval(timer);
            } else {
                timeRemainingRef.current -= 1;
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [isExpiredSearch]);


    useEffect(() => {
        if (headerAirportData?.length) {
            let serachAirportQuery = {
                passengerDetails: {
                    adult: queryParams?.adult > 0 ? Number(queryParams?.adult) : 0,
                    children: queryParams?.child > 0 ? Number(queryParams?.child) : 0,
                    infants: queryParams?.infant > 0 ? Number(queryParams?.infant) : 0,
                },
                passengerClass: queryParams?.passageClass,
                searchDetails: [],
                directFlight: queryParams?.directFlight,
                nearByAirport: queryParams?.nearByAirport,
                ...(queryParams?.returnDate && { returnDate: queryParams?.returnDate }),
                airlineCode: headerAirlineData?.map((items) => {
                    return {
                        value: items?.code,
                        label: items?.name
                    }
                }) || '',
            };
            let serachDetailsObj;
            if (Array.isArray(queryParams?.segments)) {
                serachDetailsObj = queryParams?.segments?.map((airports) => {
                    let fromAirprtData = searchAirportDataFn(airports?.fromAirport);
                    let toAirportData = searchAirportDataFn(airports?.toAirport);
                    return {
                        fromData: {
                            inputValue: '',
                            airportName: `${fromAirprtData?.city} (${fromAirprtData?.code})`,
                            label: `${fromAirprtData?.city} (${fromAirprtData?.code}) - ${fromAirprtData?.name}`,
                            cityName: fromAirprtData?.city || '',
                            name: fromAirprtData?.name,
                            value: fromAirprtData?.code,
                            loading: '',
                            menuOpen: ''
                        },
                        toData: {
                            inputValue: '',
                            airportName: `${toAirportData?.city} (${toAirportData?.code})`,
                            cityName: toAirportData?.city || '',
                            label: `${toAirportData?.city} (${toAirportData?.code}) - ${toAirportData?.name}`,
                            name: toAirportData?.name,
                            value: toAirportData?.code,
                            loading: '',
                            menuOpen: ''
                        },
                        startDate: (airports?.departDate) ? new Date(airports?.departDate) : '',
                        returnDate: (airports?.returnDate) ? new Date(airports?.returnDate) : ''
                    }
                })
                serachAirportQuery.searchDetails = serachDetailsObj
            } else {
                let fromAirprtData = searchAirportDataFn(queryParams?.fromAirport);
                let toAirportData = searchAirportDataFn(queryParams?.toAirport);
                serachDetailsObj = {
                    fromData: {
                        inputValue: '',
                        airportName: `${fromAirprtData?.city} (${fromAirprtData?.code})`,
                        cityName: fromAirprtData?.city || '',
                        label: `${fromAirprtData?.city} (${fromAirprtData?.code}) - ${fromAirprtData?.name}`,
                        name: fromAirprtData?.name,
                        value: fromAirprtData?.code,
                        loading: '',
                        menuOpen: ''
                    },
                    toData: {
                        inputValue: '',
                        airportName: `${toAirportData?.city} (${toAirportData?.code})`,
                        cityName: toAirportData?.city || '',
                        label: `${toAirportData?.city} (${toAirportData?.code}) - ${toAirportData?.name}`,
                        name: toAirportData?.name,
                        value: toAirportData?.code,
                        loading: '',
                        menuOpen: ''
                    },
                    startDate: (queryParams?.departDate) ? new Date(queryParams?.departDate) : '',
                    returnDate: (queryParams?.returnDate) ? new Date(queryParams?.returnDate) : ''
                }
                serachAirportQuery.searchDetails.push(serachDetailsObj)
            }
            setSearchQueryAirport(serachAirportQuery);
            setIsHeaderAirportsLoading(false);
        }
    }, [headerAirportData])

    const headerAirportDataCityAndCountry = (code, onlyCity = false, nearByAirport) => {
        let findCityAndCountry = headerAirportData?.find((airport) => airport?.code === code);
        if (nearByAirport && !findCityAndCountry) {
            findCityAndCountry = headerAirportData?.find((airport) => airport?.code === nearByAirport);
        }
        if (onlyCity) {
            return findCityAndCountry?.city;
        } else {
            return `${findCityAndCountry?.city}, ${findCityAndCountry?.country}`;
        }
    }

    const searchAirportDataFn = (code) => {
        return headerAirportData?.find((airport) => airport?.code === code);
    }

    // Extract the price the user just clicked, in a vendor-aware way.
    // The shapes of the (priceId, pricing, service) arguments differ per vendor,
    // mirroring how each Book button calls flightBookingFn.
    const extractClickedFlightPriceFn = (source, flightData, priceIdArg, pricingArg, serviceArg) => {
        const src = String(source || '').toLowerCase();
        if (src === 'tripjack') {
            const found = flightData?.pricing?.find?.((p) => p?.id === priceIdArg);
            return Number(found?.totalPrice) || 0;
        }
        if (src === 'amadeus') {
            // 4th arg is amaduesFaresData which holds the pricing[] list.
            const found = pricingArg?.pricing?.find?.((p) => p?.id === priceIdArg);
            return Number(found?.totalPrice) || 0;
        }
        if (src === 'ndc-portal') {
            let totalMarkup = Number(totalMarkupAmount) || 0;
            const mainAmount = pricingArg?.bundle ? parseFloat(pricingArg?.mainAmount) + (parseFloat(pricingArg?.totalPrice) + parseFloat(totalMarkup)) : pricingArg?.totalPrice;
            // 4th arg is the full pricingData object.
            return Number(mainAmount) || 0;
        }
        if (src === 'akasa-air') {
            // 3rd arg IS the pricing object.
            return Number(priceIdArg?.totalPrice) || 0;
        }
        if (src === 'air-arabia') {
            // 4th = pricing item, 5th = optional bundle service.
            const baseTotal = Number(pricingArg?.totalPrice ?? pricingArg?.price) || 0;
            const bundlePrice = Number(serviceArg?.price) || 0;
            return bundlePrice ? bundlePrice : baseTotal;
        }
        if (src === 'travel-fusion' || src === 'verteil' || src === 'fly-dubai') {
            // 3rd arg IS the pricing object.
            return Number(priceIdArg?.totalPrice) || 0;
        }
        return 0;
    };

    const flightBookingFn = async (source, flightData, priceId, pricing = {}, service = {}) => {
        setCookie("lastQueryParamsFlight", window.location.search);
        const capturedPrice = extractClickedFlightPriceFn(source, flightData, priceId, pricing, service);
        if (source === 'tripjack') {
            captureBookedFlightPriceFn(source, priceId, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId}&source=${toUrlSource(source)}&flightId=${flightData?.flightDHTRId}`)
        } else if (source === 'ndc-portal') {
            captureBookedFlightPriceFn(source, priceId?.id, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId?.id}&flightId=${flightData?.flightDHTRId}&source=${toUrlSource(source)}`)
        } else if (source === 'amadeus') {
            captureBookedFlightPriceFn(source, priceId, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId}&source=${toUrlSource(source)}&sid=${flightData?.sessionId}&amaduestoken=${pricing?.tokenId}&type=${pricing?.type}`)
        } else if (source === "akasa-air") {
            let passenger = '';
            if (priceId?.passengers) {
                const passengerKeys = Object.keys(priceId.passengers);
                passenger = passengerKeys.map((key, index) => {
                    const count = priceId.passengers[key]?.passengerCount || 0;
                    const suffix = index < passengerKeys.length - 1 ? 'T' : '';
                    return `${key.charAt(0).toUpperCase()}${count}${suffix}`;
                }).join('');
            }
            if (queryParams?.infant) {
                passenger += `TI${queryParams?.infant}`
            }
            captureBookedFlightPriceFn(source, priceId?.id, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId?.id}&source=${toUrlSource(source)}&jKey=${flightData?.journeyKey}&pass=${passenger}&flightId=${flightData?.flightDHTRId}`)
        } else if (source === 'air-arabia') {
            let priceId = btoa(window.location.search);
            let segmentData = flightData.segments?.map(({ arrival, departure, ...rest }) => ({
                ...rest,
                arrival: { ...arrival, time: arrival.arrivalTime },
                departure: { ...departure, time: departure.departureTime },
                equipmentType: rest?.flightEquipmentType,
                airline: {
                    code: rest?.flightCode,
                    name: rest?.flightName
                }
            }));

            let cookieData = {
                directionType: flightData.tripType,
                flightSegment: segmentData,
                totalDuration: flightData?.totalDuration,
                passenger: flightData?.pricing?.[0]?.passengers,
                source: source,
                pricingObj: pricing,
                bundleData: [{
                    serviceId: service?.serviceId,
                    direction: 'ONWARD'
                }],
                allBundleSelections: selectedAirArabiaBundle
            };
            setSessionStorage(`airArabia-${priceId}`, JSON.stringify(cookieData));
            captureBookedFlightPriceFn(source, priceId, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId}&source=${toUrlSource(source)}`);
        } else if (source === 'travel-fusion') {
            let routiingId = flightData?.routingId;
            let outwardId = priceId?.id;
            captureBookedFlightPriceFn(source, routiingId, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${routiingId}&outwardId=${outwardId}&source=${toUrlSource(source)}&flightId=${flightData?.flightDHTRId}`);
        } else if (source === 'verteil') {
            let sessionData = priceId?.session;
            let priceIdData = priceId?.id;
            let searchData = btoa(window.location.search);
            let generateString = generateRandomString(42, 3);
            setSessionStorage(`verteil-${generateString}`, priceIdData);
            setSessionStorage(`verteil-${priceIdData}-${searchData}`, JSON.stringify(sessionData));
            captureBookedFlightPriceFn(source, generateString, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${generateString}&searchData=${searchData}&source=${toUrlSource(source)}&flightId=${flightData?.flightDHTRId}`);
        } else if (source === 'fly-dubai') {
            let sessionData = priceId?.session;
            let searchData = btoa(window.location.search);
            let priceIdData = priceId?.id;
            const passengerCounts = Object?.fromEntries(
                Object?.entries(priceId?.passengers)?.map(([key, value]) => [key, value?.passengerCount])
            );
            let segements = flightData?.segments
            let sessionStorageData = { sessionData, passengers: passengerCounts, segements }
            setSessionStorage(`fly-dubai-${priceIdData}-${searchData}`, JSON.stringify(sessionStorageData));
            captureBookedFlightPriceFn(source, priceIdData, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceIdData}&searchData=${searchData}&source=${toUrlSource(source)}&flightId=${priceId?.flightDHTRId ?? priceId?.id}`);
        } else if (source === 'aljazeera') {
            let priceIdData = priceId?.id;
            let infant = parseInt(queryParams?.infant)
            let child = parseInt(queryParams?.child)
            let adult = parseInt(queryParams?.adult)
            let payload = {
                keys: [
                    {
                        "journeyKey": flightData?.segments?.[0]?.journeyKey,
                        "fareAvailabilityKey": pricing?.id,
                        "standbyPriorityCode": "",
                        "inventoryControl": ""
                    }
                ],
                adult, child, infant,
                serviceBundleCodes: [pricing?.bundleCode],
                baseCurrency: flightData?.baseCurrency,
            }
            setSessionStorage(`aljazeera-${priceIdData}`, JSON.stringify(payload));
            captureBookedFlightPriceFn(source, priceIdData, capturedPrice, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceIdData}&source=${toUrlSource(source)}&flightId=${priceId?.flightDHTRId ?? priceId?.id}`);
        }
    }


    const multiFlightBookingFn = () => {
        setCookie("lastQueryParamsFlight", window.location.search);
        let priceId = selectedMultiflights?.map(flight => flight?.priceId?.id);
        let source = selectedMultiflights?.[0]?.['source'];
        // For round-trip / multi-flight, the captured price is the sum of each selected
        // leg's totalPrice (each flight's priceId object carries .totalPrice).
        const capturedPriceMulti = (selectedMultiflights || []).reduce((sum, f) => sum + (Number(f?.priceId?.totalPrice) || 0), 0);
        if (source === "air-arabia") {
            priceId = btoa(window.location.search);
            let bundleData = selectedMultiflights?.map((flight, index) => {
                return {
                    serviceId: flight?.bundleData?.bundleData?.serviceId,
                    direction: index === 0 ? 'ONWARD' : 'RETURN'
                }
            });
            let segmentData = selectedMultiflights?.map((multiflight) => {
                return {
                    segement: multiflight?.segment?.map(({ arrival, departure, ...rest }) => ({
                        ...rest,
                        arrival: { ...arrival, time: arrival?.arrivalTime },
                        departure: { ...departure, time: departure?.departureTime },
                        equipmentType: rest?.flightEquipmentType,
                        airline: {
                            code: rest?.flightCode,
                            name: rest?.flightName
                        }
                    })),
                    totalDuration: multiflight?.totalDurations
                }
            })
            // Get bundles for different trip types
            const onwardBundle = getBundleForTripType('ONWARD');
            const returnBundle = getBundleForTripType('RETURN');


            let cookieData = {
                directionType: 'ReturnWay',
                flightSegment: segmentData,
                totalDuration: selectedMultiflights[0]?.totalDurations,
                passenger: selectedMultiflights?.[0]?.priceId?.passengers,
                source: source,
                bundleData: bundleData,
                onwardBundle: onwardBundle,
                returnBundle: returnBundle,
                allBundleSelections: selectedAirArabiaBundle,
                // transactionId : selectedMultiflights?.[0]?.transactionId,
                // bundleSummary : {
                //     totalBundles : selectedAirArabiaBundle.length,
                //     hasOnward : !!onwardBundle,
                //     hasReturn : !!returnBundle,
                //     isComplete : selectedAirArabiaBundle.length >= 2
                // }
            };
            setSessionStorage(`airArabia-${priceId}`, JSON.stringify(cookieData));
            captureBookedFlightPriceFn(source, priceId, capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId}&source=${toUrlSource(source)}`);
        } else if (source === 'akasa-air') {
            let combinedData = selectedMultiflights?.map(flight => {
                return `${flight?.journeyKey}|${flight?.priceId?.id}`;
            });
            let priceIdData = combinedData.join(',');
            let passenger = '';
            let pricingIdData = selectedMultiflights?.[0]?.priceId;

            if (pricingIdData?.passengers) {
                const passengerKeys = Object.keys(pricingIdData.passengers);
                passenger = passengerKeys.map((key, index) => {
                    const count = pricingIdData.passengers[key]?.passengerCount || 0;
                    const suffix = index < passengerKeys.length - 1 ? 'T' : '';
                    return `${key.charAt(0).toUpperCase()}${count}${suffix}`;
                }).join('');
            }
            if (queryParams?.infant) {
                passenger += `TI${queryParams?.infant}`
            }
            let flightId = selectedMultiflights?.[0]?.['flightDHTRId'];
            captureBookedFlightPriceFn(source, priceIdData, capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceIdData}&source=${toUrlSource(source)}&pass=${passenger}&flightId=${flightId}`)
        } else if (source === 'travel-fusion') {
            let findOnWardData = selectedMultiflights?.find(flight => flight?.type === "ONWARD");
            let findReturnData = selectedMultiflights?.find(flight => flight?.type === "RETURN");
            let routingId = findOnWardData?.routingId;
            let outwardId = findOnWardData?.priceId?.id;
            let returnId = findReturnData?.priceId?.id;
            captureBookedFlightPriceFn(source, routingId, capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${routingId}&outwardId=${outwardId}&returnId=${returnId}&source=${toUrlSource(source)}&flightId=${findOnWardData?.flightDHTRId}`);
        } else if (source === 'ndc-portal') {
            let priceId = selectedMultiflights?.map(flight => flight?.priceId?.id);
            // console.log("priceId", priceId)
            captureBookedFlightPriceFn(source, priceId.join(","), capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId.join(",")}&source=${toUrlSource(source)}`)
        } else if (source === 'fly-dubai') {
            let sessionData = selectedMultiflights?.map(flight => flight?.priceId?.session?.[0])
            let searchData = btoa(window.location.search);
            let priceIdData = selectedMultiflights?.map(flight => flight?.priceId?.flightDHTRId).join(",")
            const passengerCounts = Object.fromEntries(
                Object.entries(
                    selectedMultiflights
                        ?.map(flight => flight?.priceId?.passengers || {})
                        .reduce((acc, paxObj) => {
                            for (const [key, value] of Object.entries(paxObj)) {
                                // For Fly Dubai, we should use the maximum count instead of adding them
                                // since the same passengers are traveling on both flights
                                acc[key] = Math.max(acc[key] || 0, value?.passengerCount || 0);
                            }
                            return acc;
                        }, {})
                )
            );
            let sessionStorageData = { sessionData, passengers: passengerCounts }
            setSessionStorage(`fly-dubai-${priceIdData}-${searchData}`, JSON.stringify(sessionStorageData));
            captureBookedFlightPriceFn(source, priceIdData, capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceIdData}&searchData=${searchData}&source=${toUrlSource(source)}`);
            /*let priceId = selectedMultiflights?.map(flight => flight?.priceId?.id);
            console.log("priceId", priceId)*/
            // navigate(`/flight/booking?priceId=${priceId.join(",")}&source=${toUrlSource(source)}`)
        } else if (source === 'aljazeera') {
            // Order legs onward-first / return-second so journeyKeys and bundle codes line up
            // with the outbound + inbound search query.
            const onwardLeg = selectedMultiflights?.find(flight => flight?.type === 'ONWARD');
            const returnLeg = selectedMultiflights?.find(flight => flight?.type === 'RETURN');
            const orderedLegs = [onwardLeg, returnLeg].filter(Boolean);
            const legs = orderedLegs.length ? orderedLegs : (selectedMultiflights || []);

            // Aljazeera carries journeyKey on the segment, not at flight top-level.
            const getJourneyKey = (leg) => leg?.journeyKey || leg?.segment?.[0]?.journeyKey;

            let adult = parseInt(queryParams?.adult);
            let child = parseInt(queryParams?.child);
            let infant = parseInt(queryParams?.infant);

            // priceId mirrors the round-trip format PassengerListPage already parses for
            // aljazeera ("journeyKey|fareAvailabilityKey,journeyKey|fareAvailabilityKey").
            let priceIdData = legs.map(leg => `${getJourneyKey(leg)}|${leg?.priceId?.id}`).join(',');

            let payload = {
                keys: legs.map(leg => ({
                    "journeyKey": getJourneyKey(leg),
                    "fareAvailabilityKey": leg?.priceId?.id,
                    "standbyPriorityCode": "",
                    "inventoryControl": ""
                })),
                adult, child, infant,
                serviceBundleCodes: legs.map(leg => leg?.priceId?.bundleCode),
                baseCurrency: onwardLeg?.baseCurrency || legs?.[0]?.baseCurrency,
            };

            let flightId = legs.map(leg => leg?.flightDHTRId).join(',');
            setSessionStorage(`aljazeera-${priceIdData}`, JSON.stringify(payload));
            captureBookedFlightPriceFn(source, priceIdData, capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceIdData}&source=${toUrlSource(source)}&flightId=${flightId}`);
        } else {
            let flightId = selectedMultiflights?.[0]?.['flightDHTRId'];
            captureBookedFlightPriceFn('tripjack', priceId.join(","), capturedPriceMulti, agentActiveCurrency);
            navigate(`/flight/booking?priceId=${priceId.join(",")}&source=${toUrlSource("tripjack")}&flightId=${flightId}`)
        }
    }


    const flightTabChangeFn = (index, key, value) => {
        setFlightData((prevData) => {
            const updatedData = [...prevData];
            updatedData[index][key] = value
            return updatedData;
        });
    }

    const setViewFaresDataFn = async (flightData, index) => {
        if (flightData?.source === "amadeus" && !flightData?.amaduesFaresData) {
            setFlightData((prevData) => {
                const updatedData = [...prevData];
                updatedData[index]['amaduesLoader'] = true;
                return updatedData;
            });
            let queryPayload = {
                tripType: flightData?.source,
                flightDetails: {
                    sid: flightData?.sessionId,
                    flightOption: [{
                        Type: flightData?.sessionType,
                        Id: flightData?.flightIndexID
                    }]
                },
                activeCurrency: "AED",
            }
            let amaduesViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, { authorization: userToken });
            if (amaduesViewFares?.status === 200 && amaduesViewFares?.data?.statusCode === 200) {
                // setAmaduesViewFaresData(amaduesViewFares?.data?.data)
                setFlightData((prevData) => {
                    const updatedData = [...prevData];
                    updatedData[index]['amaduesLoader'] = false;
                    updatedData[index]['amaduesFaresData'] = amaduesViewFares?.data?.data;
                    return updatedData;
                });
            }
        } else if (flightData?.source === "tripjack" && !flightData?.tripJackFareRuleData) {
            setFlightData((prevData) => {
                const updatedData = [...prevData];
                updatedData[index]['tripJackLoader'] = true;
                return updatedData;
            });
            let queryPayload = {
                tripType: flightData?.source,
                priceId: flightData?.pricing?.[0]?.id,
                type: "SEARCH",
                activeCurrency: agentActiveCurrency,
            }
            let tripJackFareRules = await ApiCall('POST', '/flights/fare-rules', queryPayload, { authorization: userToken });
            if (tripJackFareRules?.status === 200 && tripJackFareRules?.data?.statusCode === 200) {
                let flightAirportData = `${flightData?.segments[0]?.departure?.airportCode}-${flightData?.segments[flightData?.segments?.length - 1]?.arrival?.airportCode}`
                let fareRuleCancellationAmount = tripJackFareRules?.data?.data?.data?.fareRule?.[flightAirportData]?.fr?.['CANCELLATION']?.['BEFORE_DEPARTURE']?.amount;
                setFlightData((prevData) => {
                    const updatedData = [...prevData];
                    updatedData[index]['tripJackLoader'] = false;
                    updatedData[index]['tripJackFareRuleData'] = tripJackFareRules?.data?.data?.data?.fareRule;
                    updatedData[index]['tripJackFareActiveIndex'] = tripJackFareRules?.data?.data?.data?.fareRule && Object?.keys(tripJackFareRules?.data?.data?.data?.fareRule)?.length ? Object.keys(tripJackFareRules?.data?.data?.data?.fareRule)?.[0] : '';
                    updatedData[index]['fareRuleCancellationAmount'] = fareRuleCancellationAmount;
                    return updatedData;
                });
            } else {
                setFlightData((prevData) => {
                    const updatedData = [...prevData];
                    updatedData[index]['tripJackLoader'] = false;
                    return updatedData;
                });
            }
        } else if (flightData?.source === "travel-fusion") {
            let queryPayload = {
                tripType: flightData?.source,
                routingId: flightData?.routingId,
                outwardId: flightData?.pricing?.[0]?.id,
                activeCurrency: "AED",
            }
            let travelFusionViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, { authorization: userToken });
            // console.log(travelFusionViewFares, 'flightData')
        } else if (flightData?.source === "air-arabia") {
            let callApi = true;
            if (flightData?.airArabiaFlightLastCall) {
                let diffMinute = getMinutesDifference(flightData?.airArabiaFlightLastCall);
                if (14 > diffMinute) {
                    callApi = false;
                }
            }
            if (callApi) {
                setFlightData((prevData) => {
                    const updatedData = [...prevData];
                    updatedData[index]['airArabiaLoader'] = true;
                    return updatedData;
                });
                let queryPayload = {
                    tripType: flightData?.source,
                    activeCurrency: "AED",
                    flightSegment: flightData?.segments,
                    passenger: flightData?.pricing?.[0]?.passengers,
                    directionType: flightData?.tripType
                }
                let airArabiaViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, { authorization: userToken });
                if (airArabiaViewFares?.status === 200 && airArabiaViewFares?.data?.statusCode === 200 && !airArabiaViewFares?.data?.data?.data?.error) {
                    setFlightData((prevData) => {
                        const updatedData = [...prevData];
                        updatedData[index]['airArabiaLoader'] = false;
                        updatedData[index]['airArabiaFlightData'] = airArabiaViewFares?.data?.data?.data;
                        updatedData[index]['airArabiaFlightLastCall'] = new Date();
                        return updatedData;
                    });
                } else {
                    setFlightData((prevData) => {
                        const updatedData = [...prevData];
                        updatedData[index]['airArabiaLoader'] = false;
                        return updatedData;
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (flightData?.length) {
            const cheapestFlight = flightData.reduce((minObj, currentObj) => {
                const currentPrice = currentObj?.pricing?.[0]?.totalPrice ?? Number.POSITIVE_INFINITY;
                const minPrice = minObj?.pricing?.[0]?.totalPrice ?? Number.POSITIVE_INFINITY;
                return currentPrice < minPrice ? currentObj : minObj;
            }, flightData[0]);
            setCheapestDuration(
                <>
                    {formatePriceFn(agentActiveCurrency, formatPrice(cheapestFlight?.pricing?.[0]?.totalPrice, true, true), displayPrice)}
                    {" | "}
                    {convertMinutesHeaderFn(cheapestFlight?.totalDuration)}
                </>
            );
            const minDuration = flightData.reduce((minObj, currentObj) => {
                if (currentObj.totalDuration < minObj.totalDuration) return currentObj;
                if (currentObj.totalDuration > minObj.totalDuration) return minObj;
                const curP = currentObj?.pricing?.[0]?.totalPrice ?? Infinity;
                const minP = minObj?.pricing?.[0]?.totalPrice ?? Infinity;
                return curP < minP ? currentObj : minObj;
            }, flightData[0]);
            setFastestDuration(
                <>
                    {formatePriceFn(agentActiveCurrency, formatPrice(minDuration?.pricing?.[0]?.totalPrice, true, true), displayPrice)}
                    {" | "}
                    {convertMinutesHeaderFn(minDuration?.totalDuration)}
                </>
            );
        }
    }, [agentActiveCurrency, displayPrice, flightData]);

    /*console.log(selectedMultiflights, 'selectedMultiflights')*/

    useEffect(() => {
        const divAutoScroll = document.querySelectorAll(".hw--flight-auto-scroll-div");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setPage(p => p + 1)
                    }
                });
            },
            {
                root: null,
                rootMargin: "5px",
                threshold: 0,
            }
        );

        divAutoScroll.forEach((button) => {
            observer.observe(button);
        });

        return () => {
            divAutoScroll.forEach((button) => {
                observer.unobserve(button);
            });
        };
    }, [loading]);

    const flightDataToConsider = flightData?.slice(0, page * PER_PAGE)

    const HeaderAirport = ({ fromAirport, toAirport }) => {
        return (
            <>
                <div className="overflow-hidden">
                    <div className="overflow-ellipsis hw-fontBold hw-dtr--mtext">{fromAirport}</div>
                    <div
                        className="overflow-ellipsis hw-dtr--dtext">{headerAirportDataCityAndCountry(fromAirport)}</div>
                </div>
                <FlightSimpleIcon />
                <div className="overflow-hidden">
                    <div className="overflow-ellipsis hw-fontBold hw-dtr--mtext">{toAirport}</div>
                    <div className="overflow-ellipsis hw-dtr--dtext">{headerAirportDataCityAndCountry(toAirport)}</div>
                </div>
            </>
        )
    }

    const handleDateClick = (depDate, retDate) => {
        const params = new URLSearchParams(location.search)
        params.set('dep', depDate);
        if (retDate) {
            params.set('ret', retDate)
        }
        navigate(`/flight/list?${params.toString()}`, { state: new Date().getTime() });
    }

    const printHeaderUser = userAgentData?.user_data ?? {};
    const printCompanyName = printHeaderUser.display_name || '';
    const printPhone = printHeaderUser.phone || '';
    const printEmail = printHeaderUser.email || '';
    const printLogoSrc = printHeaderUser.company_logo || '';
    const printLogoDisplaySrc = printLogoSrc || agentDefaultImage;
    const printGeneratedLabel = new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    return (
        <>
            {/* Destination grid */}

            {/* {headerAirportMenuShow ?

                :
                // <div className="hw-blue--grid hw-search--destinationMultiCity" style={{pointerEvents : loading && "none"}}>
                //     <div className="row hw-search--destinationRow">
                //         <div className="hw-search-scroller col-auto d-flex align-items-center hw-gapy16">
                //             {Array.isArray(queryParams?.segments) ?
                //                 queryParams?.segments.map((airportData) => {
                //                     return (
                //                         <div className="d-flex align-items-center hw-gapy16">
                //                             <HeaderAirport
                //                                 fromAirport={airportData?.fromAirport}
                //                                 toAirport={airportData?.toAirport}
                //                             />
                //                         </div>
                //                     )
                //                 })
                //                 :
                //                 <>
                //                     <HeaderAirport
                //                         fromAirport={queryParams?.fromAirport}
                //                         toAirport={queryParams?.toAirport}
                //                     />
                //                 </>
                //             }
                //         </div>
                //         {!Array.isArray(queryParams?.segments) ? <div className="col overflow-hidden">
                //             <div className="hw-dtr--mtext overflow-ellipsis">Departure Date</div>
                //             <div
                //                 className="hw-fontBold hw-dtr--dtext overflow-ellipsis">{formatDayWiseDateFn(queryParams?.departDate)}</div>
                //         </div>  : '' }
                //         {queryParams?.returnDate ?
                //             <div className="col overflow-hidden">
                //                 <div className="hw-dtr--mtext overflow-ellipsis">Return Date</div>
                //                 <div
                //                     className="hw-fontBold hw-dtr--dtext overflow-ellipsis">{formatDayWiseDateFn(queryParams?.returnDate)}</div>
                //             </div>
                //             : ''}
                //         <div className="col overflow-hidden">
                //             <div className="hw-dtr--mtext overflow-ellipsis">Passengers & Class</div>
                //             <div className="hw-fontBold hw-dtr--dtext overflow-ellipsis">
                //                 {[
                //                     queryParams?.adult > 0 ? `${queryParams.adult} Adult` : null,
                //                     queryParams?.child > 0 ? `${queryParams.child} Children` : null,
                //                     queryParams?.infant > 0 ? `${queryParams.infant} Infants` : null
                //                 ]
                //                     .filter(Boolean)
                //                     .join(', ')
                //                 }
                //                 {queryParams?.passageClass ? ` | ${queryParams.passageClass}` : ''}
                //             </div>
                //         </div>
                //         <div className="col overflow-hidden">
                //             <div className="hw-dtr--mtext overflow-ellipsis">Preferred Airline</div>
                //             <div
                //                 className="hw-fontBold hw-dtr--dtext overflow-ellipsis">{queryParams?.airlineCode ? queryParams?.airlineCode : 'None'}</div>
                //         </div>
                //         <div className="col-auto d-flex">
                //             <button onClick={() => {
                //                 setHeaderAirportMenuShow(true);
                //             }} className="hw-btn hw-btn--whiteDefault"><SearchIcon/></button>
                //         </div>
                //     </div>
                // </div>
                 <SearchFlight queryparams={searchQueryAirport} setHeaderAirportMenuShow={setHeaderAirportMenuShow}/>
            } */}
            <SearchFlight
                queryparams={searchQueryAirport}
                setHeaderAirportMenuShow={setHeaderAirportMenuShow}
                showLoadingAfterLoad={showLoadingAfterLoad}
                isHeaderLoading={isHeaderAirportsLoading}
            />

            {/* End Destination grid */}

            {/* Flight Filter */}
            {(!mainLoading && showLoadingAfterLoad) ? <div style={{ position: 'relative' }}>
                <div className="hw-before-loader--status-half" style={{ left: 0 }}>
                </div></div> : ''}
            {mainLoading ? (() => {
                const isMultiCity = (Array.isArray(queryParams?.segments) && queryParams.segments.length > 1) ||
                                    (Array.isArray(searchQueryAirport?.searchDetails) && searchQueryAirport.searchDetails.length > 1);

                let multiCitySegments = [];
                if (isMultiCity) {
                    if (Array.isArray(queryParams?.segments) && queryParams.segments.length > 1) {
                        multiCitySegments = queryParams.segments.map((seg, idx) => {
                            const sDetail = searchQueryAirport?.searchDetails?.[idx];
                            const fromCity = sDetail?.fromData?.cityName || headerAirportDataCityAndCountry(seg?.fromAirport, true) || "";
                            const toCity = sDetail?.toData?.cityName || headerAirportDataCityAndCountry(seg?.toAirport, true) || "";
                            return {
                                fromCode: seg?.fromAirport || "",
                                fromCity: fromCity,
                                toCode: seg?.toAirport || "",
                                toCity: toCity,
                                departDate: seg?.departDate || sDetail?.startDate || ""
                            };
                        });
                    } else if (Array.isArray(searchQueryAirport?.searchDetails) && searchQueryAirport.searchDetails.length > 1) {
                        multiCitySegments = searchQueryAirport.searchDetails.map((sDetail) => ({
                            fromCode: sDetail?.fromData?.value || "",
                            fromCity: sDetail?.fromData?.cityName || "",
                            toCode: sDetail?.toData?.value || "",
                            toCity: sDetail?.toData?.cityName || "",
                            departDate: sDetail?.startDate || ""
                        }));
                    }
                }

                const fromCode = queryParams?.fromAirport || queryParams?.segments?.[0]?.fromAirport || "";
                const fromCity = searchQueryAirport?.searchDetails?.[0]?.fromData?.cityName ||
                    headerAirportDataCityAndCountry(fromCode, true) || "";

                const lastSegQueryParams = (queryParams?.segments?.length ? queryParams.segments[queryParams.segments.length - 1] : null);
                const lastSegSearchDetails = (searchQueryAirport?.searchDetails?.length ? searchQueryAirport.searchDetails[searchQueryAirport.searchDetails.length - 1] : null);

                const toCode = queryParams?.toAirport || lastSegQueryParams?.toAirport || "";
                const toCity = lastSegSearchDetails?.toData?.cityName ||
                    headerAirportDataCityAndCountry(toCode, true) || "";

                const departDate = queryParams?.departDate || queryParams?.segments?.[0]?.departDate || searchQueryAirport?.searchDetails?.[0]?.startDate || "";
                const returnDate = queryParams?.returnDate || "";

                return (
                    <>
                    <FlightListLoadingSkeleton />
                    <FlightSearchLoader
                        fromCode={fromCode}
                        fromCity={fromCity}
                        toCode={toCode}
                        toCity={toCity}
                        departDate={departDate}
                        returnDate={returnDate}
                        adult={parseInt(queryParams?.adult) || 0}
                        child={parseInt(queryParams?.child) || 0}
                        infant={parseInt(queryParams?.infant) || 0}
                        travelClass={queryParams?.passageClass || ""}
                        isMultiCity={isMultiCity}
                        multiCitySegments={multiCitySegments}
                    />
                    </>
                );
            })() : <>
                    <div className="hw-page--width">
                        <div className="hw-print-flight-quote-header" aria-hidden="true">
                            <div className="hw-print-flight-quote-header__body">
                                <div className="hw-print-flight-quote-header__brand">
                                    <div className="hw-print-flight-quote-header__logoCell">
                                        <img
                                            src={printLogoDisplaySrc}
                                            alt=""
                                            className="hw-print-flight-quote-header__logo"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = agentDefaultImage;
                                            }}
                                        />
                                    </div>
                                    {printCompanyName ? (
                                        <div className="hw-print-flight-quote-header__brandText">
                                            <div className="hw-print-flight-quote-header__companyName">
                                                {printCompanyName}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="hw-print-flight-quote-header__meta">
                                    <div className="hw-print-flight-quote-header__metaLine">
                                        <span className="hw-print-flight-quote-header__metaLabel">Generated :</span>{' '}
                                        {printGeneratedLabel}
                                    </div>
                                    {printEmail ? (
                                        <div className="hw-print-flight-quote-header__metaLine">
                                            <span className="hw-print-flight-quote-header__metaLabel">Email :</span>{' '}
                                            {printEmail}
                                        </div>
                                    ) : null}
                                    {printPhone ? (
                                        <div className="hw-print-flight-quote-header__metaLine">
                                            <span className="hw-print-flight-quote-header__metaLabel">Phone :</span>{' '}
                                            {printPhone}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="hw-search--flightList" style={{ pointerEvents: loading && "none" }}
                     
                        >
                            {
                                (!!originalFlightData?.length || !!flightData?.length || (roundTripDomestic?.status && (multiFlightOptionsData?.length > 0 || selectedMultiflights?.length > 0))) && <FlightListingSidebar
                                    queryParams={queryParams}
                                    jsToogleFilterClickFn={jsToogleFilterClickFn}
                                    filterHideShowFn={filterHideShowFn}
                                    headerAirportDataCityAndCountry={headerAirportDataCityAndCountry}
                                    filterHideShow={filterHideShow}
                                    departureTimeFilter={departureTimeFilter}
                                    setDepartureTimeFilter={setDepartureTimeFilter}
                                    totalAirportStops={totalAirportStops}
                                    setTotalAirportStops={setTotalAirportStops}
                                    inputRangeOnChange={inputRangeOnChange}
                                    priceRange={priceRange}
                                    fastestFlight={fastestFlight}
                                    onclickFastestCheapestFn={onclickFastestCheapestFn}
                                    cheapestDuration={cheapestDuration}
                                    fastestDuration={fastestDuration}
                                    showSortTabs={!!flightDataToConsider?.length}
                                    agentActiveCurrency={agentActiveCurrency}
                                    airlineFilterData={airlineFilterData}
                                    setAirlineFilterData={setAirlineFilterData}
                                    currentTabAirport={currentTabAirport}
                                    durationValues={durationValues}
                                    handleChange={handleChange}
                                    airportFilterData={airportFilterData}
                                    setAirportFilterData={setAirportFilterData}
                                    roundTripDomestic={roundTripDomestic}
                                    setRoundTripDomestic={setRoundTripDomestic}
                                    showViewAs={!!(originalFlightData?.length && roundTripDomestic?.status)}
                                    hasSingleFlight={!!originalFlightData?.some(f => f?.tripType !== 'COMBO')}
                                    hasComboFlight={!!originalFlightData?.some(f => f?.tripType === 'COMBO')}
                                    multiFlightOptionsData={multiFlightOptionsData}
                                    flightData={flightData}
                                    returnDepartureTimeFilter={returnDepartureTimeFilter}
                                    setreturnDepartureTimeFilter={setreturnDepartureTimeFilter}
                                    activeStops={activeStops}
                                    setActiveStops={setActiveStops}
                                    returnDurationValues={returnDurationValues}
                                    returnHandleChange={returnHandleChange}
                                    multiCityDepartureTimeFilter={multiCityDepartureTimeFilter}
                                    multiCityDurationValues={multiCityDurationValues}
                                    setMultiCityDepartureTimeFilter={setMultiCityDepartureTimeFilter}
                                    setMultiCityDurationValues={setMultiCityDurationValues}
                                    showLoadingAfterLoad={showLoadingAfterLoad}
                                    durationRangeChange={durationRangeChange}
                                    mainLoading={mainLoading}
                                    airlineText={airlineText}
                                    setAirlineText={setAirlineText}
                                    displayPrice={displayPrice}
                                />
                            }
                            <div className={`hw-search--flightFilterResult ${(!originalFlightData?.length) ? "hw-search-center" : ""}`} style={{ pointerEvents: (showLoadingAfterLoad || mainLoading || loading) && 'none' }}>
                                {/*{flightDataToConsider?.length ?  <h3 className="hw-blue">Flights From {flightDataToConsider?.[0]?.segments?.[0]?.departure?.city} to {flightDataToConsider?.[0]?.segments?.[flightDataToConsider?.[0]?.segments?.length - 1]?.arrival?.city}</h3> : ''}*/}

                                {
                                    (queryParams?.type !== "combo") &&
                                    <>
                                        <div>
                                            <div className="hw-dates-slider-header" style={{ display: !originalFlightData?.length ? "none" : "" }}>
                                                <span className="hw-fontBold hw-text14"> Flights From {flightDataToConsider?.[0]?.segments?.[0]?.departure?.city ? flightDataToConsider?.[0]?.segments?.[0]?.departure?.city : originalFlightData?.[0]?.segments?.[0]?.departure?.city} to {flightDataToConsider?.[0]?.segments?.[flightDataToConsider?.[0]?.segments?.length - 1]?.arrival?.city ? flightDataToConsider?.[0]?.segments?.[flightDataToConsider?.[0]?.segments?.length - 1]?.arrival?.city : originalFlightData?.[0]?.segments?.[originalFlightData?.[0]?.segments?.length - 1]?.arrival?.city}</span>
                                                <div className="hw-text14 hw-dates-rotate-text">
                                                    {(showLoadingAfterLoad || loading) ? <>
                                                        <div className="hw-dates-rotate-text-inner">
                                                            <span>Searching for best deals</span>
                                                            <span>Looking for cheap deals</span>
                                                            <span>Searching for best deals</span>
                                                            <span>Looking for cheap deals</span>
                                                            <span>Searching for best deals</span>
                                                            <span>Looking for cheap deals</span>
                                                            <span>Searching for best deals</span>
                                                            <span>Looking for cheap deals</span>
                                                        </div>
                                                        <div className="hw-loader" />
                                                    </> : <span>{flightData?.length} flights found</span>}
                                                </div>
                                            </div>
                                            <div style={{ display: !originalFlightData?.length ? "none" : "" }} className="hw-dates-slider-container">
                                                <button className="hw-dates-btn-prev" onClick={handlePrev}><SliderRightIcon /></button>
                                                {
                                                    (isLoadingDate || !datefilterData?.length) && <div className="hw-dates-skeleton-slider">
                                                        {Array.from({ length: 10 }).map((_, idx) => (
                                                            <div key={idx} className="hw-date-item">
                                                                <div className="skeleton-item" style={{ width: "80px", height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", animation: "skeleton-pulse 1.5s ease-in-out infinite", marginBottom: "8px" }} />
                                                                <div className="skeleton-item" style={{ width: "80px", height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                                <div className="hw-dates-slider hw-dates--roundtrip" style={{ visibility: isLoadingDate ? "hidden" : "visible" }} ref={sliderRef} >
                                                    {datefilterData?.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className={`hw-date-item ${selectedDate === index ? "selected" : ""}`}
                                                            onClick={() => {
                                                                handleDateClick(item?.depDate, item?.arrDate);
                                                                setSelectedDate(index);
                                                            }}
                                                        >
                                                            <div className="hw-date-range hw-text--hidden">{item.displayString}</div>
                                                            {item?.showLoading ? (
                                                                <div className="skeleton-item" style={{ width: "80px", height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
                                                            ) : item.price ? (
                                                                <div className="hw-price">{formatePriceFn(agentActiveCurrency, formatPrice(item?.price, true, true), displayPrice)}</div>
                                                            ) : (
                                                                <div className="hw-no-price">View</div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                                <button className="hw-dates-btn-next" onClick={handleNext}><SliderLeftIcon /></button>
                                            </div>
                                        </div>
                                    </>
                                }

                                {(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1) ?
                                    <div className="hw-search--flightFilterResult__top d-flex hw-search--flightScrollerTab">
                                        <div className="hw-search--roundTripBreadcrumbs">
                                            {multiFlightOptionsData?.map((flightData, flightIndex) => {
                                                return (
                                                    <div onClick={() => {
                                                        const multiFlights = multiFlightOptionsData.map((item, index) => ({
                                                            ...item,
                                                            active: index === flightIndex,
                                                        }));
                                                        const multiSelectedFlight = selectedMultiflights.map((item, index) => ({
                                                            ...item,
                                                            active: index === flightIndex,
                                                        }))
                                                        setSelectedMultiflights(multiSelectedFlight);
                                                        setMultiFlightOptionsData(multiFlights);
                                                    }} className={`item ${flightData?.active ? "active" : ""}`}>
                                                        <div className="d-flex align-items-center justify-center hw-gapy4 hw-fontBold">{flightData?.fromAirport?.city}<span>-</span>{flightData?.arrivalAirport?.city}</div>

                                                        <div>{new Date(flightData?.fromAirport?.departureTime)?.toLocaleDateString('en-GB')?.split('/')?.reverse()?.join('-')}</div>
                                                    </div>
                                                )
                                            })}
                                        </div>


                                    </div>

                                    : null}

                                <div className="hw-search--flightFilterResult__body">
                                    {loading ?
                                        <ul className="hw-search--flightFilterResult__list list-unstyled">
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
                                                <FlightListItemSkeleton />
                                            ))}
                                        </ul> :

                                        <>
                                            <ul className="hw-search--flightFilterResult__list list-unstyled hw-search--flightFilterResult__listNew">
                                                {flightDataToConsider?.length ?
                                                    <>
                                                        {
                                                            flightDataToConsider?.map((flights, index) => {
                                                                // For Fly Dubai return flights, check if there are any compatible fares
                                                                if (flights?.source === 'fly-dubai' && flights?.tripType === 'RETURN') {
                                                                    if (sessionStorage.getItem('fly-dubai-Combination') && sessionStorage.getItem('fly-dubai-Combination') !== 'undefined') {
                                                                        const combinationData = JSON.parse(sessionStorage.getItem('fly-dubai-Combination'));
                                                                        if (combinationData && Array.isArray(combinationData)) {
                                                                            const selectedOnwardFlight = selectedMultiflights.find(flight =>
                                                                                flight?.type === 'ONWARD'
                                                                            );
                                                                            if (selectedOnwardFlight) {
                                                                                const matchingCombination = combinationData.find(combo =>
                                                                                    combo.SolnRef && combo.SolnRef[0] === selectedOnwardFlight.priceId?.solnId
                                                                                );
                                                                                if (matchingCombination) {
                                                                                    const compatibleFares = flights?.pricing?.filter(pricingData =>
                                                                                        matchingCombination.SolnRef && matchingCombination.SolnRef[1] === pricingData?.solnId
                                                                                    );
                                                                                    // If no compatible fares, don't render this flight card
                                                                                    if (!compatibleFares || compatibleFares.length === 0) {
                                                                                        return null;
                                                                                    }
                                                                                } else {
                                                                                    // No matching combination found, don't render this flight card
                                                                                    return null;
                                                                                }
                                                                            } else {
                                                                                // No onward flight selected, don't render return flight cards
                                                                                return null;
                                                                            }
                                                                        } else {
                                                                            // No combination data, don't render return flight cards
                                                                            return null;
                                                                        }
                                                                    }

                                                                }


                                                                return (
                                                                    <ListFlightItemComponent
                                                                        index={index}
                                                                        flights={flights}
                                                                        queryParams={queryParams}
                                                                        agentActiveCurrency={agentActiveCurrency}
                                                                        headerAirportDataCityAndCountry={headerAirportDataCityAndCountry}
                                                                        flightBookingFn={flightBookingFn}
                                                                        selectedMultiflights={selectedMultiflights}
                                                                        roundTripDomestic={roundTripDomestic}
                                                                        selectMultiFlightFn={selectMultiFlightFn}
                                                                        showVendorLogo={showVendorLogo}
                                                                        seatShow={seatShow}
                                                                        selectedAirArabiaBundle={selectedAirArabiaBundle}
                                                                        onSelectAirArabiaBundle={onSelectAirArabiaBundle}
                                                                        displayPrice={displayPrice}
                                                                        totalMarkupAmount={totalMarkupAmount}
                                                                        isShowFlightAlternateOption={isShowFlightAlternateOption}
                                                                        isPrintSelectionMode={isPrintSelectionMode || isEmailSelectionMode}
                                                                        isSelectedForPrint={isPrintSelectionMode
                                                                            ? selectedPrintIndexes.includes(index)
                                                                            : selectedEmailIndexes.includes(index)}
                                                                        onTogglePrintSelection={() => {
                                                                            if (isPrintSelectionMode) {
                                                                                togglePrintSelectionItemFn(index);
                                                                                return;
                                                                            }
                                                                            if (isEmailSelectionMode) {
                                                                                toggleEmailSelectionItemFn(index);
                                                                            }
                                                                        }}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                        {
                                                            showLoadingAfterLoad ?
                                                                [1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
                                                                    <FlightListItemSkeleton />
                                                                ))
                                                                : ''}
                                                    </> :
                                                    <div className={`text-center  hw-flight--ntavailable ${(!originalFlightData?.length) ? "hw-search-notavailabel" : "ml-6"}`} style={{ padding: "36px 16px" }}>
                                                        <svg width="210" height="140" viewBox="0 0 210 140" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block", margin: "0 auto 20px" }} aria-hidden="true">
                                                            <g stroke="#b4bac6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                                                                <path d="M40 40C35 40 35 31 41 31C41 26 50 24 53 29C57 23 68 26 66 33C72 33 72 40 67 40Z" />
                                                                <path d="M150 30C145 30 145 21 151 21C151 16 160 14 163 19C167 13 178 16 176 23C182 23 182 30 177 30Z" />
                                                                <g transform="translate(64,20) scale(3.4)" strokeWidth="0.6">
                                                                    <path d="M22 2L11 13" />
                                                                    <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                                                                </g>
                                                                <path d="M24 118C50 114 70 92 98 68" strokeDasharray="1 7" />
                                                                <circle cx="24" cy="118" r="3" fill="#b4bac6" stroke="none" />
                                                            </g>
                                                        </svg>
                                                        {(() => {
                                                            const titleStyle = { marginBottom: 12 };
                                                            const descStyle = { marginBottom: 24, maxWidth: 460, marginLeft: "auto", marginRight: "auto", lineHeight: 1.6 };
                                                            const btnStyle = { padding: "10px 28px" };
                                                            const comboAvailable = originalFlightData?.some(f => f?.tripType === 'COMBO');
                                                            const singleAvailable = originalFlightData?.some(f => f?.tripType !== 'COMBO');
                                                            if (roundTripDomestic?.status && roundTripDomestic?.active === 1 && comboAvailable) {
                                                                return (
                                                                    <>
                                                                        <h3 className="hw-black900" style={titleStyle}>No single flights available</h3>
                                                                        <div className="hw-fontWeight--500" style={descStyle}>Single flights are not available for this search. Try Combo Flight instead.</div>
                                                                        <button className="hw-btn hw-btn--bprimary" style={btnStyle} onClick={() => setRoundTripDomestic((prev) => ({ ...prev, active: 2 }))}>View Combo Flight</button>
                                                                    </>
                                                                );
                                                            }
                                                            if (roundTripDomestic?.status && roundTripDomestic?.active === 2 && singleAvailable) {
                                                                return (
                                                                    <>
                                                                        <h3 className="hw-black900" style={titleStyle}>No combo flights available</h3>
                                                                        <div className="hw-fontWeight--500" style={descStyle}>Combo flights are not available for this search. Try Single Flight instead.</div>
                                                                        <button className="hw-btn hw-btn--bprimary" style={btnStyle} onClick={() => setRoundTripDomestic((prev) => ({ ...prev, active: 1 }))}>View Single Flight</button>
                                                                    </>
                                                                );
                                                            }
                                                            return (
                                                                <>
                                                                    <h3 className="hw-black900" style={titleStyle}>Sorry, No flights available</h3>
                                                                    <div className="hw-fontWeight--500" style={descStyle}>We could not find flights for this search. Please adjust your filters or try again with different dates.</div>
                                                                    {(!originalFlightData?.length) && <button className="hw-btn hw-btn--bprimary" style={btnStyle} onClick={() => navigate('/flight/search')}>Go Back</button>}
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                }
                                            </ul>
                                            <div className="hw--flight-auto-scroll-div" />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {(roundTripDomestic?.status && roundTripDomestic?.active === 1 && selectedMultiflights.some(item => item.priceId !== undefined)) ?
                        (() => {
                            const allSelected = selectedMultiflights?.every(item => item?.priceId !== undefined);

                            // only apply overlap logic when ALL selected legs are aljazeera
                            const selectedWithPrice = selectedMultiflights?.filter(f => f?.priceId) ?? [];
                            const isAllAljazeera = selectedWithPrice.length > 0 &&
                                selectedWithPrice.every(f => f?.source === 'aljazeera');

                            const MIN_CONNECTION_MS = 90 * 60 * 1000; // 90 minutes

                            let hasOverlap = false;
                            if (isAllAljazeera && allSelected) {
                                const segs = selectedWithPrice
                                    .map(f => ({
                                        dep: new Date(f?.fromAirport?.departureTime).getTime(),
                                        arr: new Date(f?.arrivalAirport?.arrivalTime).getTime(),
                                    }))
                                    .filter(s => !isNaN(s.dep) && !isNaN(s.arr))
                                    .sort((a, b) => a.dep - b.dep);

                                for (let i = 0; i < segs.length - 1; i++) {
                                    const gap = segs[i + 1].dep - segs[i].arr;
                                    // block if legs overlap OR the gap is under 90 minutes
                                    if (gap < MIN_CONNECTION_MS) {
                                        hasOverlap = true;
                                        break;
                                    }
                                }
                            }

                            const blockBook = isAllAljazeera && allSelected && hasOverlap;

                            return (
                                <div className="hw-search--flightListBottomFooter">
                                    <div className="hw-page--width">
                                        <div className="hw-search--destinationRowMain">
                                            <div className="col-scroll">
                                                <div className="row hw-search--destinationRow">
                                                    {selectedMultiflights?.map((flights) => {
                                                        if (flights?.priceId) {
                                                            return (
                                                                <div className="col d-flex hw-gapy10">
                                                                    <div>
                                                                        <span className="hw-gapy10 align-items-center">
                                                                            <img width={24}
                                                                                height={24}
                                                                                src={airlineImageFn(flights?.airlineData?.flightCode)}
                                                                                alt={flights?.airlineData?.flightName}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <div className="hw-fontBold hw-dtr--mtext overflow-ellipsis hw-blue">{flights?.airlineData?.flightName}</div>
                                                                        <div className="hw-dtr--dtext hw-blue hw-text14">{flights?.airlineData?.flightCode}-{flights?.airlineData?.flightNumber}</div>
                                                                    </div>
                                                                    <div className="col-auto d-flex align-items-center hw-gapy10">
                                                                        <div>
                                                                            <div className="hw-dtr--dtext hw-blue hw-text14 hw-fontBold">{formatDateTime(flights?.fromAirport?.departureTime)?.time}</div>
                                                                            <div className="hw-dtr--dtext hw-blue hw-text14 hw-fontBold">{flights?.fromAirport?.airportCode}</div>
                                                                        </div>
                                                                        <ArrowRightIcon />
                                                                        <div>
                                                                            <div className="hw-dtr--dtext hw-blue hw-text14 hw-fontBold">{formatDateTime(flights?.arrivalAirport?.arrivalTime)?.time}</div>
                                                                            <div className="hw-dtr--dtext hw-blue hw-text14 hw-fontBold">{flights?.arrivalAirport?.airportCode}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className=" d-flex align-items-center ">
                                                                        <span className="hw-fontBold hw-blue hw-dtr--dtext overflow-ellipsis">{formatePriceFn(agentActiveCurrency, formatPrice(flights?.priceId?.totalPrice, false, true), displayPrice)}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                            <div className="col-fix-right d-flex flex-shrink--null hw-gapy16 align-items-center">
                                                <div className=" d-flex align-items-center">
                                                    <span className="hw-fontBold hw-dtr--dtext hw-blue hw-text18">{formatePriceFn(agentActiveCurrency, formatPrice(
                                                        selectedMultiflights?.reduce((acc, flights) => {
                                                            const price = Number(flights?.priceId?.totalPrice ?? 0);
                                                            return acc + (isNaN(price) ? 0 : price);
                                                        }, 0),
                                                        false, true
                                                    ), displayPrice)}</span>
                                                </div>

                                                {blockBook && (
                                                    <>
                                                        <div
                                                            data-tooltip-id="flight-overlap-tooltip"
                                                            data-tooltip-content="Flights must have at least 90 minutes between them. Please choose another flight."
                                                            style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                color: '#efa544',
                                                            }}
                                                        >
                                                            <InfoIcon />
                                                        </div>

                                                        {/* The actual tooltip worker component */}
                                                        <Tooltip
                                                            id="flight-overlap-tooltip"
                                                            place="top"      /* Options: top, bottom, left, right */
                                                            variant="dark"   /* Options: dark, light, success, warning, error, info */
                                                            style={{ maxWidth: '250px', textAlign: 'center', borderRadius: '6px' }}
                                                        />
                                                    </>
                                                )}

                                                <button
                                                    disabled={blockBook}
                                                    onClick={() => {
                                                        if (blockBook) return;
                                                        if (selectedMultiflights?.every(item => item?.priceId !== undefined)) {
                                                            multiFlightBookingFn()
                                                        } else {
                                                            const firstItemWithoutPriceIdIndex = selectedMultiflights.findIndex(item => !item?.priceId || item?.priceId === undefined);
                                                            if (firstItemWithoutPriceIdIndex !== -1) {
                                                                const updatedSelectedMultiflights = selectedMultiflights.map((item, index) => ({
                                                                    ...item,
                                                                    active: index === firstItemWithoutPriceIdIndex
                                                                }));
                                                                const updatedMultiFlightOptionsData = multiFlightOptionsData.map((item, index) => ({
                                                                    ...item,
                                                                    active: index === firstItemWithoutPriceIdIndex
                                                                }));
                                                                setSelectedMultiflights(updatedSelectedMultiflights);
                                                                setMultiFlightOptionsData(updatedMultiFlightOptionsData);
                                                            }
                                                        }
                                                    }}
                                                    className={`hw-btn hw-btn--primary hw-btn--mdSize hw-btn--mn140 ${blockBook ? 'hw-btn--disabled' : ''}`}
                                                >
                                                    {selectedMultiflights?.every(item => item?.priceId !== undefined) ? 'Book' : 'Select Another Flight'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })()
                        : null
                    }
                </>}


            {/* End flight filter */}
            {!mainLoading && isShowMarkupOption && originalFlightData?.length > 0 ? (
                <div
                    ref={actionMenuRef}
                    style={{
                        position: "fixed",
                        right: isMobileView ? "50%" : "20px",
                        bottom: isMobileView ? "0" : "auto",
                        top: isMobileView ? "auto" : (isActionMenuCentered ? "72%" : "72%"),
                        transform: isMobileView ? "translateX(50%)" : "translateY(-50%)",
                        transition: "all 0.25s ease",
                        zIndex: 999998,
                        gap: "0.75rem",
                        display: "flex",
                        flexDirection: isMobileView ? "row" : "column",
                        alignItems: "center",
                        background: isMobileView ? "rgba(255,255,255,0.95)" : "transparent",
                        padding: isMobileView ? "8px" : 0,
                        borderRadius: isMobileView ? "999px" : 0,
                        boxShadow: isMobileView ? "0 6px 20px rgba(0,0,0,0.15)" : "none",
                        visibility: isFooterVisible ? "hidden" : "visible",
                        opacity: isFooterVisible ? 0 : 1,
                        pointerEvents: (isFooterVisible || isFlightBookModalOpen) ? "none" : "auto"
                    }}
                    className="hw-gapy10 hw--listing-buttons-container"
                    onPointerDown={hideActionTooltips}
                >
                    <div
                        className="hw-action-tooltipWrap"
                        onMouseEnter={() => showActionTooltip('markup')}
                        onMouseLeave={hideActionTooltips}
                        onFocus={(e) => {
                            if (e.target.matches(':focus-visible')) {
                                showActionTooltip('markup', { fromFocus: true });
                            }
                        }}
                        onBlur={hideActionTooltips}
                    >
                        <button
                            onClick={() => {
                                hideActionTooltips();
                                setShowMarkupPopup(true);
                            }}
                            className="hw-btn hw-btn--smSize"
                            style={{
                                background: (isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                borderColor: (isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                color: "#fff",
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                padding: "0",
                                opacity: (isFlightBookModalOpen) ? 0.65 : 1,
                                cursor: isFlightBookModalOpen ? "not-allowed" : "pointer"
                            }}
                            disabled={isFlightBookModalOpen}
                            aria-label="Open markup popup"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_10623_75448)">
                                    <path d="M9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.25 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H19C19.5304 6 20.0391 6.21071 20.4142 6.58579C20.7893 6.96086 21 7.46957 21 8V12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18 12H18.01" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6 12H6.01" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 19H22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19 16V22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_10623_75448">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                        </button>
                        <span className={`hw-action-tooltipText${activeActionTooltip === 'markup' ? ' is-visible' : ''}`}>Add markup amount (AED)</span>
                    </div>
                    {!isPrintSelectionMode ? (
                        <div
                            className="hw-action-tooltipWrap"
                            onMouseEnter={() => showActionTooltip('print')}
                            onMouseLeave={hideActionTooltips}
                            onFocus={(e) => {
                                if (e.target.matches(':focus-visible')) {
                                    showActionTooltip('print', { fromFocus: true });
                                }
                            }}
                            onBlur={hideActionTooltips}
                        >
                            <button
                                onClick={startPrintSelectionModeFn}
                                className="hw-btn hw-btn--smSize"
                                disabled={isEmailSelectionMode || isFlightBookModalOpen}
                                style={{
                                    background: (isEmailSelectionMode || isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                    borderColor: (isEmailSelectionMode || isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                    color: "#fff",
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    padding: "0",
                                    opacity: (isEmailSelectionMode || isFlightBookModalOpen) ? 0.65 : 1,
                                    cursor: (isEmailSelectionMode || isFlightBookModalOpen) ? "not-allowed" : "pointer"
                                }}
                                aria-label="Select flights for print"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_10623_13529)">
                                        <path d="M17 17H19C19.5304 17 20.0391 16.7893 20.4142 16.4142C20.7893 16.0391 21 15.5304 21 15V11C21 10.4696 20.7893 9.96086 20.4142 9.58579C20.0391 9.21071 19.5304 9 19 9H5C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M17 9V5C17 4.46957 16.7893 3.96086 16.4142 3.58579C16.0391 3.21071 15.5304 3 15 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7 15C7 14.4696 7.21071 13.9609 7.58579 13.5858C7.96086 13.2107 8.46957 13 9 13H15C15.5304 13 16.0391 13.2107 16.4142 13.5858C16.7893 13.9609 17 14.4696 17 15V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H9C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19V15Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_10623_13529">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </button>
                            <span className={`hw-action-tooltipText${activeActionTooltip === 'print' ? ' is-visible' : ''}`}>Print flight details</span>
                        </div>
                    ) : (
                        <>
                            <button
                                onClick={confirmPrintSelectionFn}
                                className="hw-btn hw-btn--smSize"
                                style={{
                                    background: selectedPrintIndexes.length ? "#0d6efd" : "#7fb0ff",
                                    borderColor: selectedPrintIndexes.length ? "#0d6efd" : "#7fb0ff",
                                    color: "#fff",
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    padding: "0",
                                    opacity: selectedPrintIndexes.length ? 1 : 0.8,
                                    cursor: selectedPrintIndexes.length ? "pointer" : "not-allowed"
                                }}
                                aria-label="Print selected flights"
                                disabled={!selectedPrintIndexes.length}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M7 9V4h10v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    <rect x="5" y="9" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.8" />
                                    <path d="M8 14h8v6H8v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                                    <path d="m9.5 12 1.8 1.8L15 10.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button
                                onClick={cancelPrintSelectionModeFn}
                                className="hw-btn hw-btn--smSize"
                                style={{ background: "#0d6efd", borderColor: "#0d6efd", color: "#fff", width: "42px", height: "42px", borderRadius: "50%", padding: "0" }}
                                aria-label="Cancel print selection mode"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="m7 7 10 10M17 7 7 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                                </svg>
                            </button>
                        </>
                    )}
                    {!isEmailSelectionMode ? (
                        <div
                            className="hw-action-tooltipWrap"
                            onMouseEnter={() => showActionTooltip('email')}
                            onMouseLeave={hideActionTooltips}
                            onFocus={(e) => {
                                if (e.target.matches(':focus-visible')) {
                                    showActionTooltip('email', { fromFocus: true });
                                }
                            }}
                            onBlur={hideActionTooltips}
                        >
                            <button
                                onClick={startEmailSelectionModeFn}
                                className="hw-btn hw-btn--smSize"
                                disabled={isPrintSelectionMode || isFlightBookModalOpen}
                                style={{
                                    background: (isPrintSelectionMode || isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                    borderColor: (isPrintSelectionMode || isFlightBookModalOpen) ? "#9ec5fe" : "#0d6efd",
                                    color: "#fff",
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    padding: "0",
                                    opacity: (isPrintSelectionMode || isFlightBookModalOpen) ? 0.65 : 1,
                                    cursor: (isPrintSelectionMode || isFlightBookModalOpen) ? "not-allowed" : "pointer"
                                }}
                                aria-label="Select flights for email"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_10623_49979)">
                                        <path d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3 7L12 13L21 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_10623_49979">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                            <span className={`hw-action-tooltipText${activeActionTooltip === 'email' ? ' is-visible' : ''}`}>Send flight details via email</span>
                        </div>
                    ) : (
                        <>
                            <button
                                onClick={openEmailPopupFn}
                                className="hw-btn hw-btn--smSize"
                                style={{
                                    background: selectedEmailIndexes.length ? "#0d6efd" : "#7fb0ff",
                                    borderColor: selectedEmailIndexes.length ? "#0d6efd" : "#7fb0ff",
                                    color: "#fff",
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    padding: "0",
                                    opacity: selectedEmailIndexes.length ? 1 : 0.8,
                                    cursor: selectedEmailIndexes.length ? "pointer" : "not-allowed"
                                }}
                                aria-label="Open email popup for selected flights"
                                disabled={!selectedEmailIndexes.length}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <rect x="3.5" y="5.5" width="17" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" />
                                    <path d="m5 8 7 5 7-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="m9.5 12 1.8 1.8L15 10.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button
                                onClick={cancelEmailSelectionModeFn}
                                className="hw-btn hw-btn--smSize"
                                style={{ background: "#0d6efd", borderColor: "#0d6efd", color: "#fff", width: "42px", height: "42px", borderRadius: "50%", padding: "0" }}
                                aria-label="Cancel email selection mode"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="m7 7 10 10M17 7 7 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                                </svg>
                            </button>
                        </>
                    )}
                </div>
            ) : null}
            <CommonPopup
                show={showMarkupPopup}
                setShow={setShowMarkupPopup}
                title={<span className="d-flex align-items-center hw-gapy8"><MarkUpIcon /> Add Markup Amount (AED)</span>}
                modalClass="hw-modal--medium hw-modal--markupAmount"
            >
                <div className="d-flex d-flex-column hw-gapy16">
                    <div
                        style={{
                            background: "#f4f8ff",
                            borderRadius: "8px",
                            padding: "12px 10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <span className="hw-text15 hw-fontWeight--500 hw-black900">Total markup added</span>
                        <span className="hw-text16 hw-fontWeight--700 hw-black900">
                            {formatePriceFn("AED", totalMarkupAmount, displayPrice)}
                        </span>
                    </div>
                    <div style={{ marginTop: "2rem" }}>
                        <div className="hw-text16 hw-fontWeight--500 hw-black900" style={{ marginBottom: "8px" }}>
                            Amount
                        </div>
                        <input
                            type="number"
                            min="0"
                            step="1"
                            value={markupInputAmount}
                            onChange={(event) => {
                                const nextValue = event.target.value;
                                if (!/^\d*$/.test(nextValue)) {
                                    setMarkupError('Decimal values are not allowed. Please enter a whole number.');
                                    return;
                                }
                                setMarkupInputAmount(nextValue);
                                if (markupError) {
                                    setMarkupError('');
                                }
                            }}
                            placeholder={"Add amount in AED"}
                            className="hw-form--input markup-price"
                        />
                    </div>
                    {markupError ? (
                        <div className="hw-text14" style={{ color: "#dc3545" }}>
                            {markupError}
                        </div>
                    ) : null}
                    <div className="d-flex hw-gapy12" style={{ marginTop: "2rem", flexWrap: "nowrap", gap: "3rem" }}>
                        <button
                            onClick={clearMarkupAmountFn}
                            className="hw-btn hw-btn--primaryOutline hw-btn--mdSize"
                            style={{ flex: 1 }}
                        >
                            Clear
                        </button>
                        <button
                            onClick={addMarkupAmountFn}
                            className="hw-btn hw-btn--primary hw-btn--mdSize"
                            style={{ flex: 1 }}
                        >
                            Add Amount
                        </button>
                    </div>
                </div>
            </CommonPopup>
            <CommonPopup
                show={showEmailPopup}
                setShow={setShowEmailPopup}
                title={<span className="d-flex align-items-center hw-gapy8"><EmailPopupIcon /> Send Selected Flights</span>}
                modalClass="hw-modal--medium hw-modal--sendEmail"
            >
                <div className="d-flex d-flex-column hw-gapy16">
                    <div
                        style={{
                            background: "#f4f8ff",
                            borderRadius: "8px",
                            padding: "12px 10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <span className="hw-text15 hw-fontWeight--500 hw-black900">Selected Options</span>
                        <span className="hw-text16 hw-fontWeight--700 hw-black900">{selectedEmailIndexes.length}</span>
                    </div>
                    <div style={{ marginTop: "2rem" }}>
                        <div className="hw-text16 hw-fontWeight--500 hw-black900" style={{ marginBottom: "8px" }}>
                            Enter email
                        </div>
                        <input
                            type="email"
                            value={emailAddress}
                            onChange={(event) => {
                                setEmailAddress(event.target.value);
                                if (emailError) {
                                    setEmailError('');
                                    setEmailMessageType('error');
                                }
                            }}
                            placeholder="johndoe@email.com"
                            className="hw-form--input"
                        />
                    </div>
                    {emailError ? (
                        <div className="hw-text14" style={{ color: emailMessageType === 'success' ? "#16a34a" : "#dc3545" }}>
                            {emailError}
                        </div>
                    ) : null}
                    <div className="d-flex hw-gapy12" style={{ marginTop: "2rem", flexWrap: "nowrap", gap: "3rem" }}>
                        <button
                            onClick={() => {
                                setShowEmailPopup(false);
                                setEmailAddress('');
                                setEmailError('');
                                setEmailMessageType('error');
                            }}
                            className="hw-btn hw-btn--primaryOutline hw-btn--mdSize"
                            style={{ flex: 1 }}
                        >
                            Close
                        </button>
                        <button
                            onClick={sendSelectedFlightsEmailFn}
                            className="hw-btn hw-btn--primary hw-btn--mdSize"
                            disabled={emailSending}
                            style={{ flex: 1 }}
                        >
                            {emailSending ? 'Sending...' : 'Send Email'}
                        </button>
                    </div>
                </div>
            </CommonPopup>
            <style>
                {`
                    .hw-print-flight-quote-header {
                        display: none;
                    }
                    @media print {
                        @page {
                            margin: 5mm;
                        }
                        html,
                        body,
                        #root,
                        .hw-app--main {
                            margin: 0 !important;
                            padding: 0 !important;
                            height: auto !important;
                            min-height: 0 !important;
                            overflow: visible !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        header,
                        .hw-header,
                        .hw-widget--flight,
                        .hw-top--fixImg,
                        .hw--listing-buttons-container,
                        footer,
                        .hw--vendor-img,
                        .hw-footer {
                            display: none !important;
                        }
                        .hw-app--main {
                            background-color: #ffffff !important;
                        }
                        .hw-page--width {
                            width: 100% !important;
                            max-width: 100% !important;
                            margin: 0 !important;
                            padding: 0 !important;
                            background: transparent !important;
                            box-sizing: border-box !important;
                        }
                        .hw-search--flightList > :not(.hw-search--flightFilterResult) {
                            display: none !important;
                        }
                        .hw-search--flightFilterResult > :not(.hw-search--flightFilterResult__body) {
                            display: none !important;
                        }
                        /*
                         * FIX: Blank first page on tablet (WebKit/Safari print bug).
                         *
                         * When a flex container (display:flex; flex-direction:column) holds
                         * multiple children with break-inside:avoid and the combined height
                         * exceeds one print page, WebKit treats the ENTIRE flex container as a
                         * single unbreakable unit → whole list is pushed to page 2 → page 1 blank.
                         * Happens at 4-5 cards because that is when total height first exceeds
                         * the print-page height on a tablet.
                         *
                         * Fix: switch containers to display:block so WebKit handles
                         * break-inside:avoid per-card correctly (block children can break between
                         * each other while each card itself stays unbroken).  Spacing is achieved
                         * with margin-bottom instead of row-gap.
                         */
                        .hw-search--flightList {
                            height: auto !important;
                            overflow: visible !important;
                            display: block !important;
                        }
                        .hw-search--flightFilterResult {
                            padding: 0 !important;
                            overflow: visible !important;
                            width: 100% !important;
                        }
                        .hw-search--flightFilterResult__body {
                            display: block !important;
                            overflow: visible !important;
                        }
                        .hw-search--flightFilterResult__list {
                            display: block !important;
                            overflow: visible !important;
                            /* reset <ul> browser defaults */
                            margin: 0 !important;
                            padding: 0 !important;
                            list-style: none !important;
                        }
                        .hw-search--flightFilterResult__listItem[data-print-selected="true"] {
                            /*
                             * CROSS-BROWSER CARD-SPLIT FIX
                             * Tested targets: Chrome desktop/tablet, Firefox desktop,
                             *                 Safari iOS/iPadOS, Chrome Android/iOS.
                             *
                             * 1. break-inside + page-break-inside
                             *    Standard (W3C) + legacy property.  Works in Chrome & Firefox.
                             *
                             * 2. -webkit-column-break-inside: avoid
                             *    Required by older Safari / WebKit.  Without this, Safari
                             *    completely ignores the fragmentation hint.
                             *
                             * 3. display: block
                             *    Safari's print engine does NOT honour break-inside on
                             *    flex items (display:flex is set on the <li> by screen CSS
                             *    at ≥750 px).  Switching to block makes it a standard
                             *    fragmentation participant.  The card's internal layout
                             *    is unaffected because the inner .hw-flight--listBox has
                             *    display:flex set explicitly in the print CSS below.
                             *
                             * 4. position: static
                             *    Screen CSS gives the <li> position:relative.  Some WebKit
                             *    versions skip break-inside for positioned elements.
                             *    Static removes that stacking-context side-effect.
                             *    (The NDC badge no longer needs position:relative on the
                             *    card — it was already reset to position:static above.)
                             *
                             * 5. -webkit-print-color-adjust + print-color-adjust
                             *    Needed on each card so box-shadow renders in WebKit print
                             *    without creating a compositing layer that can interfere
                             *    with the fragmentation boundary.
                             */
                            break-inside: avoid !important;
                            page-break-inside: avoid !important;
                            -webkit-column-break-inside: avoid !important;
                            display: block !important;
                            position: static !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            /* spacing — margin-bottom instead of row-gap because
                               row-gap only works inside flex/grid containers        */
                            margin-bottom: 1.2rem !important;
                            box-shadow: 0px 0px 10px 0px rgba(var(--hw-black-rgb), 0.2) !important;
                        }
                        ${!isMobileView ? `
                        .hw-search--flightFilterResult__listItem {
                            padding: 1.5rem !important;
                            border-radius: 0.5rem !important;
                            background-color: var(--hw-white) !important;
                        }
                        /*
                         * NDC Fare badge fix for Safari/WebKit print.
                         *
                         * On screen the badge uses position:absolute (top:5px left:5px) and the
                         * card reserves padding-top:2.5rem as a "slot" for it.  In print the card
                         * gets padding:1.5rem !important (above), which is too small — the badge
                         * overflows into card content.  Chrome clips it gracefully; Safari renders
                         * the overlap visibly.
                         *
                         * Fix: switch the badge to position:static so it flows as the first
                         * block-level element inside the card, above the flight details row.
                         * flex-basis:100% forces it onto its own flex row; the explicit
                         * padding-top:2.5rem that was there only for the absolute slot is no longer
                         * needed, so the card keeps its uniform 1.5rem padding.
                         */
                        .hw-search--flightFilterResult__listNew > .hw-search--flightFilterResult__listItem > .mb-2 {
                            position: static !important;
                            flex-basis: 100% !important;
                            width: 100% !important;
                            margin-bottom: 4px !important;
                        }
                        .hw-search--flightFilterResult__listNew > .hw-search--flightFilterResult__listItem > .mb-2 .hw-ndc-fare {
                            position: static !important;
                            display: inline-block !important;
                        }
                        .hw-flight--listBox {
                            display: flex !important;
                            justify-content: space-between !important;
                            column-gap: 2rem !important;
                            flex-wrap: nowrap !important;
                            row-gap: 0 !important;
                        }
                        .hw-flight--listBox .destination {
                            display: flex !important;
                            align-items: center !important;
                            justify-content: space-between !important;
                            gap: 1.6rem !important;
                            flex: 1 0 0 !important;
                            width: auto !important;
                            max-width: 62.6rem !important;
                        }
                        .hw-flight--listBox .destination .destination-from,
                        .hw-flight--listBox .destination .destination-to {
                            width: 9rem !important;
                            min-width: 9rem !important;
                        }
                        .hw-flight--listBox__flight {
                            min-width: 20rem !important;
                            text-align: center !important;
                        }
                        .hw-flight--listBox__flight > span {
                            white-space: nowrap !important;
                        }
                        .hw-flight--line {
                            min-width: 16rem !important;
                        }
                        .hw-flight--listBoxAction {
                            display: flex !important;
                            flex-direction: column !important;
                            justify-content: flex-start !important;
                            align-items: center !important;
                            width: auto !important;
                        }
                        .hw-flight--listBoxAction .hw-text24,
                        .hw-flight--listBoxAction .hw-xstext20,
                        .hw-flight--listBoxAction .hw-text24 > span,
                        .hw-flight--listBoxAction .hw-xstext20 > span {
                            white-space: nowrap !important;
                            display: inline-flex !important;
                            align-items: baseline !important;
                            column-gap: 0.25em !important;
                        }
                        .hw-search--innerflight__listItem {
                            display: flex !important;
                            flex-direction: row !important;
                            align-items: center !important;
                            column-gap: 2rem !important;
                            row-gap: 0 !important;
                        }
                        ` : ``}
                        .hw-search--flightListBottomFooter {
                            display: none !important;
                        }
                        .hw--flight-auto-scroll-div,
                        .hw-expire--session__bookingConfirmed {
                            display: none !important;
                        }
                        .hw-print-flight-quote-header {
                            display: block !important;
                            width: 100% !important;
                            margin: 0 0 14px !important;
                            padding: 0 !important;
                            box-sizing: border-box !important;
                            page-break-after: auto !important;
                            break-after: auto !important;
                            color: #141826 !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        .hw-print-flight-quote-header__body {
                            display: flex !important;
                            flex-direction: row !important;
                            justify-content: space-between !important;
                            align-items: center !important;
                            gap: 20px !important;
                            padding: 12px 0 10px 0 !important;
                            border-bottom: 1px solid #e4e6ed !important;
                            box-sizing: border-box !important;
                        }
                        .hw-print-flight-quote-header__brand {
                            display: flex !important;
                            flex-direction: row !important;
                            align-items: center !important;
                            gap: 12px !important;
                            flex: 1 !important;
                            min-width: 0 !important;
                            text-align: left !important;
                        }
                        .hw-print-flight-quote-header__logoCell {
                            flex-shrink: 0 !important;
                        }
                        .hw-print-flight-quote-header__logo {
                            display: block !important;
                            width: 56px !important;
                            height: 56px !important;
                            object-fit: contain !important;
                            border-radius: 4px !important;
                        }
                        .hw-print-flight-quote-header__brandText {
                            min-width: 0 !important;
                            display: flex !important;
                            align-items: center !important;
                        }
                        .hw-print-flight-quote-header__companyName {
                            font-size: 18px !important;
                            font-weight: 700 !important;
                            line-height: 1.2 !important;
                            text-transform: uppercase !important;
                            letter-spacing: 0.03em !important;
                            color: #0f1117 !important;
                        }
                        .hw-print-flight-quote-header__meta {
                            text-align: right !important;
                            flex-shrink: 0 !important;
                            font-size: 12px !important;
                            line-height: 1.55 !important;
                            color: #0f1117 !important;
                        }
                        .hw-print-flight-quote-header__metaLine {
                            font-weight: 600 !important;
                        }
                        .hw-print-flight-quote-header__metaLabel {
                            font-weight: 700 !important;
                            color: #0f1117 !important;
                        }
                        .hw-print-selection-box {
                            display: none !important;
                        }
                        .hw-search--flightFilterResult__listItem[data-print-selected="false"] {
                            display: none !important;
                        }
                    }
                `}
            </style>
        </>
    );
};


export default ListFlightPage;